
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredb49"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredb49"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jybxg", function(module, exports) {

$parcel$export(module.exports, "focus", () => src_default);
$parcel$export(module.exports, "default", () => module_default);
// node_modules/tabbable/dist/index.esm.js
var candidateSelectors = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]:not(slot)",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])',
    "details>summary:first-of-type",
    "details"
];
var candidateSelector = /* @__PURE__ */ candidateSelectors.join(",");
var NoElement = typeof Element === "undefined";
var matches = NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function(element) {
    return element.getRootNode();
} : function(element) {
    return element.ownerDocument;
};
var getCandidates = function getCandidates2(el, includeContainer, filter) {
    var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
    if (includeContainer && matches.call(el, candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
var getCandidatesIteratively = function getCandidatesIteratively2(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if (element.tagName === "SLOT") {
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively2(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scope: element,
                candidates: nestedCandidates
            });
        } else {
            var validCandidate = matches.call(element, candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            var validShadowRoot = !options.shadowRootFilter || options.shadowRootFilter(element);
            if (shadowRoot && validShadowRoot) {
                var _nestedCandidates = getCandidatesIteratively2(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scope: element,
                    candidates: _nestedCandidates
                });
            } else elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
var getTabindex = function getTabindex2(node, isScope) {
    if (node.tabIndex < 0) {
        if ((isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || node.isContentEditable) && isNaN(parseInt(node.getAttribute("tabindex"), 10))) return 0;
    }
    return node.tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables2(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput2(node) {
    return node.tagName === "INPUT";
};
var isHiddenInput = function isHiddenInput2(node) {
    return isInput(node) && node.type === "hidden";
};
var isDetailsWithSummary = function isDetailsWithSummary2(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var getCheckedRadio = function getCheckedRadio2(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var isTabbableRadio = function isTabbableRadio2(node) {
    if (!node.name) return true;
    var radioScope = node.form || getRootNode(node);
    var queryRadios = function queryRadios2(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var isRadio = function isRadio2(node) {
    return isInput(node) && node.type === "radio";
};
var isNonTabbableRadio = function isNonTabbableRadio2(node) {
    return isRadio(node) && !isTabbableRadio(node);
};
var isZeroArea = function isZeroArea2(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var isHidden = function isHidden2(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if (matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
    var nodeRootHost = getRootNode(node).host;
    var nodeIsAttached = (nodeRootHost === null || nodeRootHost === void 0 ? void 0 : nodeRootHost.ownerDocument.contains(nodeRootHost)) || node.ownerDocument.contains(node);
    if (!displayCheck || displayCheck === "full") {
        if (typeof getShadowRoot === "function") {
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true) return isZeroArea(node);
                else if (node.assignedSlot) node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) node = rootNode.host;
                else node = parentElement;
            }
            node = originalNode;
        }
        if (nodeIsAttached) return !node.getClientRects().length;
    } else if (displayCheck === "non-zero-area") return isZeroArea(node);
    return false;
};
var isDisabledFromFieldset = function isDisabledFromFieldset2(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    if (child.tagName === "LEGEND") return matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                }
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable2(options, node) {
    if (node.disabled || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    isDetailsWithSummary(node) || isDisabledFromFieldset(node)) return false;
    return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable2(options, node) {
    if (isNonTabbableRadio(node) || getTabindex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable2(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    return false;
};
var sortByOrder = function sortByOrder2(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scope;
        var element = isScope ? item.scope : item;
        var candidateTabindex = getTabindex(element, isScope);
        var elements = isScope ? sortByOrder2(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort(sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var tabbable = function tabbable2(el, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = getCandidatesIteratively([
        el
    ], options.includeContainer, {
        filter: isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: isValidShadowRootTabbable
    });
    else candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
    return sortByOrder(candidates);
};
var focusable = function focusable2(el, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = getCandidatesIteratively([
        el
    ], options.includeContainer, {
        filter: isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var isTabbable = function isTabbable2(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if (matches.call(node, candidateSelector) === false) return false;
    return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* @__PURE__ */ candidateSelectors.concat("iframe").join(",");
var isFocusable = function isFocusable2(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if (matches.call(node, focusableCandidateSelector) === false) return false;
    return isNodeMatchingSelectorFocusable(options, node);
};
// node_modules/focus-trap/dist/focus-trap.esm.js
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var activeFocusTraps = function() {
    var trapQueue = [];
    return {
        activateTrap: function activateTrap(trap) {
            if (trapQueue.length > 0) {
                var activeTrap = trapQueue[trapQueue.length - 1];
                if (activeTrap !== trap) activeTrap.pause();
            }
            var trapIndex = trapQueue.indexOf(trap);
            if (trapIndex === -1) trapQueue.push(trap);
            else {
                trapQueue.splice(trapIndex, 1);
                trapQueue.push(trap);
            }
        },
        deactivateTrap: function deactivateTrap(trap) {
            var trapIndex = trapQueue.indexOf(trap);
            if (trapIndex !== -1) trapQueue.splice(trapIndex, 1);
            if (trapQueue.length > 0) trapQueue[trapQueue.length - 1].unpause();
        }
    };
}();
var isSelectableInput = function isSelectableInput2(node) {
    return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
};
var isEscapeEvent = function isEscapeEvent2(e) {
    return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
};
var isTabEvent = function isTabEvent2(e) {
    return e.key === "Tab" || e.keyCode === 9;
};
var delay = function delay2(fn) {
    return setTimeout(fn, 0);
};
var findIndex = function findIndex2(arr, fn) {
    var idx = -1;
    arr.every(function(value, i) {
        if (fn(value)) {
            idx = i;
            return false;
        }
        return true;
    });
    return idx;
};
var valueOrHandler = function valueOrHandler2(value) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
    return typeof value === "function" ? value.apply(void 0, params) : value;
};
var getActualTarget = function getActualTarget2(event) {
    return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
};
var createFocusTrap = function createFocusTrap2(elements, userOptions) {
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
    var config = _objectSpread2({
        returnFocusOnDeactivate: true,
        escapeDeactivates: true,
        delayInitialFocus: true
    }, userOptions);
    var state = {
        // containers given to createFocusTrap()
        // @type {Array<HTMLElement>}
        containers: [],
        // list of objects identifying tabbable nodes in `containers` in the trap
        // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
        //  is active, but the trap should never get to a state where there isn't at least one group
        //  with at least one tabbable node in it (that would lead to an error condition that would
        //  result in an error being thrown)
        // @type {Array<{
        //   container: HTMLElement,
        //   tabbableNodes: Array<HTMLElement>, // empty if none
        //   focusableNodes: Array<HTMLElement>, // empty if none
        //   firstTabbableNode: HTMLElement|null,
        //   lastTabbableNode: HTMLElement|null,
        //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
        // }>}
        containerGroups: [],
        // same order/length as `containers` list
        // references to objects in `containerGroups`, but only those that actually have
        //  tabbable nodes in them
        // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
        //  the same length
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: false,
        paused: false,
        // timer ID for when delayInitialFocus is true and initial focus in this trap
        //  has been delayed during activation
        delayInitialFocusTimer: void 0
    };
    var trap;
    var getOption = function getOption2(configOverrideOptions, optionName, configOptionName) {
        return configOverrideOptions && configOverrideOptions[optionName] !== void 0 ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    var findContainerIndex = function findContainerIndex2(element) {
        return state.containerGroups.findIndex(function(_ref) {
            var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
            return container.contains(element) || // fall back to explicit tabbable search which will take into consideration any
            //  web components if the `tabbableOptions.getShadowRoot` option was used for
            //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
            //  look inside web components even if open)
            tabbableNodes.find(function(node) {
                return node === element;
            });
        });
    };
    var getNodeForOption = function getNodeForOption2(optionName) {
        var optionValue = config[optionName];
        if (typeof optionValue === "function") {
            for(var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)params[_key2 - 1] = arguments[_key2];
            optionValue = optionValue.apply(void 0, params);
        }
        if (optionValue === true) optionValue = void 0;
        if (!optionValue) {
            if (optionValue === void 0 || optionValue === false) return optionValue;
            throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
        }
        var node = optionValue;
        if (typeof optionValue === "string") {
            node = doc.querySelector(optionValue);
            if (!node) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
        }
        return node;
    };
    var getInitialFocusNode = function getInitialFocusNode2() {
        var node = getNodeForOption("initialFocus");
        if (node === false) return false;
        if (node === void 0) {
            if (findContainerIndex(doc.activeElement) >= 0) node = doc.activeElement;
            else {
                var firstTabbableGroup = state.tabbableGroups[0];
                var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
                node = firstTabbableNode || getNodeForOption("fallbackFocus");
            }
        }
        if (!node) throw new Error("Your focus-trap needs to have at least one focusable element");
        return node;
    };
    var updateTabbableNodes = function updateTabbableNodes2() {
        state.containerGroups = state.containers.map(function(container) {
            var tabbableNodes = tabbable(container, config.tabbableOptions);
            var focusableNodes = focusable(container, config.tabbableOptions);
            return {
                container: container,
                tabbableNodes: tabbableNodes,
                focusableNodes: focusableNodes,
                firstTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[0] : null,
                lastTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : null,
                /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */ nextTabbableNode: function nextTabbableNode(node) {
                    var forward = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                    var nodeIdx = focusableNodes.findIndex(function(n) {
                        return n === node;
                    });
                    if (nodeIdx < 0) return void 0;
                    if (forward) return focusableNodes.slice(nodeIdx + 1).find(function(n) {
                        return isTabbable(n, config.tabbableOptions);
                    });
                    return focusableNodes.slice(0, nodeIdx).reverse().find(function(n) {
                        return isTabbable(n, config.tabbableOptions);
                    });
                }
            };
        });
        state.tabbableGroups = state.containerGroups.filter(function(group) {
            return group.tabbableNodes.length > 0;
        });
        if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus")) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    };
    var tryFocus = function tryFocus2(node) {
        if (node === false) return;
        if (node === doc.activeElement) return;
        if (!node || !node.focus) {
            tryFocus2(getInitialFocusNode());
            return;
        }
        node.focus({
            preventScroll: !!config.preventScroll
        });
        state.mostRecentlyFocusedNode = node;
        if (isSelectableInput(node)) node.select();
    };
    var getReturnFocusNode = function getReturnFocusNode2(previousActiveElement) {
        var node = getNodeForOption("setReturnFocus", previousActiveElement);
        return node ? node : node === false ? false : previousActiveElement;
    };
    var checkPointerDown = function checkPointerDown2(e) {
        var target = getActualTarget(e);
        if (findContainerIndex(target) >= 0) return;
        if (valueOrHandler(config.clickOutsideDeactivates, e)) {
            trap.deactivate({
                // if, on deactivation, we should return focus to the node originally-focused
                //  when the trap was activated (or the configured `setReturnFocus` node),
                //  then assume it's also OK to return focus to the outside node that was
                //  just clicked, causing deactivation, as long as that node is focusable;
                //  if it isn't focusable, then return focus to the original node focused
                //  on activation (or the configured `setReturnFocus` node)
                // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
                //  which will result in the outside click setting focus to the node
                //  that was clicked, whether it's focusable or not; by setting
                //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
                //  on activation (or the configured `setReturnFocus` node)
                returnFocus: config.returnFocusOnDeactivate && !isFocusable(target, config.tabbableOptions)
            });
            return;
        }
        if (valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
    };
    var checkFocusIn = function checkFocusIn2(e) {
        var target = getActualTarget(e);
        var targetContained = findContainerIndex(target) >= 0;
        if (targetContained || target instanceof Document) {
            if (targetContained) state.mostRecentlyFocusedNode = target;
        } else {
            e.stopImmediatePropagation();
            tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
        }
    };
    var checkTab = function checkTab2(e) {
        var target = getActualTarget(e);
        updateTabbableNodes();
        var destinationNode = null;
        if (state.tabbableGroups.length > 0) {
            var containerIndex = findContainerIndex(target);
            var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : void 0;
            if (containerIndex < 0) {
                if (e.shiftKey) destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
                else destinationNode = state.tabbableGroups[0].firstTabbableNode;
            } else if (e.shiftKey) {
                var startOfGroupIndex = findIndex(state.tabbableGroups, function(_ref2) {
                    var firstTabbableNode = _ref2.firstTabbableNode;
                    return target === firstTabbableNode;
                });
                if (startOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) startOfGroupIndex = containerIndex;
                if (startOfGroupIndex >= 0) {
                    var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                    var destinationGroup = state.tabbableGroups[destinationGroupIndex];
                    destinationNode = destinationGroup.lastTabbableNode;
                }
            } else {
                var lastOfGroupIndex = findIndex(state.tabbableGroups, function(_ref3) {
                    var lastTabbableNode = _ref3.lastTabbableNode;
                    return target === lastTabbableNode;
                });
                if (lastOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) lastOfGroupIndex = containerIndex;
                if (lastOfGroupIndex >= 0) {
                    var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                    var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
                    destinationNode = _destinationGroup.firstTabbableNode;
                }
            }
        } else destinationNode = getNodeForOption("fallbackFocus");
        if (destinationNode) {
            e.preventDefault();
            tryFocus(destinationNode);
        }
    };
    var checkKey = function checkKey2(e) {
        if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
            e.preventDefault();
            trap.deactivate();
            return;
        }
        if (isTabEvent(e)) {
            checkTab(e);
            return;
        }
    };
    var checkClick = function checkClick2(e) {
        var target = getActualTarget(e);
        if (findContainerIndex(target) >= 0) return;
        if (valueOrHandler(config.clickOutsideDeactivates, e)) return;
        if (valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    };
    var addListeners = function addListeners2() {
        if (!state.active) return;
        activeFocusTraps.activateTrap(trap);
        state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function() {
            tryFocus(getInitialFocusNode());
        }) : tryFocus(getInitialFocusNode());
        doc.addEventListener("focusin", checkFocusIn, true);
        doc.addEventListener("mousedown", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("touchstart", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("click", checkClick, {
            capture: true,
            passive: false
        });
        doc.addEventListener("keydown", checkKey, {
            capture: true,
            passive: false
        });
        return trap;
    };
    var removeListeners = function removeListeners2() {
        if (!state.active) return;
        doc.removeEventListener("focusin", checkFocusIn, true);
        doc.removeEventListener("mousedown", checkPointerDown, true);
        doc.removeEventListener("touchstart", checkPointerDown, true);
        doc.removeEventListener("click", checkClick, true);
        doc.removeEventListener("keydown", checkKey, true);
        return trap;
    };
    trap = {
        get active () {
            return state.active;
        },
        get paused () {
            return state.paused;
        },
        activate: function activate(activateOptions) {
            if (state.active) return this;
            var onActivate = getOption(activateOptions, "onActivate");
            var onPostActivate = getOption(activateOptions, "onPostActivate");
            var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
            if (!checkCanFocusTrap) updateTabbableNodes();
            state.active = true;
            state.paused = false;
            state.nodeFocusedBeforeActivation = doc.activeElement;
            if (onActivate) onActivate();
            var finishActivation = function finishActivation2() {
                if (checkCanFocusTrap) updateTabbableNodes();
                addListeners();
                if (onPostActivate) onPostActivate();
            };
            if (checkCanFocusTrap) {
                checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
                return this;
            }
            finishActivation();
            return this;
        },
        deactivate: function deactivate(deactivateOptions) {
            if (!state.active) return this;
            var options = _objectSpread2({
                onDeactivate: config.onDeactivate,
                onPostDeactivate: config.onPostDeactivate,
                checkCanReturnFocus: config.checkCanReturnFocus
            }, deactivateOptions);
            clearTimeout(state.delayInitialFocusTimer);
            state.delayInitialFocusTimer = void 0;
            removeListeners();
            state.active = false;
            state.paused = false;
            activeFocusTraps.deactivateTrap(trap);
            var onDeactivate = getOption(options, "onDeactivate");
            var onPostDeactivate = getOption(options, "onPostDeactivate");
            var checkCanReturnFocus = getOption(options, "checkCanReturnFocus");
            var returnFocus = getOption(options, "returnFocus", "returnFocusOnDeactivate");
            if (onDeactivate) onDeactivate();
            var finishDeactivation = function finishDeactivation2() {
                delay(function() {
                    if (returnFocus) tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
                    if (onPostDeactivate) onPostDeactivate();
                });
            };
            if (returnFocus && checkCanReturnFocus) {
                checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
                return this;
            }
            finishDeactivation();
            return this;
        },
        pause: function pause() {
            if (state.paused || !state.active) return this;
            state.paused = true;
            removeListeners();
            return this;
        },
        unpause: function unpause() {
            if (!state.paused || !state.active) return this;
            state.paused = false;
            updateTabbableNodes();
            addListeners();
            return this;
        },
        updateContainerElements: function updateContainerElements(containerElements) {
            var elementsAsArray = [].concat(containerElements).filter(Boolean);
            state.containers = elementsAsArray.map(function(element) {
                return typeof element === "string" ? doc.querySelector(element) : element;
            });
            if (state.active) updateTabbableNodes();
            return this;
        }
    };
    trap.updateContainerElements(elements);
    return trap;
};
// packages/focus/src/index.js
function src_default(Alpine) {
    let lastFocused;
    let currentFocused;
    window.addEventListener("focusin", ()=>{
        lastFocused = currentFocused;
        currentFocused = document.activeElement;
    });
    Alpine.magic("focus", (el)=>{
        let within = el;
        return {
            __noscroll: false,
            __wrapAround: false,
            within (el2) {
                within = el2;
                return this;
            },
            withoutScrolling () {
                this.__noscroll = true;
                return this;
            },
            noscroll () {
                this.__noscroll = true;
                return this;
            },
            withWrapAround () {
                this.__wrapAround = true;
                return this;
            },
            wrap () {
                return this.withWrapAround();
            },
            focusable (el2) {
                return isFocusable(el2);
            },
            previouslyFocused () {
                return lastFocused;
            },
            lastFocused () {
                return lastFocused;
            },
            focused () {
                return currentFocused;
            },
            focusables () {
                if (Array.isArray(within)) return within;
                return focusable(within, {
                    displayCheck: "none"
                });
            },
            all () {
                return this.focusables();
            },
            isFirst (el2) {
                let els = this.all();
                return els[0] && els[0].isSameNode(el2);
            },
            isLast (el2) {
                let els = this.all();
                return els.length && els.slice(-1)[0].isSameNode(el2);
            },
            getFirst () {
                return this.all()[0];
            },
            getLast () {
                return this.all().slice(-1)[0];
            },
            getNext () {
                let list = this.all();
                let current = document.activeElement;
                if (list.indexOf(current) === -1) return;
                if (this.__wrapAround && list.indexOf(current) === list.length - 1) return list[0];
                return list[list.indexOf(current) + 1];
            },
            getPrevious () {
                let list = this.all();
                let current = document.activeElement;
                if (list.indexOf(current) === -1) return;
                if (this.__wrapAround && list.indexOf(current) === 0) return list.slice(-1)[0];
                return list[list.indexOf(current) - 1];
            },
            first () {
                this.focus(this.getFirst());
            },
            last () {
                this.focus(this.getLast());
            },
            next () {
                this.focus(this.getNext());
            },
            previous () {
                this.focus(this.getPrevious());
            },
            prev () {
                return this.previous();
            },
            focus (el2) {
                if (!el2) return;
                setTimeout(()=>{
                    if (!el2.hasAttribute("tabindex")) el2.setAttribute("tabindex", "0");
                    el2.focus({
                        preventScroll: this.__noscroll
                    });
                });
            }
        };
    });
    Alpine.directive("trap", Alpine.skipDuringClone((el, { expression, modifiers }, { effect, evaluateLater, cleanup })=>{
        let evaluator = evaluateLater(expression);
        let oldValue = false;
        let options = {
            escapeDeactivates: false,
            allowOutsideClick: true,
            fallbackFocus: ()=>el
        };
        if (modifiers.includes("noautofocus")) options.initialFocus = false;
        else {
            let autofocusEl = el.querySelector("[autofocus]");
            if (autofocusEl) options.initialFocus = autofocusEl;
        }
        let trap = createFocusTrap(el, options);
        let undoInert = ()=>{};
        let undoDisableScrolling = ()=>{};
        const releaseFocus = ()=>{
            undoInert();
            undoInert = ()=>{};
            undoDisableScrolling();
            undoDisableScrolling = ()=>{};
            trap.deactivate({
                returnFocus: !modifiers.includes("noreturn")
            });
        };
        effect(()=>evaluator((value)=>{
                if (oldValue === value) return;
                if (value && !oldValue) {
                    if (modifiers.includes("noscroll")) undoDisableScrolling = disableScrolling();
                    if (modifiers.includes("inert")) undoInert = setInert(el);
                    setTimeout(()=>{
                        trap.activate();
                    }, 15);
                }
                if (!value && oldValue) releaseFocus();
                oldValue = !!value;
            }));
        cleanup(releaseFocus);
    }, // When cloning, we only want to add aria-hidden attributes to the
    // DOM and not try to actually trap, as trapping can mess with the
    // live DOM and isn't just isolated to the cloned DOM.
    (el, { expression, modifiers }, { evaluate })=>{
        if (modifiers.includes("inert") && evaluate(expression)) setInert(el);
    }));
}
function setInert(el) {
    let undos = [];
    crawlSiblingsUp(el, (sibling)=>{
        let cache = sibling.hasAttribute("aria-hidden");
        sibling.setAttribute("aria-hidden", "true");
        undos.push(()=>cache || sibling.removeAttribute("aria-hidden"));
    });
    return ()=>{
        while(undos.length)undos.pop()();
    };
}
function crawlSiblingsUp(el, callback) {
    if (el.isSameNode(document.body) || !el.parentNode) return;
    Array.from(el.parentNode.children).forEach((sibling)=>{
        if (sibling.isSameNode(el)) crawlSiblingsUp(el.parentNode, callback);
        else callback(sibling);
    });
}
function disableScrolling() {
    let overflow = document.documentElement.style.overflow;
    let paddingRight = document.documentElement.style.paddingRight;
    let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.overflow = "hidden";
    document.documentElement.style.paddingRight = `${scrollbarWidth}px`;
    return ()=>{
        document.documentElement.style.overflow = overflow;
        document.documentElement.style.paddingRight = paddingRight;
    };
}
// packages/focus/builds/module.js
var module_default = src_default;
 /*! Bundled license information:

tabbable/dist/index.esm.js:
  (*!
  * tabbable 5.3.3
  * @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
  *)

focus-trap/dist/focus-trap.esm.js:
  (*!
  * focus-trap 6.9.4
  * @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
  *)
*/ 
});

//AlpineJs
// packages/alpinejs/src/scheduler.js
var $60a16a39d78eea98$var$flushPending = false;
var $60a16a39d78eea98$var$flushing = false;
var $60a16a39d78eea98$var$queue = [];
var $60a16a39d78eea98$var$lastFlushedIndex = -1;
function $60a16a39d78eea98$var$scheduler(callback) {
    $60a16a39d78eea98$var$queueJob(callback);
}
function $60a16a39d78eea98$var$queueJob(job) {
    if (!$60a16a39d78eea98$var$queue.includes(job)) $60a16a39d78eea98$var$queue.push(job);
    $60a16a39d78eea98$var$queueFlush();
}
function $60a16a39d78eea98$var$dequeueJob(job) {
    let index = $60a16a39d78eea98$var$queue.indexOf(job);
    if (index !== -1 && index > $60a16a39d78eea98$var$lastFlushedIndex) $60a16a39d78eea98$var$queue.splice(index, 1);
}
function $60a16a39d78eea98$var$queueFlush() {
    if (!$60a16a39d78eea98$var$flushing && !$60a16a39d78eea98$var$flushPending) {
        $60a16a39d78eea98$var$flushPending = true;
        queueMicrotask($60a16a39d78eea98$var$flushJobs);
    }
}
function $60a16a39d78eea98$var$flushJobs() {
    $60a16a39d78eea98$var$flushPending = false;
    $60a16a39d78eea98$var$flushing = true;
    for(let i = 0; i < $60a16a39d78eea98$var$queue.length; i++){
        $60a16a39d78eea98$var$queue[i]();
        $60a16a39d78eea98$var$lastFlushedIndex = i;
    }
    $60a16a39d78eea98$var$queue.length = 0;
    $60a16a39d78eea98$var$lastFlushedIndex = -1;
    $60a16a39d78eea98$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $60a16a39d78eea98$var$reactive;
var $60a16a39d78eea98$var$effect;
var $60a16a39d78eea98$var$release;
var $60a16a39d78eea98$var$raw;
var $60a16a39d78eea98$var$shouldSchedule = true;
function $60a16a39d78eea98$var$disableEffectScheduling(callback) {
    $60a16a39d78eea98$var$shouldSchedule = false;
    callback();
    $60a16a39d78eea98$var$shouldSchedule = true;
}
function $60a16a39d78eea98$var$setReactivityEngine(engine) {
    $60a16a39d78eea98$var$reactive = engine.reactive;
    $60a16a39d78eea98$var$release = engine.release;
    $60a16a39d78eea98$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($60a16a39d78eea98$var$shouldSchedule) $60a16a39d78eea98$var$scheduler(task);
                else task();
            }
        });
    $60a16a39d78eea98$var$raw = engine.raw;
}
function $60a16a39d78eea98$var$overrideEffect(override) {
    $60a16a39d78eea98$var$effect = override;
}
function $60a16a39d78eea98$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $60a16a39d78eea98$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $60a16a39d78eea98$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $60a16a39d78eea98$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $60a16a39d78eea98$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(()=>{
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return ()=>$60a16a39d78eea98$var$release(effectReference);
}
// packages/alpinejs/src/utils/dispatch.js
function $60a16a39d78eea98$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $60a16a39d78eea98$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$60a16a39d78eea98$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $60a16a39d78eea98$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $60a16a39d78eea98$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $60a16a39d78eea98$var$started = false;
function $60a16a39d78eea98$var$start() {
    if ($60a16a39d78eea98$var$started) $60a16a39d78eea98$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $60a16a39d78eea98$var$started = true;
    if (!document.body) $60a16a39d78eea98$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $60a16a39d78eea98$var$dispatch(document, "alpine:init");
    $60a16a39d78eea98$var$dispatch(document, "alpine:initializing");
    $60a16a39d78eea98$var$startObservingMutations();
    $60a16a39d78eea98$var$onElAdded((el)=>$60a16a39d78eea98$var$initTree(el, $60a16a39d78eea98$var$walk));
    $60a16a39d78eea98$var$onElRemoved((el)=>$60a16a39d78eea98$var$destroyTree(el));
    $60a16a39d78eea98$var$onAttributesAdded((el, attrs)=>{
        $60a16a39d78eea98$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$60a16a39d78eea98$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($60a16a39d78eea98$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $60a16a39d78eea98$var$initTree(el);
    });
    $60a16a39d78eea98$var$dispatch(document, "alpine:initialized");
}
var $60a16a39d78eea98$var$rootSelectorCallbacks = [];
var $60a16a39d78eea98$var$initSelectorCallbacks = [];
function $60a16a39d78eea98$var$rootSelectors() {
    return $60a16a39d78eea98$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $60a16a39d78eea98$var$allSelectors() {
    return $60a16a39d78eea98$var$rootSelectorCallbacks.concat($60a16a39d78eea98$var$initSelectorCallbacks).map((fn)=>fn());
}
function $60a16a39d78eea98$var$addRootSelector(selectorCallback) {
    $60a16a39d78eea98$var$rootSelectorCallbacks.push(selectorCallback);
}
function $60a16a39d78eea98$var$addInitSelector(selectorCallback) {
    $60a16a39d78eea98$var$initSelectorCallbacks.push(selectorCallback);
}
function $60a16a39d78eea98$var$closestRoot(el, includeInitSelectors = false) {
    return $60a16a39d78eea98$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $60a16a39d78eea98$var$allSelectors() : $60a16a39d78eea98$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $60a16a39d78eea98$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $60a16a39d78eea98$var$findClosest(el.parentElement, callback);
}
function $60a16a39d78eea98$var$isRoot(el) {
    return $60a16a39d78eea98$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $60a16a39d78eea98$var$initInterceptors = [];
function $60a16a39d78eea98$var$interceptInit(callback) {
    $60a16a39d78eea98$var$initInterceptors.push(callback);
}
function $60a16a39d78eea98$var$initTree(el, walker = $60a16a39d78eea98$var$walk, intercept = ()=>{}) {
    $60a16a39d78eea98$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            intercept(el2, skip);
            $60a16a39d78eea98$var$initInterceptors.forEach((i)=>i(el2, skip));
            $60a16a39d78eea98$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            el2._x_ignore && skip();
        });
    });
}
function $60a16a39d78eea98$var$destroyTree(root, walker = $60a16a39d78eea98$var$walk) {
    walker(root, (el)=>{
        $60a16a39d78eea98$var$cleanupAttributes(el);
        $60a16a39d78eea98$var$cleanupElement(el);
    });
}
// packages/alpinejs/src/mutation.js
var $60a16a39d78eea98$var$onAttributeAddeds = [];
var $60a16a39d78eea98$var$onElRemoveds = [];
var $60a16a39d78eea98$var$onElAddeds = [];
function $60a16a39d78eea98$var$onElAdded(callback) {
    $60a16a39d78eea98$var$onElAddeds.push(callback);
}
function $60a16a39d78eea98$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $60a16a39d78eea98$var$onElRemoveds.push(callback);
    }
}
function $60a16a39d78eea98$var$onAttributesAdded(callback) {
    $60a16a39d78eea98$var$onAttributeAddeds.push(callback);
}
function $60a16a39d78eea98$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $60a16a39d78eea98$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $60a16a39d78eea98$var$cleanupElement(el) {
    if (el._x_cleanups) while(el._x_cleanups.length)el._x_cleanups.pop()();
}
var $60a16a39d78eea98$var$observer = new MutationObserver($60a16a39d78eea98$var$onMutate);
var $60a16a39d78eea98$var$currentlyObserving = false;
function $60a16a39d78eea98$var$startObservingMutations() {
    $60a16a39d78eea98$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $60a16a39d78eea98$var$currentlyObserving = true;
}
function $60a16a39d78eea98$var$stopObservingMutations() {
    $60a16a39d78eea98$var$flushObserver();
    $60a16a39d78eea98$var$observer.disconnect();
    $60a16a39d78eea98$var$currentlyObserving = false;
}
var $60a16a39d78eea98$var$queuedMutations = [];
function $60a16a39d78eea98$var$flushObserver() {
    let records = $60a16a39d78eea98$var$observer.takeRecords();
    $60a16a39d78eea98$var$queuedMutations.push(()=>records.length > 0 && $60a16a39d78eea98$var$onMutate(records));
    let queueLengthWhenTriggered = $60a16a39d78eea98$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($60a16a39d78eea98$var$queuedMutations.length === queueLengthWhenTriggered) while($60a16a39d78eea98$var$queuedMutations.length > 0)$60a16a39d78eea98$var$queuedMutations.shift()();
    });
}
function $60a16a39d78eea98$var$mutateDom(callback) {
    if (!$60a16a39d78eea98$var$currentlyObserving) return callback();
    $60a16a39d78eea98$var$stopObservingMutations();
    let result = callback();
    $60a16a39d78eea98$var$startObservingMutations();
    return result;
}
var $60a16a39d78eea98$var$isCollecting = false;
var $60a16a39d78eea98$var$deferredMutations = [];
function $60a16a39d78eea98$var$deferMutations() {
    $60a16a39d78eea98$var$isCollecting = true;
}
function $60a16a39d78eea98$var$flushAndStopDeferringMutations() {
    $60a16a39d78eea98$var$isCollecting = false;
    $60a16a39d78eea98$var$onMutate($60a16a39d78eea98$var$deferredMutations);
    $60a16a39d78eea98$var$deferredMutations = [];
}
function $60a16a39d78eea98$var$onMutate(mutations) {
    if ($60a16a39d78eea98$var$isCollecting) {
        $60a16a39d78eea98$var$deferredMutations = $60a16a39d78eea98$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = /* @__PURE__ */ new Set();
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].addedNodes.forEach((node)=>node.nodeType === 1 && addedNodes.add(node));
            mutations[i].removedNodes.forEach((node)=>node.nodeType === 1 && removedNodes.add(node));
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $60a16a39d78eea98$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $60a16a39d78eea98$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.has(node)) continue;
        $60a16a39d78eea98$var$onElRemoveds.forEach((i)=>i(node));
        $60a16a39d78eea98$var$destroyTree(node);
    }
    addedNodes.forEach((node)=>{
        node._x_ignoreSelf = true;
        node._x_ignore = true;
    });
    for (let node of addedNodes){
        if (removedNodes.has(node)) continue;
        if (!node.isConnected) continue;
        delete node._x_ignoreSelf;
        delete node._x_ignore;
        $60a16a39d78eea98$var$onElAddeds.forEach((i)=>i(node));
        node._x_ignore = true;
        node._x_ignoreSelf = true;
    }
    addedNodes.forEach((node)=>{
        delete node._x_ignoreSelf;
        delete node._x_ignore;
    });
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $60a16a39d78eea98$var$scope(node) {
    return $60a16a39d78eea98$var$mergeProxies($60a16a39d78eea98$var$closestDataStack(node));
}
function $60a16a39d78eea98$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$60a16a39d78eea98$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $60a16a39d78eea98$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $60a16a39d78eea98$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $60a16a39d78eea98$var$closestDataStack(node.parentNode);
}
function $60a16a39d78eea98$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $60a16a39d78eea98$var$mergeProxyTrap);
}
var $60a16a39d78eea98$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $60a16a39d78eea98$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if ((descriptor === null || descriptor === void 0 ? void 0 : descriptor.set) && (descriptor === null || descriptor === void 0 ? void 0 : descriptor.get)) return Reflect.set(target, name, value, thisProxy);
        return Reflect.set(target, name, value);
    }
};
function $60a16a39d78eea98$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $60a16a39d78eea98$var$initInterceptors2(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $60a16a39d78eea98$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$60a16a39d78eea98$var$get(data2, path), (value)=>$60a16a39d78eea98$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $60a16a39d78eea98$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $60a16a39d78eea98$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $60a16a39d78eea98$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $60a16a39d78eea98$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $60a16a39d78eea98$var$magics = {};
function $60a16a39d78eea98$var$magic(name, callback) {
    $60a16a39d78eea98$var$magics[name] = callback;
}
function $60a16a39d78eea98$var$injectMagics(obj, el) {
    Object.entries($60a16a39d78eea98$var$magics).forEach(([name, callback])=>{
        let memoizedUtilities = null;
        function getUtilities() {
            if (memoizedUtilities) return memoizedUtilities;
            else {
                let [utilities, cleanup2] = $60a16a39d78eea98$var$getElementBoundUtilities(el);
                memoizedUtilities = {
                    interceptor: $60a16a39d78eea98$var$interceptor,
                    ...utilities
                };
                $60a16a39d78eea98$var$onElRemoved(el, cleanup2);
                return memoizedUtilities;
            }
        }
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, getUtilities());
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/utils/error.js
function $60a16a39d78eea98$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $60a16a39d78eea98$var$handleError(e, el, expression);
    }
}
function $60a16a39d78eea98$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 !== null && error2 !== void 0 ? error2 : {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $60a16a39d78eea98$var$shouldAutoEvaluateFunctions = true;
function $60a16a39d78eea98$var$dontAutoEvaluateFunctions(callback) {
    let cache = $60a16a39d78eea98$var$shouldAutoEvaluateFunctions;
    $60a16a39d78eea98$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $60a16a39d78eea98$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $60a16a39d78eea98$var$evaluate(el, expression, extras = {}) {
    let result;
    $60a16a39d78eea98$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $60a16a39d78eea98$var$evaluateLater(...args) {
    return $60a16a39d78eea98$var$theEvaluatorFunction(...args);
}
var $60a16a39d78eea98$var$theEvaluatorFunction = $60a16a39d78eea98$var$normalEvaluator;
function $60a16a39d78eea98$var$setEvaluator(newEvaluator) {
    $60a16a39d78eea98$var$theEvaluatorFunction = newEvaluator;
}
function $60a16a39d78eea98$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $60a16a39d78eea98$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$60a16a39d78eea98$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $60a16a39d78eea98$var$generateEvaluatorFromFunction(dataStack, expression) : $60a16a39d78eea98$var$generateEvaluatorFromString(dataStack, expression, el);
    return $60a16a39d78eea98$var$tryCatch.bind(null, el, expression, evaluator);
}
function $60a16a39d78eea98$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($60a16a39d78eea98$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $60a16a39d78eea98$var$runIfTypeOfFunction(receiver, result);
    };
}
var $60a16a39d78eea98$var$evaluatorMemo = {};
function $60a16a39d78eea98$var$generateFunctionFromString(expression, el) {
    if ($60a16a39d78eea98$var$evaluatorMemo[expression]) return $60a16a39d78eea98$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $60a16a39d78eea98$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $60a16a39d78eea98$var$evaluatorMemo[expression] = func;
    return func;
}
function $60a16a39d78eea98$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $60a16a39d78eea98$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $60a16a39d78eea98$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$60a16a39d78eea98$var$handleError(error2, el, expression));
            if (func.finished) {
                $60a16a39d78eea98$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $60a16a39d78eea98$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$60a16a39d78eea98$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $60a16a39d78eea98$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($60a16a39d78eea98$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$60a16a39d78eea98$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$60a16a39d78eea98$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $60a16a39d78eea98$var$prefixAsString = "x-";
function $60a16a39d78eea98$var$prefix(subject = "") {
    return $60a16a39d78eea98$var$prefixAsString + subject;
}
function $60a16a39d78eea98$var$setPrefix(newPrefix) {
    $60a16a39d78eea98$var$prefixAsString = newPrefix;
}
var $60a16a39d78eea98$var$directiveHandlers = {};
function $60a16a39d78eea98$var$directive(name, callback) {
    $60a16a39d78eea98$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$60a16a39d78eea98$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $60a16a39d78eea98$var$directiveOrder.indexOf(directive2);
            $60a16a39d78eea98$var$directiveOrder.splice(pos >= 0 ? pos : $60a16a39d78eea98$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $60a16a39d78eea98$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $60a16a39d78eea98$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($60a16a39d78eea98$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($60a16a39d78eea98$var$outNonAlpineAttributes).map($60a16a39d78eea98$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($60a16a39d78eea98$var$byPriority);
    return directives2.map((directive2)=>{
        return $60a16a39d78eea98$var$getDirectiveHandler(el, directive2);
    });
}
function $60a16a39d78eea98$var$attributesOnly(attributes) {
    return Array.from(attributes).map($60a16a39d78eea98$var$toTransformedAttributes()).filter((attr)=>!$60a16a39d78eea98$var$outNonAlpineAttributes(attr));
}
var $60a16a39d78eea98$var$isDeferringHandlers = false;
var $60a16a39d78eea98$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $60a16a39d78eea98$var$currentHandlerStackKey = Symbol();
function $60a16a39d78eea98$var$deferHandlingDirectives(callback) {
    $60a16a39d78eea98$var$isDeferringHandlers = true;
    let key = Symbol();
    $60a16a39d78eea98$var$currentHandlerStackKey = key;
    $60a16a39d78eea98$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($60a16a39d78eea98$var$directiveHandlerStacks.get(key).length)$60a16a39d78eea98$var$directiveHandlerStacks.get(key).shift()();
        $60a16a39d78eea98$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $60a16a39d78eea98$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $60a16a39d78eea98$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $60a16a39d78eea98$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $60a16a39d78eea98$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $60a16a39d78eea98$var$evaluateLater.bind($60a16a39d78eea98$var$evaluateLater, el),
        evaluate: $60a16a39d78eea98$var$evaluate.bind($60a16a39d78eea98$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $60a16a39d78eea98$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $60a16a39d78eea98$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $60a16a39d78eea98$var$getElementBoundUtilities(el);
    $60a16a39d78eea98$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $60a16a39d78eea98$var$isDeferringHandlers ? $60a16a39d78eea98$var$directiveHandlerStacks.get($60a16a39d78eea98$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $60a16a39d78eea98$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $60a16a39d78eea98$var$into = (i)=>i;
function $60a16a39d78eea98$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $60a16a39d78eea98$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $60a16a39d78eea98$var$attributeTransformers = [];
function $60a16a39d78eea98$var$mapAttributes(callback) {
    $60a16a39d78eea98$var$attributeTransformers.push(callback);
}
function $60a16a39d78eea98$var$outNonAlpineAttributes({ name: name }) {
    return $60a16a39d78eea98$var$alpineAttributeRegex().test(name);
}
var $60a16a39d78eea98$var$alpineAttributeRegex = ()=>new RegExp(`^${$60a16a39d78eea98$var$prefixAsString}([^:^.]+)\\b`);
function $60a16a39d78eea98$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($60a16a39d78eea98$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $60a16a39d78eea98$var$DEFAULT = "DEFAULT";
var $60a16a39d78eea98$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $60a16a39d78eea98$var$DEFAULT,
    "teleport"
];
function $60a16a39d78eea98$var$byPriority(a, b) {
    let typeA = $60a16a39d78eea98$var$directiveOrder.indexOf(a.type) === -1 ? $60a16a39d78eea98$var$DEFAULT : a.type;
    let typeB = $60a16a39d78eea98$var$directiveOrder.indexOf(b.type) === -1 ? $60a16a39d78eea98$var$DEFAULT : b.type;
    return $60a16a39d78eea98$var$directiveOrder.indexOf(typeA) - $60a16a39d78eea98$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/nextTick.js
var $60a16a39d78eea98$var$tickStack = [];
var $60a16a39d78eea98$var$isHolding = false;
function $60a16a39d78eea98$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $60a16a39d78eea98$var$isHolding || setTimeout(()=>{
            $60a16a39d78eea98$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $60a16a39d78eea98$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $60a16a39d78eea98$var$releaseNextTicks() {
    $60a16a39d78eea98$var$isHolding = false;
    while($60a16a39d78eea98$var$tickStack.length)$60a16a39d78eea98$var$tickStack.shift()();
}
function $60a16a39d78eea98$var$holdNextTicks() {
    $60a16a39d78eea98$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $60a16a39d78eea98$var$setClasses(el, value) {
    if (Array.isArray(value)) return $60a16a39d78eea98$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $60a16a39d78eea98$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $60a16a39d78eea98$var$setClasses(el, value());
    return $60a16a39d78eea98$var$setClassesFromString(el, value);
}
function $60a16a39d78eea98$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $60a16a39d78eea98$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $60a16a39d78eea98$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $60a16a39d78eea98$var$setStylesFromObject(el, value);
    return $60a16a39d78eea98$var$setStylesFromString(el, value);
}
function $60a16a39d78eea98$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $60a16a39d78eea98$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $60a16a39d78eea98$var$setStyles(el, previousStyles);
    };
}
function $60a16a39d78eea98$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $60a16a39d78eea98$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $60a16a39d78eea98$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$60a16a39d78eea98$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $60a16a39d78eea98$var$registerTransitionsFromHelper(el, modifiers, value);
    else $60a16a39d78eea98$var$registerTransitionsFromClassString(el, expression, value);
});
function $60a16a39d78eea98$var$registerTransitionsFromClassString(el, classString, stage) {
    $60a16a39d78eea98$var$registerTransitionObject(el, $60a16a39d78eea98$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $60a16a39d78eea98$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $60a16a39d78eea98$var$registerTransitionObject(el, $60a16a39d78eea98$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $60a16a39d78eea98$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $60a16a39d78eea98$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $60a16a39d78eea98$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $60a16a39d78eea98$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $60a16a39d78eea98$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $60a16a39d78eea98$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $60a16a39d78eea98$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $60a16a39d78eea98$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $60a16a39d78eea98$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $60a16a39d78eea98$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $60a16a39d78eea98$var$closestHide(parent);
}
function $60a16a39d78eea98$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $60a16a39d78eea98$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $60a16a39d78eea98$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $60a16a39d78eea98$var$once(()=>{
        $60a16a39d78eea98$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $60a16a39d78eea98$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $60a16a39d78eea98$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $60a16a39d78eea98$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $60a16a39d78eea98$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $60a16a39d78eea98$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $60a16a39d78eea98$var$mutateDom(()=>{
                stages.end();
            });
            $60a16a39d78eea98$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $60a16a39d78eea98$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $60a16a39d78eea98$var$isCloning = false;
function $60a16a39d78eea98$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$60a16a39d78eea98$var$isCloning ? fallback(...args) : callback(...args);
}
function $60a16a39d78eea98$var$onlyDuringClone(callback) {
    return (...args)=>$60a16a39d78eea98$var$isCloning && callback(...args);
}
var $60a16a39d78eea98$var$interceptors = [];
function $60a16a39d78eea98$var$interceptClone(callback) {
    $60a16a39d78eea98$var$interceptors.push(callback);
}
function $60a16a39d78eea98$var$cloneNode(from, to) {
    $60a16a39d78eea98$var$interceptors.forEach((i)=>i(from, to));
    $60a16a39d78eea98$var$isCloning = true;
    $60a16a39d78eea98$var$dontRegisterReactiveSideEffects(()=>{
        $60a16a39d78eea98$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $60a16a39d78eea98$var$isCloning = false;
}
var $60a16a39d78eea98$var$isCloningLegacy = false;
function $60a16a39d78eea98$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $60a16a39d78eea98$var$isCloning = true;
    $60a16a39d78eea98$var$isCloningLegacy = true;
    $60a16a39d78eea98$var$dontRegisterReactiveSideEffects(()=>{
        $60a16a39d78eea98$var$cloneTree(newEl);
    });
    $60a16a39d78eea98$var$isCloning = false;
    $60a16a39d78eea98$var$isCloningLegacy = false;
}
function $60a16a39d78eea98$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $60a16a39d78eea98$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $60a16a39d78eea98$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $60a16a39d78eea98$var$initTree(el, shallowWalker);
}
function $60a16a39d78eea98$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $60a16a39d78eea98$var$effect;
    $60a16a39d78eea98$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $60a16a39d78eea98$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $60a16a39d78eea98$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $60a16a39d78eea98$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $60a16a39d78eea98$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $60a16a39d78eea98$var$camelCase(name) : name;
    switch(name){
        case "value":
            $60a16a39d78eea98$var$bindInputValue(el, value);
            break;
        case "style":
            $60a16a39d78eea98$var$bindStyles(el, value);
            break;
        case "class":
            $60a16a39d78eea98$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $60a16a39d78eea98$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $60a16a39d78eea98$var$bindAttribute(el, name, value);
            break;
    }
}
function $60a16a39d78eea98$var$bindInputValue(el, value) {
    if (el.type === "radio") {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $60a16a39d78eea98$var$safeParseBoolean(el.value) === value;
            else el.checked = $60a16a39d78eea98$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if (el.type === "checkbox") {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$60a16a39d78eea98$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $60a16a39d78eea98$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $60a16a39d78eea98$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $60a16a39d78eea98$var$setClasses(el, value);
}
function $60a16a39d78eea98$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $60a16a39d78eea98$var$setStyles(el, value);
}
function $60a16a39d78eea98$var$bindAttributeAndProperty(el, name, value) {
    $60a16a39d78eea98$var$bindAttribute(el, name, value);
    $60a16a39d78eea98$var$setPropertyIfChanged(el, name, value);
}
function $60a16a39d78eea98$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $60a16a39d78eea98$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($60a16a39d78eea98$var$isBooleanAttr(name)) value = name;
        $60a16a39d78eea98$var$setIfChanged(el, name, value);
    }
}
function $60a16a39d78eea98$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $60a16a39d78eea98$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $60a16a39d78eea98$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $60a16a39d78eea98$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $60a16a39d78eea98$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $60a16a39d78eea98$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
function $60a16a39d78eea98$var$isBooleanAttr(attrName) {
    const booleanAttributes = [
        "disabled",
        "checked",
        "required",
        "readonly",
        "open",
        "selected",
        "autofocus",
        "itemscope",
        "multiple",
        "novalidate",
        "allowfullscreen",
        "allowpaymentrequest",
        "formnovalidate",
        "autoplay",
        "controls",
        "loop",
        "muted",
        "playsinline",
        "default",
        "ismap",
        "reversed",
        "async",
        "defer",
        "nomodule"
    ];
    return booleanAttributes.includes(attrName);
}
function $60a16a39d78eea98$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $60a16a39d78eea98$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $60a16a39d78eea98$var$getAttributeBinding(el, name, fallback);
}
function $60a16a39d78eea98$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $60a16a39d78eea98$var$dontAutoEvaluateFunctions(()=>{
            return $60a16a39d78eea98$var$evaluate(el, binding.expression);
        });
    }
    return $60a16a39d78eea98$var$getAttributeBinding(el, name, fallback);
}
function $60a16a39d78eea98$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($60a16a39d78eea98$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
// packages/alpinejs/src/utils/debounce.js
function $60a16a39d78eea98$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $60a16a39d78eea98$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $60a16a39d78eea98$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $60a16a39d78eea98$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($60a16a39d78eea98$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($60a16a39d78eea98$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($60a16a39d78eea98$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $60a16a39d78eea98$var$release(reference);
    };
}
function $60a16a39d78eea98$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $60a16a39d78eea98$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($60a16a39d78eea98$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $60a16a39d78eea98$var$stores = {};
var $60a16a39d78eea98$var$isReactive = false;
function $60a16a39d78eea98$var$store(name, value) {
    if (!$60a16a39d78eea98$var$isReactive) {
        $60a16a39d78eea98$var$stores = $60a16a39d78eea98$var$reactive($60a16a39d78eea98$var$stores);
        $60a16a39d78eea98$var$isReactive = true;
    }
    if (value === void 0) return $60a16a39d78eea98$var$stores[name];
    $60a16a39d78eea98$var$stores[name] = value;
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $60a16a39d78eea98$var$stores[name].init();
    $60a16a39d78eea98$var$initInterceptors2($60a16a39d78eea98$var$stores[name]);
}
function $60a16a39d78eea98$var$getStores() {
    return $60a16a39d78eea98$var$stores;
}
// packages/alpinejs/src/binds.js
var $60a16a39d78eea98$var$binds = {};
function $60a16a39d78eea98$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $60a16a39d78eea98$var$applyBindingsObject(name, getBindings());
    else $60a16a39d78eea98$var$binds[name] = getBindings;
    return ()=>{};
}
function $60a16a39d78eea98$var$injectBindingProviders(obj) {
    Object.entries($60a16a39d78eea98$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $60a16a39d78eea98$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $60a16a39d78eea98$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $60a16a39d78eea98$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $60a16a39d78eea98$var$datas = {};
function $60a16a39d78eea98$var$data(name, callback) {
    $60a16a39d78eea98$var$datas[name] = callback;
}
function $60a16a39d78eea98$var$injectDataProviders(obj, context) {
    Object.entries($60a16a39d78eea98$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $60a16a39d78eea98$var$Alpine = {
    get reactive () {
        return $60a16a39d78eea98$var$reactive;
    },
    get release () {
        return $60a16a39d78eea98$var$release;
    },
    get effect () {
        return $60a16a39d78eea98$var$effect;
    },
    get raw () {
        return $60a16a39d78eea98$var$raw;
    },
    version: "3.13.8",
    flushAndStopDeferringMutations: $60a16a39d78eea98$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $60a16a39d78eea98$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $60a16a39d78eea98$var$disableEffectScheduling,
    startObservingMutations: $60a16a39d78eea98$var$startObservingMutations,
    stopObservingMutations: $60a16a39d78eea98$var$stopObservingMutations,
    setReactivityEngine: $60a16a39d78eea98$var$setReactivityEngine,
    onAttributeRemoved: $60a16a39d78eea98$var$onAttributeRemoved,
    onAttributesAdded: $60a16a39d78eea98$var$onAttributesAdded,
    closestDataStack: $60a16a39d78eea98$var$closestDataStack,
    skipDuringClone: $60a16a39d78eea98$var$skipDuringClone,
    onlyDuringClone: $60a16a39d78eea98$var$onlyDuringClone,
    addRootSelector: $60a16a39d78eea98$var$addRootSelector,
    addInitSelector: $60a16a39d78eea98$var$addInitSelector,
    interceptClone: $60a16a39d78eea98$var$interceptClone,
    addScopeToNode: $60a16a39d78eea98$var$addScopeToNode,
    deferMutations: $60a16a39d78eea98$var$deferMutations,
    mapAttributes: $60a16a39d78eea98$var$mapAttributes,
    evaluateLater: $60a16a39d78eea98$var$evaluateLater,
    interceptInit: $60a16a39d78eea98$var$interceptInit,
    setEvaluator: $60a16a39d78eea98$var$setEvaluator,
    mergeProxies: $60a16a39d78eea98$var$mergeProxies,
    extractProp: $60a16a39d78eea98$var$extractProp,
    findClosest: $60a16a39d78eea98$var$findClosest,
    onElRemoved: $60a16a39d78eea98$var$onElRemoved,
    closestRoot: $60a16a39d78eea98$var$closestRoot,
    destroyTree: $60a16a39d78eea98$var$destroyTree,
    interceptor: $60a16a39d78eea98$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $60a16a39d78eea98$var$transition,
    setStyles: // INTERNAL
    $60a16a39d78eea98$var$setStyles,
    mutateDom: // INTERNAL
    $60a16a39d78eea98$var$mutateDom,
    directive: $60a16a39d78eea98$var$directive,
    entangle: $60a16a39d78eea98$var$entangle,
    throttle: $60a16a39d78eea98$var$throttle,
    debounce: $60a16a39d78eea98$var$debounce,
    evaluate: $60a16a39d78eea98$var$evaluate,
    initTree: $60a16a39d78eea98$var$initTree,
    nextTick: $60a16a39d78eea98$var$nextTick,
    prefixed: $60a16a39d78eea98$var$prefix,
    prefix: $60a16a39d78eea98$var$setPrefix,
    plugin: $60a16a39d78eea98$var$plugin,
    magic: $60a16a39d78eea98$var$magic,
    store: $60a16a39d78eea98$var$store,
    start: $60a16a39d78eea98$var$start,
    clone: $60a16a39d78eea98$var$clone,
    cloneNode: // INTERNAL
    $60a16a39d78eea98$var$cloneNode,
    // INTERNAL
    bound: $60a16a39d78eea98$var$getBinding,
    $data: $60a16a39d78eea98$var$scope,
    watch: $60a16a39d78eea98$var$watch,
    walk: $60a16a39d78eea98$var$walk,
    data: $60a16a39d78eea98$var$data,
    bind: $60a16a39d78eea98$var$bind2
};
var $60a16a39d78eea98$var$alpine_default = $60a16a39d78eea98$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $60a16a39d78eea98$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $60a16a39d78eea98$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $60a16a39d78eea98$var$isBooleanAttr2 = /* @__PURE__ */ $60a16a39d78eea98$var$makeMap($60a16a39d78eea98$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $60a16a39d78eea98$var$EMPTY_OBJ = Object.freeze({});
var $60a16a39d78eea98$var$EMPTY_ARR = Object.freeze([]);
var $60a16a39d78eea98$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $60a16a39d78eea98$var$hasOwn = (val, key)=>$60a16a39d78eea98$var$hasOwnProperty.call(val, key);
var $60a16a39d78eea98$var$isArray = Array.isArray;
var $60a16a39d78eea98$var$isMap = (val)=>$60a16a39d78eea98$var$toTypeString(val) === "[object Map]";
var $60a16a39d78eea98$var$isString = (val)=>typeof val === "string";
var $60a16a39d78eea98$var$isSymbol = (val)=>typeof val === "symbol";
var $60a16a39d78eea98$var$isObject = (val)=>val !== null && typeof val === "object";
var $60a16a39d78eea98$var$objectToString = Object.prototype.toString;
var $60a16a39d78eea98$var$toTypeString = (value)=>$60a16a39d78eea98$var$objectToString.call(value);
var $60a16a39d78eea98$var$toRawType = (value)=>{
    return $60a16a39d78eea98$var$toTypeString(value).slice(8, -1);
};
var $60a16a39d78eea98$var$isIntegerKey = (key)=>$60a16a39d78eea98$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $60a16a39d78eea98$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $60a16a39d78eea98$var$camelizeRE = /-(\w)/g;
var $60a16a39d78eea98$var$camelize = $60a16a39d78eea98$var$cacheStringFunction((str)=>{
    return str.replace($60a16a39d78eea98$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $60a16a39d78eea98$var$hyphenateRE = /\B([A-Z])/g;
var $60a16a39d78eea98$var$hyphenate = $60a16a39d78eea98$var$cacheStringFunction((str)=>str.replace($60a16a39d78eea98$var$hyphenateRE, "-$1").toLowerCase());
var $60a16a39d78eea98$var$capitalize = $60a16a39d78eea98$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $60a16a39d78eea98$var$toHandlerKey = $60a16a39d78eea98$var$cacheStringFunction((str)=>str ? `on${$60a16a39d78eea98$var$capitalize(str)}` : ``);
var $60a16a39d78eea98$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $60a16a39d78eea98$var$targetMap = /* @__PURE__ */ new WeakMap();
var $60a16a39d78eea98$var$effectStack = [];
var $60a16a39d78eea98$var$activeEffect;
var $60a16a39d78eea98$var$ITERATE_KEY = Symbol("iterate");
var $60a16a39d78eea98$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $60a16a39d78eea98$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $60a16a39d78eea98$var$effect2(fn, options = $60a16a39d78eea98$var$EMPTY_OBJ) {
    if ($60a16a39d78eea98$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $60a16a39d78eea98$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $60a16a39d78eea98$var$stop(effect3) {
    if (effect3.active) {
        $60a16a39d78eea98$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $60a16a39d78eea98$var$uid = 0;
function $60a16a39d78eea98$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$60a16a39d78eea98$var$effectStack.includes(effect3)) {
            $60a16a39d78eea98$var$cleanup(effect3);
            try {
                $60a16a39d78eea98$var$enableTracking();
                $60a16a39d78eea98$var$effectStack.push(effect3);
                $60a16a39d78eea98$var$activeEffect = effect3;
                return fn();
            } finally{
                $60a16a39d78eea98$var$effectStack.pop();
                $60a16a39d78eea98$var$resetTracking();
                $60a16a39d78eea98$var$activeEffect = $60a16a39d78eea98$var$effectStack[$60a16a39d78eea98$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $60a16a39d78eea98$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $60a16a39d78eea98$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $60a16a39d78eea98$var$shouldTrack = true;
var $60a16a39d78eea98$var$trackStack = [];
function $60a16a39d78eea98$var$pauseTracking() {
    $60a16a39d78eea98$var$trackStack.push($60a16a39d78eea98$var$shouldTrack);
    $60a16a39d78eea98$var$shouldTrack = false;
}
function $60a16a39d78eea98$var$enableTracking() {
    $60a16a39d78eea98$var$trackStack.push($60a16a39d78eea98$var$shouldTrack);
    $60a16a39d78eea98$var$shouldTrack = true;
}
function $60a16a39d78eea98$var$resetTracking() {
    const last = $60a16a39d78eea98$var$trackStack.pop();
    $60a16a39d78eea98$var$shouldTrack = last === void 0 ? true : last;
}
function $60a16a39d78eea98$var$track(target, type, key) {
    if (!$60a16a39d78eea98$var$shouldTrack || $60a16a39d78eea98$var$activeEffect === void 0) return;
    let depsMap = $60a16a39d78eea98$var$targetMap.get(target);
    if (!depsMap) $60a16a39d78eea98$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($60a16a39d78eea98$var$activeEffect)) {
        dep.add($60a16a39d78eea98$var$activeEffect);
        $60a16a39d78eea98$var$activeEffect.deps.push(dep);
        if ($60a16a39d78eea98$var$activeEffect.options.onTrack) $60a16a39d78eea98$var$activeEffect.options.onTrack({
            effect: $60a16a39d78eea98$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $60a16a39d78eea98$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $60a16a39d78eea98$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $60a16a39d78eea98$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $60a16a39d78eea98$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$60a16a39d78eea98$var$isArray(target)) {
                    add2(depsMap.get($60a16a39d78eea98$var$ITERATE_KEY));
                    if ($60a16a39d78eea98$var$isMap(target)) add2(depsMap.get($60a16a39d78eea98$var$MAP_KEY_ITERATE_KEY));
                } else if ($60a16a39d78eea98$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$60a16a39d78eea98$var$isArray(target)) {
                    add2(depsMap.get($60a16a39d78eea98$var$ITERATE_KEY));
                    if ($60a16a39d78eea98$var$isMap(target)) add2(depsMap.get($60a16a39d78eea98$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($60a16a39d78eea98$var$isMap(target)) add2(depsMap.get($60a16a39d78eea98$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $60a16a39d78eea98$var$isNonTrackableKeys = /* @__PURE__ */ $60a16a39d78eea98$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $60a16a39d78eea98$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($60a16a39d78eea98$var$isSymbol));
var $60a16a39d78eea98$var$get2 = /* @__PURE__ */ $60a16a39d78eea98$var$createGetter();
var $60a16a39d78eea98$var$readonlyGet = /* @__PURE__ */ $60a16a39d78eea98$var$createGetter(true);
var $60a16a39d78eea98$var$arrayInstrumentations = /* @__PURE__ */ $60a16a39d78eea98$var$createArrayInstrumentations();
function $60a16a39d78eea98$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $60a16a39d78eea98$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$60a16a39d78eea98$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($60a16a39d78eea98$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $60a16a39d78eea98$var$pauseTracking();
            const res = $60a16a39d78eea98$var$toRaw(this)[key].apply(this, args);
            $60a16a39d78eea98$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $60a16a39d78eea98$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $60a16a39d78eea98$var$shallowReadonlyMap : $60a16a39d78eea98$var$readonlyMap : shallow ? $60a16a39d78eea98$var$shallowReactiveMap : $60a16a39d78eea98$var$reactiveMap).get(target)) return target;
        const targetIsArray = $60a16a39d78eea98$var$isArray(target);
        if (!isReadonly && targetIsArray && $60a16a39d78eea98$var$hasOwn($60a16a39d78eea98$var$arrayInstrumentations, key)) return Reflect.get($60a16a39d78eea98$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($60a16a39d78eea98$var$isSymbol(key) ? $60a16a39d78eea98$var$builtInSymbols.has(key) : $60a16a39d78eea98$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $60a16a39d78eea98$var$track(target, "get", key);
        if (shallow) return res;
        if ($60a16a39d78eea98$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$60a16a39d78eea98$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($60a16a39d78eea98$var$isObject(res)) return isReadonly ? $60a16a39d78eea98$var$readonly(res) : $60a16a39d78eea98$var$reactive2(res);
        return res;
    };
}
var $60a16a39d78eea98$var$set2 = /* @__PURE__ */ $60a16a39d78eea98$var$createSetter();
function $60a16a39d78eea98$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $60a16a39d78eea98$var$toRaw(value);
            oldValue = $60a16a39d78eea98$var$toRaw(oldValue);
            if (!$60a16a39d78eea98$var$isArray(target) && $60a16a39d78eea98$var$isRef(oldValue) && !$60a16a39d78eea98$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $60a16a39d78eea98$var$isArray(target) && $60a16a39d78eea98$var$isIntegerKey(key) ? Number(key) < target.length : $60a16a39d78eea98$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $60a16a39d78eea98$var$toRaw(receiver)) {
            if (!hadKey) $60a16a39d78eea98$var$trigger(target, "add", key, value);
            else if ($60a16a39d78eea98$var$hasChanged(value, oldValue)) $60a16a39d78eea98$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $60a16a39d78eea98$var$deleteProperty(target, key) {
    const hadKey = $60a16a39d78eea98$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $60a16a39d78eea98$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $60a16a39d78eea98$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$60a16a39d78eea98$var$isSymbol(key) || !$60a16a39d78eea98$var$builtInSymbols.has(key)) $60a16a39d78eea98$var$track(target, "has", key);
    return result;
}
function $60a16a39d78eea98$var$ownKeys(target) {
    $60a16a39d78eea98$var$track(target, "iterate", $60a16a39d78eea98$var$isArray(target) ? "length" : $60a16a39d78eea98$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $60a16a39d78eea98$var$mutableHandlers = {
    get: $60a16a39d78eea98$var$get2,
    set: $60a16a39d78eea98$var$set2,
    deleteProperty: $60a16a39d78eea98$var$deleteProperty,
    has: $60a16a39d78eea98$var$has,
    ownKeys: $60a16a39d78eea98$var$ownKeys
};
var $60a16a39d78eea98$var$readonlyHandlers = {
    get: $60a16a39d78eea98$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $60a16a39d78eea98$var$toReactive = (value)=>$60a16a39d78eea98$var$isObject(value) ? $60a16a39d78eea98$var$reactive2(value) : value;
var $60a16a39d78eea98$var$toReadonly = (value)=>$60a16a39d78eea98$var$isObject(value) ? $60a16a39d78eea98$var$readonly(value) : value;
var $60a16a39d78eea98$var$toShallow = (value)=>value;
var $60a16a39d78eea98$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $60a16a39d78eea98$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $60a16a39d78eea98$var$toRaw(target);
    const rawKey = $60a16a39d78eea98$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $60a16a39d78eea98$var$track(rawTarget, "get", key);
    !isReadonly && $60a16a39d78eea98$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $60a16a39d78eea98$var$getProto(rawTarget);
    const wrap = isShallow ? $60a16a39d78eea98$var$toShallow : isReadonly ? $60a16a39d78eea98$var$toReadonly : $60a16a39d78eea98$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $60a16a39d78eea98$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $60a16a39d78eea98$var$toRaw(target);
    const rawKey = $60a16a39d78eea98$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $60a16a39d78eea98$var$track(rawTarget, "has", key);
    !isReadonly && $60a16a39d78eea98$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $60a16a39d78eea98$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $60a16a39d78eea98$var$track($60a16a39d78eea98$var$toRaw(target), "iterate", $60a16a39d78eea98$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $60a16a39d78eea98$var$add(value) {
    value = $60a16a39d78eea98$var$toRaw(value);
    const target = $60a16a39d78eea98$var$toRaw(this);
    const proto = $60a16a39d78eea98$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $60a16a39d78eea98$var$trigger(target, "add", value, value);
    }
    return this;
}
function $60a16a39d78eea98$var$set$1(key, value) {
    value = $60a16a39d78eea98$var$toRaw(value);
    const target = $60a16a39d78eea98$var$toRaw(this);
    const { has: has2, get: get3 } = $60a16a39d78eea98$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $60a16a39d78eea98$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $60a16a39d78eea98$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $60a16a39d78eea98$var$trigger(target, "add", key, value);
    else if ($60a16a39d78eea98$var$hasChanged(value, oldValue)) $60a16a39d78eea98$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $60a16a39d78eea98$var$deleteEntry(key) {
    const target = $60a16a39d78eea98$var$toRaw(this);
    const { has: has2, get: get3 } = $60a16a39d78eea98$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $60a16a39d78eea98$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $60a16a39d78eea98$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $60a16a39d78eea98$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $60a16a39d78eea98$var$clear() {
    const target = $60a16a39d78eea98$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $60a16a39d78eea98$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $60a16a39d78eea98$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $60a16a39d78eea98$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $60a16a39d78eea98$var$toRaw(target);
        const wrap = isShallow ? $60a16a39d78eea98$var$toShallow : isReadonly ? $60a16a39d78eea98$var$toReadonly : $60a16a39d78eea98$var$toReactive;
        !isReadonly && $60a16a39d78eea98$var$track(rawTarget, "iterate", $60a16a39d78eea98$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $60a16a39d78eea98$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $60a16a39d78eea98$var$toRaw(target);
        const targetIsMap = $60a16a39d78eea98$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $60a16a39d78eea98$var$toShallow : isReadonly ? $60a16a39d78eea98$var$toReadonly : $60a16a39d78eea98$var$toReactive;
        !isReadonly && $60a16a39d78eea98$var$track(rawTarget, "iterate", isKeyOnly ? $60a16a39d78eea98$var$MAP_KEY_ITERATE_KEY : $60a16a39d78eea98$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $60a16a39d78eea98$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$60a16a39d78eea98$var$capitalize(type)} operation ${key}failed: target is readonly.`, $60a16a39d78eea98$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $60a16a39d78eea98$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $60a16a39d78eea98$var$get$1(this, key);
        },
        get size () {
            return $60a16a39d78eea98$var$size(this);
        },
        has: $60a16a39d78eea98$var$has$1,
        add: $60a16a39d78eea98$var$add,
        set: $60a16a39d78eea98$var$set$1,
        delete: $60a16a39d78eea98$var$deleteEntry,
        clear: $60a16a39d78eea98$var$clear,
        forEach: $60a16a39d78eea98$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $60a16a39d78eea98$var$get$1(this, key, false, true);
        },
        get size () {
            return $60a16a39d78eea98$var$size(this);
        },
        has: $60a16a39d78eea98$var$has$1,
        add: $60a16a39d78eea98$var$add,
        set: $60a16a39d78eea98$var$set$1,
        delete: $60a16a39d78eea98$var$deleteEntry,
        clear: $60a16a39d78eea98$var$clear,
        forEach: $60a16a39d78eea98$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $60a16a39d78eea98$var$get$1(this, key, true);
        },
        get size () {
            return $60a16a39d78eea98$var$size(this, true);
        },
        has (key) {
            return $60a16a39d78eea98$var$has$1.call(this, key, true);
        },
        add: $60a16a39d78eea98$var$createReadonlyMethod("add"),
        set: $60a16a39d78eea98$var$createReadonlyMethod("set"),
        delete: $60a16a39d78eea98$var$createReadonlyMethod("delete"),
        clear: $60a16a39d78eea98$var$createReadonlyMethod("clear"),
        forEach: $60a16a39d78eea98$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $60a16a39d78eea98$var$get$1(this, key, true, true);
        },
        get size () {
            return $60a16a39d78eea98$var$size(this, true);
        },
        has (key) {
            return $60a16a39d78eea98$var$has$1.call(this, key, true);
        },
        add: $60a16a39d78eea98$var$createReadonlyMethod("add"),
        set: $60a16a39d78eea98$var$createReadonlyMethod("set"),
        delete: $60a16a39d78eea98$var$createReadonlyMethod("delete"),
        clear: $60a16a39d78eea98$var$createReadonlyMethod("clear"),
        forEach: $60a16a39d78eea98$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $60a16a39d78eea98$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $60a16a39d78eea98$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $60a16a39d78eea98$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $60a16a39d78eea98$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$60a16a39d78eea98$var$mutableInstrumentations, $60a16a39d78eea98$var$readonlyInstrumentations, $60a16a39d78eea98$var$shallowInstrumentations, $60a16a39d78eea98$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $60a16a39d78eea98$var$createInstrumentations();
function $60a16a39d78eea98$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $60a16a39d78eea98$var$shallowReadonlyInstrumentations : $60a16a39d78eea98$var$shallowInstrumentations : isReadonly ? $60a16a39d78eea98$var$readonlyInstrumentations : $60a16a39d78eea98$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($60a16a39d78eea98$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $60a16a39d78eea98$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $60a16a39d78eea98$var$createInstrumentationGetter(false, false)
};
var $60a16a39d78eea98$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $60a16a39d78eea98$var$createInstrumentationGetter(true, false)
};
function $60a16a39d78eea98$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $60a16a39d78eea98$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $60a16a39d78eea98$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $60a16a39d78eea98$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $60a16a39d78eea98$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $60a16a39d78eea98$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $60a16a39d78eea98$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $60a16a39d78eea98$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $60a16a39d78eea98$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $60a16a39d78eea98$var$targetTypeMap($60a16a39d78eea98$var$toRawType(value));
}
function $60a16a39d78eea98$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $60a16a39d78eea98$var$createReactiveObject(target, false, $60a16a39d78eea98$var$mutableHandlers, $60a16a39d78eea98$var$mutableCollectionHandlers, $60a16a39d78eea98$var$reactiveMap);
}
function $60a16a39d78eea98$var$readonly(target) {
    return $60a16a39d78eea98$var$createReactiveObject(target, true, $60a16a39d78eea98$var$readonlyHandlers, $60a16a39d78eea98$var$readonlyCollectionHandlers, $60a16a39d78eea98$var$readonlyMap);
}
function $60a16a39d78eea98$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$60a16a39d78eea98$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $60a16a39d78eea98$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $60a16a39d78eea98$var$toRaw(observed) {
    return observed && $60a16a39d78eea98$var$toRaw(observed["__v_raw"]) || observed;
}
function $60a16a39d78eea98$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$60a16a39d78eea98$var$magic("nextTick", ()=>$60a16a39d78eea98$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$60a16a39d78eea98$var$magic("dispatch", (el)=>$60a16a39d78eea98$var$dispatch.bind($60a16a39d78eea98$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$60a16a39d78eea98$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $60a16a39d78eea98$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$60a16a39d78eea98$var$magic("store", $60a16a39d78eea98$var$getStores);
// packages/alpinejs/src/magics/$data.js
$60a16a39d78eea98$var$magic("data", (el)=>$60a16a39d78eea98$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$60a16a39d78eea98$var$magic("root", (el)=>$60a16a39d78eea98$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$60a16a39d78eea98$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $60a16a39d78eea98$var$mergeProxies($60a16a39d78eea98$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $60a16a39d78eea98$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $60a16a39d78eea98$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $60a16a39d78eea98$var$globalIdMemo = {};
function $60a16a39d78eea98$var$findAndIncrementId(name) {
    if (!$60a16a39d78eea98$var$globalIdMemo[name]) $60a16a39d78eea98$var$globalIdMemo[name] = 0;
    return ++$60a16a39d78eea98$var$globalIdMemo[name];
}
function $60a16a39d78eea98$var$closestIdRoot(el, name) {
    return $60a16a39d78eea98$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $60a16a39d78eea98$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $60a16a39d78eea98$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$60a16a39d78eea98$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $60a16a39d78eea98$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $60a16a39d78eea98$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $60a16a39d78eea98$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$60a16a39d78eea98$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $60a16a39d78eea98$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$60a16a39d78eea98$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$60a16a39d78eea98$var$warnMissingPluginMagic("Focus", "focus", "focus");
$60a16a39d78eea98$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $60a16a39d78eea98$var$warnMissingPluginMagic(name, magicName, slug) {
    $60a16a39d78eea98$var$magic(magicName, (el)=>$60a16a39d78eea98$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$60a16a39d78eea98$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $60a16a39d78eea98$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$60a16a39d78eea98$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $60a16a39d78eea98$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $60a16a39d78eea98$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $60a16a39d78eea98$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $60a16a39d78eea98$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $60a16a39d78eea98$var$initTree(clone2);
        clone2._x_ignore = true;
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $60a16a39d78eea98$var$getTarget(expression);
        $60a16a39d78eea98$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>clone2.remove());
});
var $60a16a39d78eea98$var$teleportContainerDuringClone = document.createElement("div");
function $60a16a39d78eea98$var$getTarget(expression) {
    let target = $60a16a39d78eea98$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $60a16a39d78eea98$var$teleportContainerDuringClone;
    })();
    if (!target) $60a16a39d78eea98$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $60a16a39d78eea98$var$handler = ()=>{};
$60a16a39d78eea98$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$60a16a39d78eea98$var$directive("ignore", $60a16a39d78eea98$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$60a16a39d78eea98$var$directive("effect", $60a16a39d78eea98$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($60a16a39d78eea98$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $60a16a39d78eea98$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $60a16a39d78eea98$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $60a16a39d78eea98$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $60a16a39d78eea98$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $60a16a39d78eea98$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $60a16a39d78eea98$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $60a16a39d78eea98$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    handler4 = wrapHandler(handler4, (next, e)=>{
        if ($60a16a39d78eea98$var$isKeyEvent(event)) {
            if ($60a16a39d78eea98$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        }
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $60a16a39d78eea98$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $60a16a39d78eea98$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $60a16a39d78eea98$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $60a16a39d78eea98$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $60a16a39d78eea98$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $60a16a39d78eea98$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $60a16a39d78eea98$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $60a16a39d78eea98$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $60a16a39d78eea98$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($60a16a39d78eea98$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $60a16a39d78eea98$var$keyToModifiers(key) {
    if (!key) return [];
    key = $60a16a39d78eea98$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$60a16a39d78eea98$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $60a16a39d78eea98$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $60a16a39d78eea98$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $60a16a39d78eea98$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $60a16a39d78eea98$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($60a16a39d78eea98$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $60a16a39d78eea98$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $60a16a39d78eea98$var$isCloning ? ()=>{} : $60a16a39d78eea98$var$on(el, event, modifiers, (e)=>{
        setValue($60a16a39d78eea98$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || el.type === "checkbox" && Array.isArray(getValue())) setValue($60a16a39d78eea98$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $60a16a39d78eea98$var$on(el.form, "reset", [], (e)=>{
            $60a16a39d78eea98$var$nextTick(()=>el._x_model && el._x_model.set(el.value));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $60a16a39d78eea98$var$mutateDom(()=>$60a16a39d78eea98$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $60a16a39d78eea98$var$getInputValue(el, modifiers, event, currentValue) {
    return $60a16a39d78eea98$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if (el.type === "checkbox") {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $60a16a39d78eea98$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $60a16a39d78eea98$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$60a16a39d78eea98$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $60a16a39d78eea98$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $60a16a39d78eea98$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if (el.type === "radio") {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $60a16a39d78eea98$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $60a16a39d78eea98$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $60a16a39d78eea98$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $60a16a39d78eea98$var$isNumeric2(number) ? number : rawValue;
}
function $60a16a39d78eea98$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $60a16a39d78eea98$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $60a16a39d78eea98$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$60a16a39d78eea98$var$directive("cloak", (el)=>queueMicrotask(()=>$60a16a39d78eea98$var$mutateDom(()=>el.removeAttribute($60a16a39d78eea98$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$60a16a39d78eea98$var$addInitSelector(()=>`[${$60a16a39d78eea98$var$prefix("init")}]`);
$60a16a39d78eea98$var$directive("init", $60a16a39d78eea98$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$60a16a39d78eea98$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $60a16a39d78eea98$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$60a16a39d78eea98$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $60a16a39d78eea98$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $60a16a39d78eea98$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$60a16a39d78eea98$var$mapAttributes($60a16a39d78eea98$var$startingWith(":", $60a16a39d78eea98$var$into($60a16a39d78eea98$var$prefix("bind:"))));
var $60a16a39d78eea98$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $60a16a39d78eea98$var$injectBindingProviders(bindingProviders);
        let getBindings = $60a16a39d78eea98$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $60a16a39d78eea98$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $60a16a39d78eea98$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $60a16a39d78eea98$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $60a16a39d78eea98$var$mutateDom(()=>$60a16a39d78eea98$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$60a16a39d78eea98$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$60a16a39d78eea98$var$directive("bind", $60a16a39d78eea98$var$handler2);
function $60a16a39d78eea98$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$60a16a39d78eea98$var$addRootSelector(()=>`[${$60a16a39d78eea98$var$prefix("data")}]`);
$60a16a39d78eea98$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($60a16a39d78eea98$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $60a16a39d78eea98$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $60a16a39d78eea98$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $60a16a39d78eea98$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $60a16a39d78eea98$var$injectMagics(data2, el);
    let reactiveData = $60a16a39d78eea98$var$reactive(data2);
    $60a16a39d78eea98$var$initInterceptors2(reactiveData);
    let undo = $60a16a39d78eea98$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $60a16a39d78eea98$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $60a16a39d78eea98$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$60a16a39d78eea98$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $60a16a39d78eea98$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$60a16a39d78eea98$var$isCloning) return false;
    if ($60a16a39d78eea98$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$60a16a39d78eea98$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $60a16a39d78eea98$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $60a16a39d78eea98$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $60a16a39d78eea98$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $60a16a39d78eea98$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$60a16a39d78eea98$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $60a16a39d78eea98$var$parseForExpression(expression);
    let evaluateItems = $60a16a39d78eea98$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $60a16a39d78eea98$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$60a16a39d78eea98$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>el2.remove());
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $60a16a39d78eea98$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($60a16a39d78eea98$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $60a16a39d78eea98$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $60a16a39d78eea98$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $60a16a39d78eea98$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $60a16a39d78eea98$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!!lookup[key]._x_effects) lookup[key]._x_effects.forEach($60a16a39d78eea98$var$dequeueJob);
            lookup[key].remove();
            lookup[key] = null;
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $60a16a39d78eea98$var$mutateDom(()=>{
                if (!elForSpot) $60a16a39d78eea98$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $60a16a39d78eea98$var$reactive(scope2);
            $60a16a39d78eea98$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $60a16a39d78eea98$var$mutateDom(()=>{
                lastEl.after(clone2);
                $60a16a39d78eea98$var$skipDuringClone(()=>$60a16a39d78eea98$var$initTree(clone2))();
            });
            if (typeof key === "object") $60a16a39d78eea98$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $60a16a39d78eea98$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $60a16a39d78eea98$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $60a16a39d78eea98$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $60a16a39d78eea98$var$handler3() {}
$60a16a39d78eea98$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $60a16a39d78eea98$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$60a16a39d78eea98$var$directive("ref", $60a16a39d78eea98$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$60a16a39d78eea98$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $60a16a39d78eea98$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $60a16a39d78eea98$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $60a16a39d78eea98$var$addScopeToNode(clone2, {}, el);
        $60a16a39d78eea98$var$mutateDom(()=>{
            el.after(clone2);
            $60a16a39d78eea98$var$skipDuringClone(()=>$60a16a39d78eea98$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $60a16a39d78eea98$var$walk(clone2, (node)=>{
                if (!!node._x_effects) node._x_effects.forEach($60a16a39d78eea98$var$dequeueJob);
            });
            clone2.remove();
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$60a16a39d78eea98$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$60a16a39d78eea98$var$setIdRoot(el, name));
});
$60a16a39d78eea98$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$60a16a39d78eea98$var$mapAttributes($60a16a39d78eea98$var$startingWith("@", $60a16a39d78eea98$var$into($60a16a39d78eea98$var$prefix("on:"))));
$60a16a39d78eea98$var$directive("on", $60a16a39d78eea98$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $60a16a39d78eea98$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $60a16a39d78eea98$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$60a16a39d78eea98$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$60a16a39d78eea98$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$60a16a39d78eea98$var$warnMissingPluginDirective("Focus", "trap", "focus");
$60a16a39d78eea98$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $60a16a39d78eea98$var$warnMissingPluginDirective(name, directiveName, slug) {
    $60a16a39d78eea98$var$directive(directiveName, (el)=>$60a16a39d78eea98$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$60a16a39d78eea98$var$alpine_default.setEvaluator($60a16a39d78eea98$var$normalEvaluator);
$60a16a39d78eea98$var$alpine_default.setReactivityEngine({
    reactive: $60a16a39d78eea98$var$reactive2,
    effect: $60a16a39d78eea98$var$effect2,
    release: $60a16a39d78eea98$var$stop,
    raw: $60a16a39d78eea98$var$toRaw
});
var $60a16a39d78eea98$export$b7ee041e4ad2afec = $60a16a39d78eea98$var$alpine_default;
// packages/alpinejs/builds/module.js
var $60a16a39d78eea98$export$2e2bcd8739ae039 = $60a16a39d78eea98$export$b7ee041e4ad2afec;



var $jybxg = parcelRequire("jybxg");
// packages/collapse/src/index.js
function $ccc9cd3586772f2a$export$ec45920981e0ca9b(Alpine) {
    Alpine.directive("collapse", collapse);
    collapse.inline = (el, { modifiers: modifiers })=>{
        if (!modifiers.includes("min")) return;
        el._x_doShow = ()=>{};
        el._x_doHide = ()=>{};
    };
    function collapse(el, { modifiers: modifiers }) {
        let duration = $ccc9cd3586772f2a$var$modifierValue(modifiers, "duration", 250) / 1e3;
        let floor = $ccc9cd3586772f2a$var$modifierValue(modifiers, "min", 0);
        let fullyHide = !modifiers.includes("min");
        if (!el._x_isShown) el.style.height = `${floor}px`;
        if (!el._x_isShown && fullyHide) el.hidden = true;
        if (!el._x_isShown) el.style.overflow = "hidden";
        let setFunction = (el2, styles)=>{
            let revertFunction = Alpine.setStyles(el2, styles);
            return styles.height ? ()=>{} : revertFunction;
        };
        let transitionStyles = {
            transitionProperty: "height",
            transitionDuration: `${duration}s`,
            transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)"
        };
        el._x_transition = {
            in (before = ()=>{}, after = ()=>{}) {
                if (fullyHide) el.hidden = false;
                if (fullyHide) el.style.display = null;
                let current = el.getBoundingClientRect().height;
                el.style.height = "auto";
                let full = el.getBoundingClientRect().height;
                if (current === full) current = floor;
                Alpine.transition(el, Alpine.setStyles, {
                    during: transitionStyles,
                    start: {
                        height: current + "px"
                    },
                    end: {
                        height: full + "px"
                    }
                }, ()=>el._x_isShown = true, ()=>{
                    if (el.getBoundingClientRect().height == full) el.style.overflow = null;
                });
            },
            out (before = ()=>{}, after = ()=>{}) {
                let full = el.getBoundingClientRect().height;
                Alpine.transition(el, setFunction, {
                    during: transitionStyles,
                    start: {
                        height: full + "px"
                    },
                    end: {
                        height: floor + "px"
                    }
                }, ()=>el.style.overflow = "hidden", ()=>{
                    el._x_isShown = false;
                    if (el.style.height == `${floor}px` && fullyHide) {
                        el.style.display = "none";
                        el.hidden = true;
                    }
                });
            }
        };
    }
}
function $ccc9cd3586772f2a$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "duration") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "min") {
        let match = rawValue.match(/([0-9]+)px/);
        if (match) return match[1];
    }
    return rawValue;
}
// packages/collapse/builds/module.js
var $ccc9cd3586772f2a$export$2e2bcd8739ae039 = $ccc9cd3586772f2a$export$ec45920981e0ca9b;


(0, $60a16a39d78eea98$export$2e2bcd8739ae039).plugin((0, $ccc9cd3586772f2a$export$2e2bcd8739ae039));
(0, $60a16a39d78eea98$export$2e2bcd8739ae039).plugin((0, $jybxg.default));
(0, $60a16a39d78eea98$export$2e2bcd8739ae039).start();
var $e319239f91b7ae73$exports = {};
/**!
 * MixItUp v3.3.1
 * A high-performance, dependency-free library for animated filtering, sorting and more
 * Build 94e0fbf6-cd0b-4987-b3c0-14b59b67b8a0
 *
 * @copyright Copyright 2014-2018 KunkaLabs Limited.
 * @author    KunkaLabs Limited.
 * @link      https://www.kunkalabs.com/mixitup/
 *
 * @license   Commercial use requires a commercial license.
 *            https://www.kunkalabs.com/mixitup/licenses/
 *
 *            Non-commercial use permitted under same terms as CC BY-NC 3.0 license.
 *            http://creativecommons.org/licenses/by-nc/3.0/
 */ (function(window1) {
    "use strict";
    var mixitup = null, h = null;
    (function() {
        var VENDORS = [
            "webkit",
            "moz",
            "o",
            "ms"
        ], canary = window1.document.createElement("div"), i = -1;
        // window.requestAnimationFrame
        for(i = 0; i < VENDORS.length && !window1.requestAnimationFrame; i++)window1.requestAnimationFrame = window1[VENDORS[i] + "RequestAnimationFrame"];
        // Element.nextElementSibling
        if (typeof canary.nextElementSibling === "undefined") Object.defineProperty(window1.Element.prototype, "nextElementSibling", {
            get: function() {
                var el = this.nextSibling;
                while(el){
                    if (el.nodeType === 1) return el;
                    el = el.nextSibling;
                }
                return null;
            }
        });
        // Element.matches
        (function(ElementPrototype) {
            ElementPrototype.matches = ElementPrototype.matches || ElementPrototype.machesSelector || ElementPrototype.mozMatchesSelector || ElementPrototype.msMatchesSelector || ElementPrototype.oMatchesSelector || ElementPrototype.webkitMatchesSelector || function(selector) {
                return Array.prototype.indexOf.call(this.parentElement.querySelectorAll(selector), this) > -1;
            };
        })(window1.Element.prototype);
        // Object.keys
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
        if (!Object.keys) Object.keys = function() {
            var hasOwnProperty = Object.prototype.hasOwnProperty, hasDontEnumBug = false, dontEnums = [], dontEnumsLength = -1;
            hasDontEnumBug = !({
                toString: null
            }).propertyIsEnumerable("toString");
            dontEnums = [
                "toString",
                "toLocaleString",
                "valueOf",
                "hasOwnProperty",
                "isPrototypeOf",
                "propertyIsEnumerable",
                "constructor"
            ];
            dontEnumsLength = dontEnums.length;
            return function(obj) {
                var result = [], prop = "", i = -1;
                if (typeof obj !== "object" && (typeof obj !== "function" || obj === null)) throw new TypeError("Object.keys called on non-object");
                for(prop in obj)if (hasOwnProperty.call(obj, prop)) result.push(prop);
                if (hasDontEnumBug) {
                    for(i = 0; i < dontEnumsLength; i++)if (hasOwnProperty.call(obj, dontEnums[i])) result.push(dontEnums[i]);
                }
                return result;
            };
        }();
        // Array.isArray
        // https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray
        if (!Array.isArray) Array.isArray = function(arg) {
            return Object.prototype.toString.call(arg) === "[object Array]";
        };
        // Object.create
        // https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/create
        if (typeof Object.create !== "function") Object.create = function(undefined) {
            var Temp = function() {};
            return function(prototype, propertiesObject) {
                if (prototype !== Object(prototype) && prototype !== null) throw TypeError("Argument must be an object, or null");
                Temp.prototype = prototype || {};
                var result = new Temp();
                Temp.prototype = null;
                if (propertiesObject !== undefined) Object.defineProperties(result, propertiesObject);
                if (prototype === null) /* jshint ignore:start */ result.__proto__ = null;
                return result;
            };
        }();
        // String.prototyoe.trim
        if (!String.prototype.trim) String.prototype.trim = function() {
            return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
        };
        // Array.prototype.indexOf
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf
        if (!Array.prototype.indexOf) Array.prototype.indexOf = function(searchElement) {
            var n, k, t, len;
            if (this === null) throw new TypeError();
            t = Object(this);
            len = t.length >>> 0;
            if (len === 0) return -1;
            n = 0;
            if (arguments.length > 1) {
                n = Number(arguments[1]);
                if (n !== n) n = 0;
                else if (n !== 0 && n !== Infinity && n !== -Infinity) n = (n > 0 || -1) * Math.floor(Math.abs(n));
            }
            if (n >= len) return -1;
            for(k = n >= 0 ? n : Math.max(len - Math.abs(n), 0); k < len; k++){
                if (k in t && t[k] === searchElement) return k;
            }
            return -1;
        };
        // Function.prototype.bind
        // https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_objects/Function/bind
        if (!Function.prototype.bind) Function.prototype.bind = function(oThis) {
            var aArgs, self, FNOP, fBound;
            if (typeof this !== "function") throw new TypeError();
            aArgs = Array.prototype.slice.call(arguments, 1);
            self = this;
            FNOP = function() {};
            fBound = function() {
                return self.apply(this instanceof FNOP ? this : oThis, aArgs.concat(Array.prototype.slice.call(arguments)));
            };
            if (this.prototype) FNOP.prototype = this.prototype;
            fBound.prototype = new FNOP();
            return fBound;
        };
        // Element.prototype.dispatchEvent
        if (!window1.Element.prototype.dispatchEvent) window1.Element.prototype.dispatchEvent = function(event) {
            try {
                return this.fireEvent("on" + event.type, event);
            } catch (err) {}
        };
    })();
    /**
     * The `mixitup()` "factory" function creates and returns individual instances
     * of MixItUp, known as "mixers", on which API methods can be called.
     *
     * When loading MixItUp via a script tag, the factory function is accessed
     * via the global variable `mixitup`. When using a module loading
     * system (e.g. ES2015, CommonJS, RequireJS), the factory function is
     * exported into your module when you require the MixItUp library.
     *
     * @example
     * mixitup(container [,config] [,foreignDoc])
     *
     * @example <caption>Example 1: Creating a mixer instance with an element reference</caption>
     * var containerEl = document.querySelector('.container');
     *
     * var mixer = mixitup(containerEl);
     *
     * @example <caption>Example 2: Creating a mixer instance with a selector string</caption>
     * var mixer = mixitup('.container');
     *
     * @example <caption>Example 3: Passing a configuration object</caption>
     * var mixer = mixitup(containerEl, {
     *     animation: {
     *         effects: 'fade scale(0.5)'
     *     }
     * });
     *
     * @example <caption>Example 4: Passing an iframe reference</caption>
     * var mixer = mixitup(containerEl, config, foreignDocument);
     *
     * @global
     * @namespace
     * @public
     * @kind        function
     * @since       3.0.0
     * @param       {(Element|string)}  container
     *      A DOM element or selector string representing the container(s) on which to instantiate MixItUp.
     * @param       {object}            [config]
     *      An optional "configuration object" used to customize the behavior of the MixItUp instance.
     * @param       {object}            [foreignDoc]
     *      An optional reference to a `document`, which can be used to control a MixItUp instance in an iframe.
     * @return      {mixitup.Mixer}
     *      A "mixer" object holding the MixItUp instance.
     */ mixitup = function(container, config, foreignDoc) {
        var el = null, returnCollection = false, instance = null, facade = null, doc = null, output = null, instances = [], id = "", elements = [], i = -1;
        doc = foreignDoc || window1.document;
        if (returnCollection = arguments[3]) // A non-documented 4th paramater enabling control of multiple instances
        returnCollection = typeof returnCollection === "boolean";
        if (typeof container === "string") elements = doc.querySelectorAll(container);
        else if (container && typeof container === "object" && h.isElement(container, doc)) elements = [
            container
        ];
        else if (container && typeof container === "object" && container.length) // Although not documented, the container may also be an array-like list of
        // elements such as a NodeList or jQuery collection, is returnCollection is true
        elements = container;
        else throw new Error(mixitup.messages.errorFactoryInvalidContainer());
        if (elements.length < 1) throw new Error(mixitup.messages.errorFactoryContainerNotFound());
        for(i = 0; el = elements[i]; i++){
            if (i > 0 && !returnCollection) break;
            if (!el.id) {
                id = "MixItUp" + h.randomHex();
                el.id = id;
            } else id = el.id;
            if (mixitup.instances[id] instanceof mixitup.Mixer) {
                instance = mixitup.instances[id];
                if (!config || config && config.debug && config.debug.showWarnings !== false) console.warn(mixitup.messages.warningFactoryPreexistingInstance());
            } else {
                instance = new mixitup.Mixer();
                instance.attach(el, doc, id, config);
                mixitup.instances[id] = instance;
            }
            facade = new mixitup.Facade(instance);
            if (config && config.debug && config.debug.enable) instances.push(instance);
            else instances.push(facade);
        }
        if (returnCollection) output = new mixitup.Collection(instances);
        else // Return the first instance regardless
        output = instances[0];
        return output;
    };
    /**
     * The `.use()` static method is used to extend the functionality of mixitup with compatible
     * extensions and libraries in an environment with modular scoping e.g. ES2015, CommonJS, or RequireJS.
     *
     * You need only call the `.use()` function once per project, per extension, as module loaders
     * will cache a single reference to MixItUp inclusive of all changes made.
     *
     * @example
     * mixitup.use(extension)
     *
     * @example <caption>Example 1: Extending MixItUp with the Pagination Extension</caption>
     *
     * import mixitup from 'mixitup';
     * import mixitupPagination from 'mixitup-pagination';
     *
     * mixitup.use(mixitupPagination);
     *
     * // All mixers created by the factory function in all modules will now
     * // have pagination functionality
     *
     * var mixer = mixitup('.container');
     *
     * @public
     * @name     use
     * @memberof mixitup
     * @kind     function
     * @static
     * @since    3.0.0
     * @param    {*}  extension   A reference to the extension or library to be used.
     * @return   {void}
     */ mixitup.use = function(extension) {
        mixitup.Base.prototype.callActions.call(mixitup, "beforeUse", arguments);
        // Call the extension's factory function, passing
        // the mixitup factory as a paramater
        if (typeof extension === "function" && extension.TYPE === "mixitup-extension") // Mixitup extension
        {
            if (typeof mixitup.extensions[extension.NAME] === "undefined") {
                extension(mixitup);
                mixitup.extensions[extension.NAME] = extension;
            }
        } else if (extension.fn && extension.fn.jquery) // jQuery
        mixitup.libraries.$ = extension;
        mixitup.Base.prototype.callActions.call(mixitup, "afterUse", arguments);
    };
    mixitup.instances = {};
    mixitup.extensions = {};
    mixitup.libraries = {};
    /**
     * @private
     */ h = {
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        cls
         * @return  {boolean}
         */ hasClass: function(el, cls) {
            return !!el.className.match(new RegExp("(\\s|^)" + cls + "(\\s|$)"));
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        cls
         * @return  {void}
         */ addClass: function(el, cls) {
            if (!this.hasClass(el, cls)) el.className += el.className ? " " + cls : cls;
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        cls
         * @return  {void}
         */ removeClass: function(el, cls) {
            if (this.hasClass(el, cls)) {
                var reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
                el.className = el.className.replace(reg, " ").trim();
            }
        },
        /**
         * Merges the properties of the source object onto the
         * target object. Alters the target object.
         *
         * @private
         * @param   {object}    destination
         * @param   {object}    source
         * @param   {boolean}   [deep=false]
         * @param   {boolean}   [handleErrors=false]
         * @return  {void}
         */ extend: function(destination, source, deep, handleErrors) {
            var sourceKeys = [], key = "", i = -1;
            deep = deep || false;
            handleErrors = handleErrors || false;
            try {
                if (Array.isArray(source)) for(i = 0; i < source.length; i++)sourceKeys.push(i);
                else if (source) sourceKeys = Object.keys(source);
                for(i = 0; i < sourceKeys.length; i++){
                    key = sourceKeys[i];
                    if (!deep || typeof source[key] !== "object" || this.isElement(source[key])) // All non-object properties, or all properties if shallow extend
                    destination[key] = source[key];
                    else if (Array.isArray(source[key])) {
                        // Arrays
                        if (!destination[key]) destination[key] = [];
                        this.extend(destination[key], source[key], deep, handleErrors);
                    } else {
                        // Objects
                        if (!destination[key]) destination[key] = {};
                        this.extend(destination[key], source[key], deep, handleErrors);
                    }
                }
            } catch (err) {
                if (handleErrors) this.handleExtendError(err, destination);
                else throw err;
            }
            return destination;
        },
        /**
         * @private
         * @param   {Error}  err
         * @param   {object} destination
         * @return  {void}
         */ handleExtendError: function(err, destination) {
            var re = /property "?(\w*)"?[,:] object/i, matches = null, erroneous = "", message = "", suggestion = "", probableMatch = "", key = "", mostMatchingChars = -1, i = -1;
            if (err instanceof TypeError && (matches = re.exec(err.message))) {
                erroneous = matches[1];
                for(key in destination){
                    i = 0;
                    while(i < erroneous.length && erroneous.charAt(i) === key.charAt(i))i++;
                    if (i > mostMatchingChars) {
                        mostMatchingChars = i;
                        probableMatch = key;
                    }
                }
                if (mostMatchingChars > 1) suggestion = mixitup.messages.errorConfigInvalidPropertySuggestion({
                    probableMatch: probableMatch
                });
                message = mixitup.messages.errorConfigInvalidProperty({
                    erroneous: erroneous,
                    suggestion: suggestion
                });
                throw new TypeError(message);
            }
            throw err;
        },
        /**
         * @private
         * @param   {string} str
         * @return  {function}
         */ template: function(str) {
            var re = /\${([\w]*)}/g, dynamics = {}, matches = null;
            while(matches = re.exec(str))dynamics[matches[1]] = new RegExp("\\${" + matches[1] + "}", "g");
            return function(data) {
                var key = "", output = str;
                data = data || {};
                for(key in dynamics)output = output.replace(dynamics[key], typeof data[key] !== "undefined" ? data[key] : "");
                return output;
            };
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        type
         * @param   {function}      fn
         * @param   {boolean}       useCapture
         * @return  {void}
         */ on: function(el, type, fn, useCapture) {
            if (!el) return;
            if (el.addEventListener) el.addEventListener(type, fn, useCapture);
            else if (el.attachEvent) {
                el["e" + type + fn] = fn;
                el[type + fn] = function() {
                    el["e" + type + fn](window1.event);
                };
                el.attachEvent("on" + type, el[type + fn]);
            }
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        type
         * @param   {function}      fn
         * @return  {void}
         */ off: function(el, type, fn) {
            if (!el) return;
            if (el.removeEventListener) el.removeEventListener(type, fn, false);
            else if (el.detachEvent) {
                el.detachEvent("on" + type, el[type + fn]);
                el[type + fn] = null;
            }
        },
        /**
         * @private
         * @param   {string}      eventType
         * @param   {object}      detail
         * @param   {Document}    [doc]
         * @return  {CustomEvent}
         */ getCustomEvent: function(eventType, detail, doc) {
            var event = null;
            doc = doc || window1.document;
            if (typeof window1.CustomEvent === "function") event = new window1.CustomEvent(eventType, {
                detail: detail,
                bubbles: true,
                cancelable: true
            });
            else if (typeof doc.createEvent === "function") {
                event = doc.createEvent("CustomEvent");
                event.initCustomEvent(eventType, true, true, detail);
            } else {
                event = doc.createEventObject(), event.type = eventType;
                event.returnValue = false;
                event.cancelBubble = false;
                event.detail = detail;
            }
            return event;
        },
        /**
         * @private
         * @param   {Event} e
         * @return  {Event}
         */ getOriginalEvent: function(e) {
            if (e.touches && e.touches.length) return e.touches[0];
            else if (e.changedTouches && e.changedTouches.length) return e.changedTouches[0];
            else return e;
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        selector
         * @return  {Number}
         */ index: function(el, selector) {
            var i = 0;
            while((el = el.previousElementSibling) !== null)if (!selector || el.matches(selector)) ++i;
            return i;
        },
        /**
         * Converts a dash or snake-case string to camel case.
         *
         * @private
         * @param   {string}    str
         * @param   {boolean}   [isPascal]
         * @return  {string}
         */ camelCase: function(str) {
            return str.toLowerCase().replace(/([_-][a-z])/g, function($1) {
                return $1.toUpperCase().replace(/[_-]/, "");
            });
        },
        /**
         * Converts a dash or snake-case string to pascal case.
         *
         * @private
         * @param   {string}    str
         * @param   {boolean}   [isPascal]
         * @return  {string}
         */ pascalCase: function(str) {
            return (str = this.camelCase(str)).charAt(0).toUpperCase() + str.slice(1);
        },
        /**
         * Converts a camel or pascal-case string to dash case.
         *
         * @private
         * @param   {string}    str
         * @return  {string}
         */ dashCase: function(str) {
            return str.replace(/([A-Z])/g, "-$1").replace(/^-/, "").toLowerCase();
        },
        /**
         * @private
         * @param   {HTMLElement}       el
         * @param   {HTMLHtmlElement}   [doc]
         * @return  {boolean}
         */ isElement: function(el, doc) {
            doc = doc || window1.document;
            if (window1.HTMLElement && el instanceof window1.HTMLElement) return true;
            else if (doc.defaultView && doc.defaultView.HTMLElement && el instanceof doc.defaultView.HTMLElement) return true;
            else return el !== null && el.nodeType === 1 && typeof el.nodeName === "string";
        },
        /**
         * @private
         * @param   {string}            htmlString
         * @param   {HTMLHtmlElement}   [doc]
         * @return  {DocumentFragment}
         */ createElement: function(htmlString, doc) {
            var frag = null, temp = null;
            doc = doc || window1.document;
            frag = doc.createDocumentFragment();
            temp = doc.createElement("div");
            temp.innerHTML = htmlString.trim();
            while(temp.firstChild)frag.appendChild(temp.firstChild);
            return frag;
        },
        /**
         * @private
         * @param   {Node} node
         * @return  {void}
         */ removeWhitespace: function(node) {
            var deleting;
            while(node && node.nodeName === "#text"){
                deleting = node;
                node = node.previousSibling;
                deleting.parentElement && deleting.parentElement.removeChild(deleting);
            }
        },
        /**
         * @private
         * @param   {Array<*>}  a
         * @param   {Array<*>}  b
         * @return  {boolean}
         */ isEqualArray: function(a, b) {
            var i = a.length;
            if (i !== b.length) return false;
            while(i--){
                if (a[i] !== b[i]) return false;
            }
            return true;
        },
        /**
         * @private
         * @param   {object}  a
         * @param   {object}  b
         * @return  {boolean}
         */ deepEquals: function(a, b) {
            var key;
            if (typeof a === "object" && a && typeof b === "object" && b) {
                if (Object.keys(a).length !== Object.keys(b).length) return false;
                for(key in a){
                    if (!b.hasOwnProperty(key) || !this.deepEquals(a[key], b[key])) return false;
                }
            } else if (a !== b) return false;
            return true;
        },
        /**
         * @private
         * @param   {Array<*>}  oldArray
         * @return  {Array<*>}
         */ arrayShuffle: function(oldArray) {
            var newArray = oldArray.slice(), len = newArray.length, i = len, p = -1, t = [];
            while(i--){
                p = ~~(Math.random() * len);
                t = newArray[i];
                newArray[i] = newArray[p];
                newArray[p] = t;
            }
            return newArray;
        },
        /**
         * @private
         * @param   {object}    list
         */ arrayFromList: function(list) {
            var output, i;
            try {
                return Array.prototype.slice.call(list);
            } catch (err) {
                output = [];
                for(i = 0; i < list.length; i++)output.push(list[i]);
                return output;
            }
        },
        /**
         * @private
         * @param   {function}  func
         * @param   {Number}    wait
         * @param   {boolean}   immediate
         * @return  {function}
         */ debounce: function(func, wait, immediate) {
            var timeout;
            return function() {
                var self = this, args = arguments, callNow = immediate && !timeout, later = null;
                later = function() {
                    timeout = null;
                    if (!immediate) func.apply(self, args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(self, args);
            };
        },
        /**
         * @private
         * @param   {HTMLElement}   element
         * @return  {object}
         */ position: function(element) {
            var xPosition = 0, yPosition = 0, offsetParent = element;
            while(element){
                xPosition -= element.scrollLeft;
                yPosition -= element.scrollTop;
                if (element === offsetParent) {
                    xPosition += element.offsetLeft;
                    yPosition += element.offsetTop;
                    offsetParent = element.offsetParent;
                }
                element = element.parentElement;
            }
            return {
                x: xPosition,
                y: yPosition
            };
        },
        /**
         * @private
         * @param   {object}    node1
         * @param   {object}    node2
         * @return  {Number}
         */ getHypotenuse: function(node1, node2) {
            var distanceX = node1.x - node2.x, distanceY = node1.y - node2.y;
            distanceX = distanceX < 0 ? distanceX * -1 : distanceX, distanceY = distanceY < 0 ? distanceY * -1 : distanceY;
            return Math.sqrt(Math.pow(distanceX, 2) + Math.pow(distanceY, 2));
        },
        /**
         * Calcuates the area of intersection between two rectangles and expresses it as
         * a ratio in comparison to the area of the first rectangle.
         *
         * @private
         * @param   {Rect}  box1
         * @param   {Rect}  box2
         * @return  {number}
         */ getIntersectionRatio: function(box1, box2) {
            var controlArea = box1.width * box1.height, intersectionX = -1, intersectionY = -1, intersectionArea = -1, ratio = -1;
            intersectionX = Math.max(0, Math.min(box1.left + box1.width, box2.left + box2.width) - Math.max(box1.left, box2.left));
            intersectionY = Math.max(0, Math.min(box1.top + box1.height, box2.top + box2.height) - Math.max(box1.top, box2.top));
            intersectionArea = intersectionY * intersectionX;
            ratio = intersectionArea / controlArea;
            return ratio;
        },
        /**
         * @private
         * @param   {object}            el
         * @param   {string}            selector
         * @param   {boolean}           [includeSelf]
         * @param   {HTMLHtmlElement}   [doc]
         * @return  {Element|null}
         */ closestParent: function(el, selector, includeSelf, doc) {
            var parent = el.parentNode;
            doc = doc || window1.document;
            if (includeSelf && el.matches(selector)) return el;
            while(parent && parent != doc.body){
                if (parent.matches && parent.matches(selector)) return parent;
                else if (parent.parentNode) parent = parent.parentNode;
                else return null;
            }
            return null;
        },
        /**
         * @private
         * @param   {HTMLElement}       el
         * @param   {string}            selector
         * @param   {HTMLHtmlElement}   [doc]
         * @return  {NodeList}
         */ children: function(el, selector, doc) {
            var children = [], tempId = "";
            doc = doc || window1.doc;
            if (el) {
                if (!el.id) {
                    tempId = "Temp" + this.randomHexKey();
                    el.id = tempId;
                }
                children = doc.querySelectorAll("#" + el.id + " > " + selector);
                if (tempId) el.removeAttribute("id");
            }
            return children;
        },
        /**
         * Creates a clone of a provided array, with any empty strings removed.
         *
         * @private
         * @param   {Array<*>} originalArray
         * @return  {Array<*>}
         */ clean: function(originalArray) {
            var cleanArray = [], i = -1;
            for(i = 0; i < originalArray.length; i++)if (originalArray[i] !== "") cleanArray.push(originalArray[i]);
            return cleanArray;
        },
        /**
         * Abstracts an ES6 promise into a q-like deferred interface for storage and deferred resolution.
         *
         * @private
         * @param  {object} libraries
         * @return {h.Deferred}
         */ defer: function(libraries) {
            var deferred = null, promiseWrapper = null, $ = null;
            promiseWrapper = new this.Deferred();
            if (mixitup.features.has.promises) // ES6 native promise or polyfill
            promiseWrapper.promise = new Promise(function(resolve, reject) {
                promiseWrapper.resolve = resolve;
                promiseWrapper.reject = reject;
            });
            else if (($ = window1.jQuery || libraries.$) && typeof $.Deferred === "function") {
                // jQuery
                deferred = $.Deferred();
                promiseWrapper.promise = deferred.promise();
                promiseWrapper.resolve = deferred.resolve;
                promiseWrapper.reject = deferred.reject;
            } else if (window1.console) // No implementation
            console.warn(mixitup.messages.warningNoPromiseImplementation());
            return promiseWrapper;
        },
        /**
         * @private
         * @param   {Array<Promise>}    tasks
         * @param   {object}            libraries
         * @return  {Promise<Array>}
         */ all: function(tasks, libraries) {
            var $ = null;
            if (mixitup.features.has.promises) return Promise.all(tasks);
            else if (($ = window1.jQuery || libraries.$) && typeof $.when === "function") return $.when.apply($, tasks).done(function() {
                // jQuery when returns spread arguments rather than an array or resolutions
                return arguments;
            });
            // No implementation
            if (window1.console) console.warn(mixitup.messages.warningNoPromiseImplementation());
            return [];
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        property
         * @param   {Array<string>} vendors
         * @return  {string}
         */ getPrefix: function(el, property, vendors) {
            var i = -1, prefix = "";
            if (h.dashCase(property) in el.style) return "";
            for(i = 0; prefix = vendors[i]; i++){
                if (prefix + property in el.style) return prefix.toLowerCase();
            }
            return "unsupported";
        },
        /**
         * @private
         * @return  {string}
         */ randomHex: function() {
            return ("00000" + (Math.random() * 16777216 << 0).toString(16)).substr(-6).toUpperCase();
        },
        /**
         * @private
         * @param   {HTMLDocument}  [doc]
         * @return  {object}
         */ getDocumentState: function(doc) {
            doc = typeof doc.body === "object" ? doc : window1.document;
            return {
                scrollTop: window1.pageYOffset,
                scrollLeft: window1.pageXOffset,
                docHeight: doc.documentElement.scrollHeight,
                docWidth: doc.documentElement.scrollWidth,
                viewportHeight: doc.documentElement.clientHeight,
                viewportWidth: doc.documentElement.clientWidth
            };
        },
        /**
         * @private
         * @param   {object}    obj
         * @param   {function}  fn
         * @return  {function}
         */ bind: function(obj, fn) {
            return function() {
                return fn.apply(obj, arguments);
            };
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @return  {boolean}
         */ isVisible: function(el) {
            var styles = null;
            if (el.offsetParent) return true;
            styles = window1.getComputedStyle(el);
            if (styles.position === "fixed" && styles.visibility !== "hidden" && styles.opacity !== "0") // Fixed elements report no offsetParent,
            // but may still be invisible
            return true;
            return false;
        },
        /**
         * @private
         * @param   {object}    obj
         */ seal: function(obj) {
            if (typeof Object.seal === "function") Object.seal(obj);
        },
        /**
         * @private
         * @param   {object}    obj
         */ freeze: function(obj) {
            if (typeof Object.freeze === "function") Object.freeze(obj);
        },
        /**
         * @private
         * @param   {string}    control
         * @param   {string}    specimen
         * @return  {boolean}
         */ compareVersions: function(control, specimen) {
            var controlParts = control.split("."), specimenParts = specimen.split("."), controlPart = -1, specimenPart = -1, i = -1;
            for(i = 0; i < controlParts.length; i++){
                controlPart = parseInt(controlParts[i].replace(/[^\d.]/g, ""));
                specimenPart = parseInt(specimenParts[i].replace(/[^\d.]/g, "") || 0);
                if (specimenPart < controlPart) return false;
                else if (specimenPart > controlPart) return true;
            }
            return true;
        },
        /**
         * @private
         * @constructor
         */ Deferred: function() {
            this.promise = null;
            this.resolve = null;
            this.reject = null;
            this.id = h.randomHex();
        },
        /**
         * @private
         * @param   {object}  obj
         * @return  {boolean}
         */ isEmptyObject: function(obj) {
            var key = "";
            if (typeof Object.keys === "function") return Object.keys(obj).length === 0;
            for(key in obj){
                if (obj.hasOwnProperty(key)) return false;
            }
            return true;
        },
        /**
         * @param   {mixitup.Config.ClassNames}   classNames
         * @param   {string}                      elementName
         * @param   {string}                      [modifier]
         * @return  {string}
         */ getClassname: function(classNames, elementName, modifier) {
            var classname = "";
            classname += classNames.block;
            if (classname.length) classname += classNames.delineatorElement;
            classname += classNames["element" + this.pascalCase(elementName)];
            if (!modifier) return classname;
            if (classname.length) classname += classNames.delineatorModifier;
            classname += modifier;
            return classname;
        },
        /**
         * Returns the value of a property on a given object via its string key.
         *
         * @param   {object}    obj
         * @param   {string}    stringKey
         * @return  {*} value
         */ getProperty: function(obj, stringKey) {
            var parts = stringKey.split("."), returnCurrent = null, current = "", i = 0;
            if (!stringKey) return obj;
            returnCurrent = function(obj) {
                if (!obj) return null;
                else return obj[current];
            };
            while(i < parts.length){
                current = parts[i];
                obj = returnCurrent(obj);
                i++;
            }
            if (typeof obj !== "undefined") return obj;
            else return null;
        }
    };
    mixitup.h = h;
    /**
     * The Base class adds instance methods to all other extensible MixItUp classes,
     * enabling the calling of any registered hooks.
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Base = function() {};
    mixitup.Base.prototype = {
        constructor: mixitup.Base,
        /**
         * Calls any registered hooks for the provided action.
         *
         * @memberof    mixitup.Base
         * @private
         * @instance
         * @since       2.0.0
         * @param       {string}    actionName
         * @param       {Array<*>}  args
         * @return      {void}
         */ callActions: function(actionName, args) {
            var self = this, hooks = self.constructor.actions[actionName], extensionName = "";
            if (!hooks || h.isEmptyObject(hooks)) return;
            for(extensionName in hooks)hooks[extensionName].apply(self, args);
        },
        /**
         * Calls any registered hooks for the provided filter.
         *
         * @memberof    mixitup.Base
         * @private
         * @instance
         * @since       2.0.0
         * @param       {string}    filterName
         * @param       {*}         input
         * @param       {Array<*>}  args
         * @return      {*}
         */ callFilters: function(filterName, input, args) {
            var self = this, hooks = self.constructor.filters[filterName], output = input, extensionName = "";
            if (!hooks || h.isEmptyObject(hooks)) return output;
            args = args || [];
            for(extensionName in hooks){
                args = h.arrayFromList(args);
                args.unshift(output);
                output = hooks[extensionName].apply(self, args);
            }
            return output;
        }
    };
    /**
     * The BaseStatic class holds a set of static methods which are then added to all other
     * extensible MixItUp classes as a means of integrating extensions via the addition of new
     * methods and/or actions and hooks.
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.BaseStatic = function() {
        this.actions = {};
        this.filters = {};
        /**
         * Performs a shallow extend on the class's prototype, adding one or more new members to
         * the class in a single operation.
         *
         * @memberof    mixitup.BaseStatic
         * @public
         * @static
         * @since       2.1.0
         * @param       {object} extension
         * @return      {void}
         */ this.extend = function(extension) {
            h.extend(this.prototype, extension);
        };
        /**
         * Registers a function to be called on the action hook of the provided name.
         *
         * @memberof    mixitup.BaseStatic
         * @public
         * @static
         * @since       2.1.0
         * @param       {string}    hookName
         * @param       {string}    extensionName
         * @param       {function}  func
         * @return      {void}
         */ this.registerAction = function(hookName, extensionName, func) {
            (this.actions[hookName] = this.actions[hookName] || {})[extensionName] = func;
        };
        /**
         * Registers a function to be called on the filter of the provided name.
         *
         * @memberof    mixitup.BaseStatic
         * @public
         * @static
         * @since       2.1.0
         * @param       {string}    hookName
         * @param       {string}    extensionName
         * @param       {function}  func
         * @return      {void}
         */ this.registerFilter = function(hookName, extensionName, func) {
            (this.filters[hookName] = this.filters[hookName] || {})[extensionName] = func;
        };
    };
    /**
     * The `mixitup.Features` class performs all feature and CSS prefix detection
     * neccessary for MixItUp to function correctly, as well as storing various
     * string and array constants. All feature decection is on evaluation of the
     * library and stored in a singleton instance for use by other internal classes.
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Features = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.boxSizingPrefix = "";
        this.transformPrefix = "";
        this.transitionPrefix = "";
        this.boxSizingPrefix = "";
        this.transformProp = "";
        this.transformRule = "";
        this.transitionProp = "";
        this.perspectiveProp = "";
        this.perspectiveOriginProp = "";
        this.has = new mixitup.Has();
        this.canary = null;
        this.BOX_SIZING_PROP = "boxSizing";
        this.TRANSITION_PROP = "transition";
        this.TRANSFORM_PROP = "transform";
        this.PERSPECTIVE_PROP = "perspective";
        this.PERSPECTIVE_ORIGIN_PROP = "perspectiveOrigin";
        this.VENDORS = [
            "Webkit",
            "moz",
            "O",
            "ms"
        ];
        this.TWEENABLE = [
            "opacity",
            "width",
            "height",
            "marginRight",
            "marginBottom",
            "x",
            "y",
            "scale",
            "translateX",
            "translateY",
            "translateZ",
            "rotateX",
            "rotateY",
            "rotateZ"
        ];
        this.callActions("afterConstruct");
    };
    mixitup.BaseStatic.call(mixitup.Features);
    mixitup.Features.prototype = Object.create(mixitup.Base.prototype);
    h.extend(mixitup.Features.prototype, /** @lends mixitup.Features */ {
        constructor: mixitup.Features,
        /**
         * @private
         * @return  {void}
         */ init: function() {
            var self = this;
            self.callActions("beforeInit", arguments);
            self.canary = document.createElement("div");
            self.setPrefixes();
            self.runTests();
            self.callActions("beforeInit", arguments);
        },
        /**
         * @private
         * @return  {void}
         */ runTests: function() {
            var self = this;
            self.callActions("beforeRunTests", arguments);
            self.has.promises = typeof window1.Promise === "function";
            self.has.transitions = self.transitionPrefix !== "unsupported";
            self.callActions("afterRunTests", arguments);
            h.freeze(self.has);
        },
        /**
         * @private
         * @return  {void}
         */ setPrefixes: function() {
            var self = this;
            self.callActions("beforeSetPrefixes", arguments);
            self.transitionPrefix = h.getPrefix(self.canary, "Transition", self.VENDORS);
            self.transformPrefix = h.getPrefix(self.canary, "Transform", self.VENDORS);
            self.boxSizingPrefix = h.getPrefix(self.canary, "BoxSizing", self.VENDORS);
            self.boxSizingProp = self.boxSizingPrefix ? self.boxSizingPrefix + h.pascalCase(self.BOX_SIZING_PROP) : self.BOX_SIZING_PROP;
            self.transitionProp = self.transitionPrefix ? self.transitionPrefix + h.pascalCase(self.TRANSITION_PROP) : self.TRANSITION_PROP;
            self.transformProp = self.transformPrefix ? self.transformPrefix + h.pascalCase(self.TRANSFORM_PROP) : self.TRANSFORM_PROP;
            self.transformRule = self.transformPrefix ? "-" + self.transformPrefix + "-" + self.TRANSFORM_PROP : self.TRANSFORM_PROP;
            self.perspectiveProp = self.transformPrefix ? self.transformPrefix + h.pascalCase(self.PERSPECTIVE_PROP) : self.PERSPECTIVE_PROP;
            self.perspectiveOriginProp = self.transformPrefix ? self.transformPrefix + h.pascalCase(self.PERSPECTIVE_ORIGIN_PROP) : self.PERSPECTIVE_ORIGIN_PROP;
            self.callActions("afterSetPrefixes", arguments);
        }
    });
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Has = function() {
        this.transitions = false;
        this.promises = false;
        h.seal(this);
    };
    // Assign a singleton instance to `mixitup.features` and initialise:
    mixitup.features = new mixitup.Features();
    mixitup.features.init();
    /**
     * A group of properties defining the mixer's animation and effects settings.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        animation
     * @namespace
     * @public
     * @since       2.0.0
     */ mixitup.ConfigAnimation = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A boolean dictating whether or not animation should be enabled for the MixItUp instance.
         * If `false`, all operations will occur instantly and syncronously, although callback
         * functions and any returned promises will still be fulfilled.
         *
         * @example <caption>Example: Create a mixer with all animations disabled</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         enable: false
         *     }
         * });
         *
         * @name        enable
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.enable = true;
        /**
         * A string of one or more space-seperated properties to which transitions will be
         * applied for all filtering animations.
         *
         * Properties can be listed any order or combination, although they will be applied in a specific
         * predefined order to produce consistent results.
         *
         * To learn more about available effects, experiment with our <a href="https://www.kunkalabs.com/mixitup/">
         * sandbox demo</a> and try out the "Export config" button in the Animation options drop down.
         *
         * @example <caption>Example: Apply "fade" and "translateZ" effects to all animations</caption>
         * // As targets are filtered in and out, they will fade between
         * // opacity 1 and 0 and transform between translateZ(-100px) and
         * // translateZ(0).
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effects: 'fade translateZ(-100px)'
         *     }
         * });
         *
         * @name        effects
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {string}
         * @default     'fade scale'
         */ this.effects = "fade scale";
        /**
         * A string of one or more space-seperated effects to be applied only to filter-in
         * animations, overriding `config.animation.effects` if set.
         *
         * @example <caption>Example: Apply downwards vertical translate to targets being filtered in</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effectsIn: 'fade translateY(-100%)'
         *     }
         * });
         *
         * @name        effectsIn
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {string}
         * @default     ''
         */ this.effectsIn = "";
        /**
         * A string of one or more space-seperated effects to be applied only to filter-out
         * animations, overriding `config.animation.effects` if set.
         *
         * @example <caption>Example: Apply upwards vertical translate to targets being filtered out</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effectsOut: 'fade translateY(-100%)'
         *     }
         * });
         *
         * @name        effectsOut
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {string}
         * @default     ''
         */ this.effectsOut = "";
        /**
         * An integer dictating the duration of all MixItUp animations in milliseconds, not
         * including any additional delay apllied via the `'stagger'` effect.
         *
         * @example <caption>Example: Apply an animation duration of 200ms to all mixitup animations</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         duration: 200
         *     }
         * });
         *
         * @name        duration
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {number}
         * @default     600
         */ this.duration = 600;
        /**
         * A valid CSS3 transition-timing function or shorthand. For a full list of accepted
         * values, visit <a href="http://easings.net" target="_blank">easings.net</a>.
         *
         * @example <caption>Example 1: Apply "ease-in-out" easing to all animations</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         easing: 'ease-in-out'
         *     }
         * });
         *
         * @example <caption>Example 2: Apply a custom "cubic-bezier" easing function to all animations</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)'
         *     }
         * });
         *
         * @name        easing
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {string}
         * @default     'ease'
         */ this.easing = "ease";
        /**
         * A boolean dictating whether or not to apply perspective to the MixItUp container
         * during animations. By default, perspective is always applied and creates the
         * illusion of three-dimensional space for effects such as `translateZ`, `rotateX`,
         * and `rotateY`.
         *
         * You may wish to disable this and define your own perspective settings via CSS.
         *
         * @example <caption>Example: Prevent perspective from being applied to any 3D transforms</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         applyPerspective: false
         *     }
         * });
         *
         * @name        applyPerspective
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {bolean}
         * @default     true
         */ this.applyPerspective = true;
        /**
         * The perspective distance value to be applied to the container during animations,
         * affecting any 3D-transform-based effects.
         *
         * @example <caption>Example: Set a perspective distance of 2000px</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effects: 'rotateY(-25deg)',
         *         perspectiveDistance: '2000px'
         *     }
         * });
         *
         * @name        perspectiveDistance
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {string}
         * @default     '3000px'
         */ this.perspectiveDistance = "3000px";
        /**
         * The perspective-origin value to be applied to the container during animations,
         * affecting any 3D-transform-based effects.
         *
         * @example <caption>Example: Set a perspective origin in the top-right of the container</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effects: 'transateZ(-200px)',
         *         perspectiveOrigin: '100% 0'
         *     }
         * });
         *
         * @name        perspectiveOrigin
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {string}
         * @default     '50% 50%'
         */ this.perspectiveOrigin = "50% 50%";
        /**
         * A boolean dictating whether or not to enable the queuing of operations.
         *
         * If `true` (default), and a control is clicked or an API call is made while another
         * operation is progress, the operation will go into the queue and will be automatically exectuted
         * when the previous operaitons is finished.
         *
         * If `false`, any requested operations will be ignored, and the `onMixBusy` callback and `mixBusy`
         * event will be fired. If `debug.showWarnings` is enabled, a console warning will also occur.
         *
         * @example <caption>Example: Disable queuing</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         queue: false
         *     }
         * });
         *
         * @name        queue
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.queue = true;
        /**
         * An integer dictacting the maximum number of operations allowed in the queue at
         * any time, when queuing is enabled.
         *
         * @example <caption>Example: Allow a maximum of 5 operations in the queue at any time</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         queueLimit: 5
         *     }
         * });
         *
         * @name        queueLimit
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {number}
         * @default     3
         */ this.queueLimit = 3;
        /**
         * A boolean dictating whether or not to transition the height and width of the
         * container as elements are filtered in and out. If disabled, the container height
         * will change abruptly.
         *
         * It may be desirable to disable this on mobile devices as the CSS `height` and
         * `width` properties do not receive GPU-acceleration and can therefore cause stuttering.
         *
         * @example <caption>Example 1: Disable the transitioning of the container height and/or width</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         animateResizeContainer: false
         *     }
         * });
         *
         * @example <caption>Example 2: Disable the transitioning of the container height and/or width for mobile devices only</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         animateResizeContainer: myFeatureTests.isMobile ? false : true
         *     }
         * });
         *
         * @name        animateResizeContainer
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.animateResizeContainer = true;
        /**
         * A boolean dictating whether or not to transition the height and width of target
         * elements as they change throughout the course of an animation.
         *
         * This is often a must for flex-box grid layouts where the size of target elements may change
         * depending on final their position in relation to their siblings, or for `.changeLayout()`
         * operations where the size of targets change between layouts.
         *
         * NB: This feature requires additional calculations and manipulation to non-hardware-accelerated
         * properties which may adversely affect performance on slower devices, and is therefore
         * disabled by default.
         *
         * @example <caption>Example: Enable the transitioning of target widths and heights</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         animateResizeTargets: true
         *     }
         * });
         *
         * @name        animateResizeTargets
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.animateResizeTargets = false;
        /**
         * A custom function used to manipulate the order in which the stagger delay is
         * incremented when using the ‘stagger’ effect.
         *
         * When using the 'stagger' effect, the delay applied to each target element is incremented
         * based on its index. You may create a custom function to manipulate the order in which the
         * delay is incremented and create engaging non-linear stagger effects.
         *
         * The function receives the index of the target element as a parameter, and must
         * return an integer which serves as the multiplier for the stagger delay.
         *
         * @example <caption>Example 1: Stagger target elements by column in a 3-column grid</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effects: 'fade stagger(100ms)',
         *         staggerSequence: function(i) {
         *             return i % 3;
         *         }
         *     }
         * });
         *
         * @example <caption>Example 2: Using an algorithm to produce a more complex sequence</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effects: 'fade stagger(100ms)',
         *         staggerSequence: function(i) {
         *             return (2*i) - (5*((i/3) - ((1/3) * (i%3))));
         *         }
         *     }
         * });
         *
         * @name        staggerSequence
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {function}
         * @default     null
         */ this.staggerSequence = null;
        /**
         * A boolean dictating whether or not to reverse the direction of `translate`
         * and `rotate` transforms for elements being filtered out.
         *
         * It can be used to create carousel-like animations where elements enter and exit
         * from opposite directions. If enabled, the effect `translateX(-100%)` for elements
         * being filtered in would become `translateX(100%)` for targets being filtered out.
         *
         * This functionality can also be achieved by providing seperate effects
         * strings for `config.animation.effectsIn` and `config.animation.effectsOut`.
         *
         * @example <caption>Example: Reverse the desired direction on any translate/rotate effect for targets being filtered out</caption>
         * // Elements being filtered in will be translated from '100%' to '0' while
         * // elements being filtered out will be translated from 0 to '-100%'
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effects: 'fade translateX(100%)',
         *         reverseOut: true,
         *         nudge: false // Disable nudging to create a carousel-like effect
         *     }
         * });
         *
         * @name        reverseOut
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.reverseOut = false;
        /**
         * A boolean dictating whether or not to "nudge" the animation path of targets
         * when they are being filtered in and out simulatenously.
         *
         * This has been the default behavior of MixItUp since version 1, but it
         * may be desirable to disable this effect when filtering directly from
         * one exclusive set of targets to a different exclusive set of targets,
         * to create a carousel-like effect, or a generally more subtle animation.
         *
         * @example <caption>Example: Disable the "nudging" of targets being filtered in and out simulatenously</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         nudge: false
         *     }
         * });
         *
         * @name        nudge
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.nudge = true;
        /**
         * A boolean dictating whether or not to clamp the height of the container while MixItUp's
         * geometry tests are carried out before an operation.
         *
         * To prevent scroll-bar flicker, clamping is turned on by default. But in the case where the
         * height of the container might affect its vertical positioning in the viewport
         * (e.g. a vertically-centered container), this should be turned off to ensure accurate
         * test results and a smooth animation.
         *
         * @example <caption>Example: Disable container height-clamping</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         clampHeight: false
         *     }
         * });
         *
         * @name        clampHeight
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.clampHeight = true;
        /**
         * A boolean dictating whether or not to clamp the width of the container while MixItUp's
         * geometry tests are carried out before an operation.
         *
         * To prevent scroll-bar flicker, clamping is turned on by default. But in the case where the
         * width of the container might affect its horitzontal positioning in the viewport
         * (e.g. a horizontall-centered container), this should be turned off to ensure accurate
         * test results and a smooth animation.
         *
         * @example <caption>Example: Disable container width-clamping</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         clampWidth: false
         *     }
         * });
         *
         * @name        clampWidth
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.clampWidth = true;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigAnimation);
    mixitup.ConfigAnimation.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigAnimation.prototype.constructor = mixitup.ConfigAnimation;
    /**
     * A group of properties relating to the behavior of the Mixer.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        behavior
     * @namespace
     * @public
     * @since       3.1.12
     */ mixitup.ConfigBehavior = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A boolean dictating whether to allow "live" sorting of the mixer.
         *
         * Because of the expensive nature of sorting, MixItUp makes use of several
         * internal optimizations to skip redundant sorting operations, such as when
         * the newly requested sort command is the same as the active one. The caveat
         * to this optimization is that "live" edits to the value of a target's sorting
         * attribute will be ignored when requesting a re-sort by the same attribute.
         *
         * By setting to `behavior.liveSort` to `true`, the mixer will always re-sort
         * regardless of whether or not the sorting attribute and order have changed.
         *
         * @example <caption>Example: Enabling `liveSort` to allow for re-sorting</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     behavior: {
         *         liveSort: true
         *     },
         *     load: {
         *         sort: 'edited:desc'
         *     }
         * });
         *
         * var target = containerEl.children[3];
         *
         * console.log(target.getAttribute('data-edited')); // '2015-04-24'
         *
         * target.setAttribute('data-edited', '2017-08-10'); // Update the target's edited date
         *
         * mixer.sort('edited:desc')
         *     .then(function(state) {
         *         // The target is now at the top of the list
         *
         *         console.log(state.targets[0] === target); // true
         *     });
         *
         * @name        liveSort
         * @memberof    mixitup.Config.behavior
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.liveSort = false;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigBehavior);
    mixitup.ConfigBehavior.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigBehavior.prototype.constructor = mixitup.ConfigBehavior;
    /**
     * A group of optional callback functions to be invoked at various
     * points within the lifecycle of a mixer operation.
     *
     * Each function is analogous to an event of the same name triggered from the
     * container element, and is invoked immediately after it.
     *
     * All callback functions receive the current `state` object as their first
     * argument, as well as other more specific arguments described below.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        callbacks
     * @namespace
     * @public
     * @since       2.0.0
     */ mixitup.ConfigCallbacks = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A callback function invoked immediately after any MixItUp operation is requested
         * and before animations have begun.
         *
         * A second `futureState` argument is passed to the function which represents the final
         * state of the mixer once the requested operation has completed.
         *
         * @example <caption>Example: Adding an `onMixStart` callback function</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixStart: function(state, futureState) {
         *              console.log('Starting operation...');
         *         }
         *     }
         * });
         *
         * @name        onMixStart
         * @memberof    mixitup.Config.callbacks
         * @instance
         * @type        {function}
         * @default     null
         */ this.onMixStart = null;
        /**
         * A callback function invoked when a MixItUp operation is requested while another
         * operation is in progress, and the animation queue is full, or queueing
         * is disabled.
         *
         * @example <caption>Example: Adding an `onMixBusy` callback function</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixBusy: function(state) {
         *              console.log('Mixer busy');
         *         }
         *     }
         * });
         *
         * @name        onMixBusy
         * @memberof    mixitup.Config.callbacks
         * @instance
         * @type        {function}
         * @default     null
         */ this.onMixBusy = null;
        /**
         * A callback function invoked after any MixItUp operation has completed, and the
         * state has been updated.
         *
         * @example <caption>Example: Adding an `onMixEnd` callback function</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixEnd: function(state) {
         *              console.log('Operation complete');
         *         }
         *     }
         * });
         *
         * @name        onMixEnd
         * @memberof    mixitup.Config.callbacks
         * @instance
         * @type        {function}
         * @default     null
         */ this.onMixEnd = null;
        /**
         * A callback function invoked whenever an operation "fails", i.e. no targets
         * could be found matching the requested filter.
         *
         * @example <caption>Example: Adding an `onMixFail` callback function</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixFail: function(state) {
         *              console.log('No items could be found matching the requested filter');
         *         }
         *     }
         * });
         *
         * @name        onMixFail
         * @memberof    mixitup.Config.callbacks
         * @instance
         * @type        {function}
         * @default     null
         */ this.onMixFail = null;
        /**
         * A callback function invoked whenever a MixItUp control is clicked, and before its
         * respective operation is requested.
         *
         * The clicked element is assigned to the `this` keyword within the function. The original
         * click event is passed to the function as the second argument, which can be useful if
         * using `<a>` tags as controls where the default behavior needs to be prevented.
         *
         * Returning `false` from the callback will prevent the control click from triggering
         * an operation.
         *
         * @example <caption>Example 1: Adding an `onMixClick` callback function</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixClick: function(state, originalEvent) {
         *              console.log('The control "' + this.innerText + '" was clicked');
         *         }
         *     }
         * });
         *
         * @example <caption>Example 2: Using `onMixClick` to manipulate the original click event</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixClick: function(state, originalEvent) {
         *              // Prevent original click event from bubbling up:
         *              originalEvent.stopPropagation();
         *
         *              // Prevent default behavior of clicked element:
         *              originalEvent.preventDefault();
         *         }
         *     }
         * });
         *
         * @example <caption>Example 3: Using `onMixClick` to conditionally cancel operations</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixClick: function(state, originalEvent) {
         *              // Perform some conditional check:
         *
         *              if (myApp.isLoading) {
         *                  // By returning false, we can prevent the control click from triggering an operation.
         *
         *                  return false;
         *              }
         *         }
         *     }
         * });
         *
         * @name        onMixClick
         * @memberof    mixitup.Config.callbacks
         * @instance
         * @type        {function}
         * @default     null
         */ this.onMixClick = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigCallbacks);
    mixitup.ConfigCallbacks.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigCallbacks.prototype.constructor = mixitup.ConfigCallbacks;
    /**
     * A group of properties relating to clickable control elements.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        controls
     * @namespace
     * @public
     * @since       2.0.0
     */ mixitup.ConfigControls = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A boolean dictating whether or not controls should be enabled for the mixer instance.
         *
         * If `true` (default behavior), MixItUp will search the DOM for any clickable elements with
         * `data-filter`, `data-sort` or `data-toggle` attributes, and bind them for click events.
         *
         * If `false`, no click handlers will be bound, and all functionality must therefore be performed
         * via the mixer's API methods.
         *
         * If you do not intend to use the default controls, setting this property to `false` will
         * marginally improve the startup time of your mixer instance, and will also prevent any other active
         * mixer instances in the DOM which are bound to controls from controlling the instance.
         *
         * @example <caption>Example: Disabling controls</caption>
         * var mixer = mixitup(containerEl, {
         *     controls: {
         *         enable: false
         *     }
         * });
         *
         * // With the default controls disabled, we can only control
         * // the mixer via its API methods, e.g.:
         *
         * mixer.filter('.cat-1');
         *
         * @name        enable
         * @memberof    mixitup.Config.controls
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.enable = true;
        /**
         * A boolean dictating whether or not to use event delegation when binding click events
         * to the default controls.
         *
         * If `false` (default behavior), each control button in the DOM will be found and
         * individually bound when a mixer is instantiated, with their corresponding actions
         * cached for performance.
         *
         * If `true`, a single click handler will be applied to the `window` (or container element - see
         * `config.controls.scope`), and any click events triggered by elements with `data-filter`,
         * `data-sort` or `data-toggle` attributes present will be handled as they propagate upwards.
         *
         * If you require a user interface where control buttons may be added, removed, or changed during the
         * lifetime of a mixer, `controls.live` should be set to `true`. There is a marginal but unavoidable
         * performance deficit when using live controls, as the value of each control button must be read
         * from the DOM in real time once the click event has propagated.
         *
         * @example <caption>Example: Setting live controls</caption>
         * var mixer = mixitup(containerEl, {
         *     controls: {
         *         live: true
         *     }
         * });
         *
         * // Control buttons can now be added, remove and changed without breaking
         * // the mixer's UI
         *
         * @name        live
         * @memberof    mixitup.Config.controls
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.live = false;
        /**
         * A string dictating the "scope" to use when binding or querying the default controls. The available
         * values are `'global'` or `'local'`.
         *
         * When set to `'global'` (default behavior), MixItUp will query the entire document for control buttons
         * to bind, or delegate click events from (see `config.controls.live`).
         *
         * When set to `'local'`, MixItUp will only query (or bind click events to) its own container element.
         * This may be desireable if you require multiple active mixer instances within the same document, with
         * controls that would otherwise intefere with each other if scoped globally.
         *
         * Conversely, if you wish to control multiple instances with a single UI, you would create one
         * set of controls and keep the controls scope of each mixer set to `global`.
         *
         * @example <caption>Example: Setting 'local' scoped controls</caption>
         * var mixerOne = mixitup(containerOne, {
         *     controls: {
         *         scope: 'local'
         *     }
         * });
         *
         * var mixerTwo = mixitup(containerTwo, {
         *     controls: {
         *         scope: 'local'
         *     }
         * });
         *
         * // Both mixers can now exist within the same document with
         * // isolated controls placed within their container elements.
         *
         * @name        scope
         * @memberof    mixitup.Config.controls
         * @instance
         * @type        {string}
         * @default     'global'
         */ this.scope = "global"; // enum: ['local' ,'global']
        /**
         * A string dictating the type of logic to apply when concatenating the filter selectors of
         * active toggle buttons (i.e. any clickable element with a `data-toggle` attribute).
         *
         * If set to `'or'` (default behavior), selectors will be concatenated together as
         * a comma-seperated list. For example:
         *
         * `'.cat-1, .cat-2'` (shows any elements matching `'.cat-1'` OR `'.cat-2'`)
         *
         * If set to `'and'`, selectors will be directly concatenated together. For example:
         *
         * `'.cat-1.cat-2'` (shows any elements which match both `'.cat-1'` AND `'.cat-2'`)
         *
         * @example <caption>Example: Setting "and" toggle logic</caption>
         * var mixer = mixitup(containerEl, {
         *     controls: {
         *         toggleLogic: 'and'
         *     }
         * });
         *
         * @name        toggleLogic
         * @memberof    mixitup.Config.controls
         * @instance
         * @type        {string}
         * @default     'or'
         */ this.toggleLogic = "or"; // enum: ['or', 'and']
        /**
         * A string dictating the filter behavior when all toggles are inactive.
         *
         * When set to `'all'` (default behavior), *all* targets will be shown by default
         * when no toggles are active, or at the moment all active toggles are toggled off.
         *
         * When set to `'none'`, no targets will be shown by default when no toggles are
         * active, or at the moment all active toggles are toggled off.
         *
         * @example <caption>Example 1: Setting the default toggle behavior to `'all'`</caption>
         * var mixer = mixitup(containerEl, {
         *     controls: {
         *         toggleDefault: 'all'
         *     }
         * });
         *
         * mixer.toggleOn('.cat-2')
         *     .then(function() {
         *         // Deactivate all active toggles
         *
         *         return mixer.toggleOff('.cat-2')
         *     })
         *     .then(function(state) {
         *          console.log(state.activeFilter.selector); // 'all'
         *          console.log(state.totalShow); // 12
         *     });
         *
         * @example <caption>Example 2: Setting the default toggle behavior to `'none'`</caption>
         * var mixer = mixitup(containerEl, {
         *     controls: {
         *         toggleDefault: 'none'
         *     }
         * });
         *
         * mixer.toggleOn('.cat-2')
         *     .then(function() {
         *         // Deactivate all active toggles
         *
         *         return mixer.toggleOff('.cat-2')
         *     })
         *     .then(function(state) {
         *          console.log(state.activeFilter.selector); // 'none'
         *          console.log(state.totalShow); // 0
         *     });
         *
         * @name        toggleDefault
         * @memberof    mixitup.Config.controls
         * @instance
         * @type        {string}
         * @default     'all'
         */ this.toggleDefault = "all"; // enum: ['all', 'none']
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigControls);
    mixitup.ConfigControls.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigControls.prototype.constructor = mixitup.ConfigControls;
    /**
     * A group of properties defining the output and structure of class names programmatically
     * added to controls and containers to reflect the state of the mixer.
     *
     * Most commonly, class names are added to controls by MixItUp to indicate that
     * the control is active so that it can be styled accordingly - `'mixitup-control-active'` by default.
     *
     * Using a "BEM" like structure, each classname is broken into the three parts:
     * a block namespace (`'mixitup'`), an element name (e.g. `'control'`), and an optional modifier
     * name (e.g. `'active'`) reflecting the state of the element.
     *
     * By default, each part of the classname is concatenated together using single hyphens as
     * delineators, but this can be easily customised to match the naming convention and style of
     * your project.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        classNames
     * @namespace
     * @public
     * @since       3.0.0
     */ mixitup.ConfigClassNames = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * The "block" portion, or top-level namespace added to the start of any class names created by MixItUp.
         *
         * @example <caption>Example 1: changing the `config.classNames.block` value</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         block: 'portfolio'
         *     }
         * });
         *
         * // Active control output: "portfolio-control-active"
         *
         * @example <caption>Example 2: Removing `config.classNames.block`</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         block: ''
         *     }
         * });
         *
         * // Active control output: "control-active"
         *
         * @name        block
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'mixitup'
         */ this.block = "mixitup";
        /**
         * The "element" portion of the class name added to container.
         *
         * @name        elementContainer
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'container'
         */ this.elementContainer = "container";
        /**
         * The "element" portion of the class name added to filter controls.
         *
         * By default, all filter, sort, multimix and toggle controls take the same element value of `'control'`, but
         * each type's element value can be individually overwritten to match the unique classNames of your controls as needed.
         *
         * @example <caption>Example 1: changing the `config.classNames.elementFilter` value</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         elementFilter: 'filter'
         *     }
         * });
         *
         * // Active filter output: "mixitup-filter-active"
         *
         * @example <caption>Example 2: changing the `config.classNames.block` and `config.classNames.elementFilter` values</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         block: 'portfolio',
         *         elementFilter: 'filter'
         *     }
         * });
         *
         * // Active filter output: "portfolio-filter-active"
         *
         * @name        elementFilter
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'control'
         */ this.elementFilter = "control";
        /**
         * The "element" portion of the class name added to sort controls.
         *
         * By default, all filter, sort, multimix and toggle controls take the same element value of `'control'`, but
         * each type's element value can be individually overwritten to match the unique classNames of your controls as needed.
         *
         * @example <caption>Example 1: changing the `config.classNames.elementSort` value</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         elementSort: 'sort'
         *     }
         * });
         *
         * // Active sort output: "mixitup-sort-active"
         *
         * @example <caption>Example 2: changing the `config.classNames.block` and `config.classNames.elementSort` values</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         block: 'portfolio',
         *         elementSort: 'sort'
         *     }
         * });
         *
         * // Active sort output: "portfolio-sort-active"
         *
         * @name        elementSort
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'control'
         */ this.elementSort = "control";
        /**
         * The "element" portion of the class name added to multimix controls.
         *
         * By default, all filter, sort, multimix and toggle controls take the same element value of `'control'`, but
         * each type's element value can be individually overwritten to match the unique classNames of your controls as needed.
         *
         * @example <caption>Example 1: changing the `config.classNames.elementMultimix` value</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         elementMultimix: 'multimix'
         *     }
         * });
         *
         * // Active multimix output: "mixitup-multimix-active"
         *
         * @example <caption>Example 2: changing the `config.classNames.block` and `config.classNames.elementMultimix` values</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         block: 'portfolio',
         *         elementSort: 'multimix'
         *     }
         * });
         *
         * // Active multimix output: "portfolio-multimix-active"
         *
         * @name        elementMultimix
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'control'
         */ this.elementMultimix = "control";
        /**
         * The "element" portion of the class name added to toggle controls.
         *
         * By default, all filter, sort, multimix and toggle controls take the same element value of `'control'`, but
         * each type's element value can be individually overwritten to match the unique classNames of your controls as needed.
         *
         * @example <caption>Example 1: changing the `config.classNames.elementToggle` value</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         elementToggle: 'toggle'
         *     }
         * });
         *
         * // Active toggle output: "mixitup-toggle-active"
         *
         * @example <caption>Example 2: changing the `config.classNames.block` and `config.classNames.elementToggle` values</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         block: 'portfolio',
         *         elementToggle: 'toggle'
         *     }
         * });
         *
         * // Active toggle output: "portfolio-toggle-active"
         *
         * @name        elementToggle
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'control'
         */ this.elementToggle = "control";
        /**
         * The "modifier" portion of the class name added to active controls.
         * @name        modifierActive
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'active'
         */ this.modifierActive = "active";
        /**
         * The "modifier" portion of the class name added to disabled controls.
         *
         * @name        modifierDisabled
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'disabled'
         */ this.modifierDisabled = "disabled";
        /**
         * The "modifier" portion of the class name added to the container when in a "failed" state.
         *
         * @name        modifierFailed
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'failed'
         */ this.modifierFailed = "failed";
        /**
         * The delineator used between the "block" and "element" portions of any class name added by MixItUp.
         *
         * If the block portion is ommited by setting it to an empty string, no delineator will be added.
         *
         * @example <caption>Example: changing the delineator to match BEM convention</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         delineatorElement: '__'
         *     }
         * });
         *
         * // example active control output: "mixitup__control-active"
         *
         * @name        delineatorElement
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     '-'
         */ this.delineatorElement = "-";
        /**
         * The delineator used between the "element" and "modifier" portions of any class name added by MixItUp.
         *
         * If the element portion is ommited by setting it to an empty string, no delineator will be added.
         *
         * @example <caption>Example: changing both delineators to match BEM convention</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         delineatorElement: '__'
         *         delineatorModifier: '--'
         *     }
         * });
         *
         * // Active control output: "mixitup__control--active"
         *
         * @name        delineatorModifier
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     '-'
         */ this.delineatorModifier = "-";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigClassNames);
    mixitup.ConfigClassNames.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigClassNames.prototype.constructor = mixitup.ConfigClassNames;
    /**
     * A group of properties relating to MixItUp's dataset API.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        data
     * @namespace
     * @public
     * @since       3.0.0
     */ mixitup.ConfigData = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A string specifying the name of the key containing your data model's unique
         * identifier (UID). To use the dataset API, a UID key must be specified and
         * be present and unique on all objects in the dataset you provide to MixItUp.
         *
         * For example, if your dataset is made up of MongoDB documents, the UID
         * key would be `'id'` or `'_id'`.
         *
         * @example <caption>Example: Setting the UID to `'id'`</caption>
         * var mixer = mixitup(containerEl, {
         *     data: {
         *         uidKey: 'id'
         *     }
         * });
         *
         * @name        uidKey
         * @memberof    mixitup.Config.data
         * @instance
         * @type        {string}
         * @default     ''
         */ this.uidKey = "";
        /**
         * A boolean dictating whether or not MixItUp should "dirty check" each object in
         * your dataset for changes whenever `.dataset()` is called, and re-render any targets
         * for which a change is found.
         *
         * Depending on the complexity of your data model, dirty checking can be expensive
         * and is therefore disabled by default.
         *
         * NB: For changes to be detected, a new immutable instance of the edited model must be
         * provided to mixitup, rather than manipulating properties on the existing instance.
         * If your changes are a result of a DB write and read, you will most likely be calling
         * `.dataset()` with a clean set of objects each time, so this will not be an issue.
         *
         * @example <caption>Example: Enabling dirty checking</caption>
         *
         * var myDataset = [
         *     {
         *         id: 0,
         *         title: "Blog Post Title 0"
         *         ...
         *     },
         *     {
         *         id: 1,
         *         title: "Blog Post Title 1"
         *         ...
         *     }
         * ];
         *
         * // Instantiate a mixer with a pre-loaded dataset, and a target renderer
         * // function defined
         *
         * var mixer = mixitup(containerEl, {
         *     data: {
         *         uidKey: 'id',
         *         dirtyCheck: true
         *     },
         *     load: {
         *         dataset: myDataset
         *     },
         *     render: {
         *         target: function() { ... }
         *     }
         * });
         *
         * // For illustration, we will clone and edit the second object in the dataset.
         * // NB: this would typically be done server-side in response to a DB update,
         * and then re-queried via an API.
         *
         * myDataset[1] = Object.assign({}, myDataset[1]);
         *
         * myDataset[1].title = 'Blog Post Title 11';
         *
         * mixer.dataset(myDataset)
         *    .then(function() {
         *        // the target with ID "1", will be re-rendered reflecting its new title
         *    });
         *
         * @name        dirtyCheck
         * @memberof    mixitup.Config.data
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.dirtyCheck = false;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigData);
    mixitup.ConfigData.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigData.prototype.constructor = mixitup.ConfigData;
    /**
     * A group of properties allowing the toggling of various debug features.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        debug
     * @namespace
     * @public
     * @since       3.0.0
     */ mixitup.ConfigDebug = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A boolean dictating whether or not the mixer instance returned by the
         * `mixitup()` factory function should expose private properties and methods.
         *
         * By default, mixer instances only expose their public API, but enabling
         * debug mode will give you access to various mixer internals which may aid
         * in debugging, or the authoring of extensions.
         *
         * @example <caption>Example: Enabling debug mode</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     debug: {
         *         enable: true
         *     }
         * });
         *
         * // Private properties and methods will now be visible on the mixer instance:
         *
         * console.log(mixer);
         *
         * @name        enable
         * @memberof    mixitup.Config.debug
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.enable = false;
        /**
         * A boolean dictating whether or not warnings should be shown when various
         * common gotchas occur.
         *
         * Warnings are intended to provide insights during development when something
         * occurs that is not a fatal, but may indicate an issue with your integration,
         * and are therefore turned on by default. However, you may wish to disable
         * them in production.
         *
         * @example <caption>Example 1: Disabling warnings</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     debug: {
         *         showWarnings: false
         *     }
         * });
         *
         * @example <caption>Example 2: Disabling warnings based on environment</caption>
         *
         * var showWarnings = myAppConfig.environment === 'development' ? true : false;
         *
         * var mixer = mixitup(containerEl, {
         *     debug: {
         *         showWarnings: showWarnings
         *     }
         * });
         *
         * @name        showWarnings
         * @memberof    mixitup.Config.debug
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.showWarnings = true;
        /**
         * Used for server-side testing only.
         *
         * @private
         * @name        fauxAsync
         * @memberof    mixitup.Config.debug
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.fauxAsync = false;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigDebug);
    mixitup.ConfigDebug.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigDebug.prototype.constructor = mixitup.ConfigDebug;
    /**
     * A group of properties relating to the layout of the container.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        layout
     * @namespace
     * @public
     * @since       3.0.0
     */ mixitup.ConfigLayout = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A boolean dictating whether or not mixitup should query all descendants
         * of the container for targets, or only immediate children.
         *
         * By default, mixitup will query all descendants matching the
         * `selectors.target` selector when indexing targets upon instantiation.
         * This allows for targets to be nested inside a sub-container which is
         * useful when ring-fencing targets from locally scoped controls in your
         * markup (see `controls.scope`).
         *
         * However, if you are building a more complex UI requiring the nesting
         * of mixers within mixers, you will most likely want to limit targets to
         * immediate children of the container by setting this property to `false`.
         *
         * @example <caption>Example: Restricting targets to immediate children</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     layout: {
         *         allowNestedTargets: false
         *     }
         * });
         *
         * @name        allowNestedTargets
         * @memberof    mixitup.Config.layout
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.allowNestedTargets = true;
        /**
         * A string specifying an optional class name to apply to the container when in
         * its default state.
         *
         * By changing this class name or adding a class name to the container via the
         * `.changeLayout()` API method, the CSS layout of the container can be changed,
         * and MixItUp will attemp to gracefully animate the container and its targets
         * between states.
         *
         * @example <caption>Example 1: Specifying a container class name</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     layout: {
         *         containerClassName: 'grid'
         *     }
         * });
         *
         * @example <caption>Example 2: Changing the default class name with `.changeLayout()`</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     layout: {
         *         containerClassName: 'grid'
         *     }
         * });
         *
         * mixer.changeLayout('list')
         *     .then(function(state) {
         *          console.log(state.activeContainerClass); // "list"
         *     });
         *
         * @name        containerClassName
         * @memberof    mixitup.Config.layout
         * @instance
         * @type        {string}
         * @default     ''
         */ this.containerClassName = "";
        /**
         * A reference to a non-target sibling element after which to insert targets
         * when there are no targets in the container.
         *
         * @example <caption>Example: Setting a `siblingBefore` reference element</caption>
         *
         * var addButton = containerEl.querySelector('button');
         *
         * var mixer = mixitup(containerEl, {
         *     layout: {
         *         siblingBefore: addButton
         *     }
         * });
         *
         * @name        siblingBefore
         * @memberof    mixitup.Config.layout
         * @instance
         * @type        {HTMLElement}
         * @default     null
         */ this.siblingBefore = null;
        /**
         * A reference to a non-target sibling element before which to insert targets
         * when there are no targets in the container.
         *
         * @example <caption>Example: Setting an `siblingAfter` reference element</caption>
         *
         * var gap = containerEl.querySelector('.gap');
         *
         * var mixer = mixitup(containerEl, {
         *     layout: {
         *         siblingAfter: gap
         *     }
         * });
         *
         * @name        siblingAfter
         * @memberof    mixitup.Config.layout
         * @instance
         * @type        {HTMLElement}
         * @default     null
         */ this.siblingAfter = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigLayout);
    mixitup.ConfigLayout.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigLayout.prototype.constructor = mixitup.ConfigLayout;
    /**
     * A group of properties defining the initial state of the mixer on load (instantiation).
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        load
     * @namespace
     * @public
     * @since       2.0.0
     */ mixitup.ConfigLoad = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A string defining any filtering to be statically applied to the mixer on load.
         * As per the `.filter()` API, this can be any valid selector string, or the
         * values `'all'` or `'none'`.
         *
         * @example <caption>Example 1: Defining an initial filter selector to be applied on load</caption>
         *
         * // The mixer will show only those targets matching '.category-a' on load.
         *
         * var mixer = mixitup(containerEl, {
         *     load: {
         *         filter: '.category-a'
         *     }
         * });
         *
         * @example <caption>Example 2: Hiding all targets on load</caption>
         *
         * // The mixer will show hide all targets on load.
         *
         * var mixer = mixitup(containerEl, {
         *     load: {
         *         filter: 'none'
         *     }
         * });
         *
         * @name        filter
         * @memberof    mixitup.Config.load
         * @instance
         * @type        {string}
         * @default     'all'
         */ this.filter = "all";
        /**
         * A string defining any sorting to be statically applied to the mixer on load.
         * As per the `.sort()` API, this should be a valid "sort string" made up of
         * an attribute to sort by (or `'default'`) followed by an optional sorting
         * order, or the value `'random'`;
         *
         * @example <caption>Example: Defining sorting to be applied on load</caption>
         *
         * // The mixer will sort the container by the value of the `data-published-date`
         * // attribute, in descending order.
         *
         * var mixer = mixitup(containerEl, {
         *     load: {
         *         sort: 'published-date:desc'
         *     }
         * });
         *
         * @name        sort
         * @memberof    mixitup.Config.load
         * @instance
         * @type        {string}
         * @default     'default:asc'
         */ this.sort = "default:asc";
        /**
         * An array of objects representing the underlying data of any pre-rendered targets,
         * when using the `.dataset()` API.
         *
         * NB: If targets are pre-rendered when the mixer is instantiated, this must be set.
         *
         * @example <caption>Example: Defining the initial underyling dataset</caption>
         *
         * var myDataset = [
         *     {
         *         id: 0,
         *         title: "Blog Post Title 0",
         *         ...
         *     },
         *     {
         *         id: 1,
         *         title: "Blog Post Title 1",
         *         ...
         *     }
         * ];
         *
         * var mixer = mixitup(containerEl, {
         *     data: {
         *         uidKey: 'id'
         *     },
         *     load: {
         *         dataset: myDataset
         *     }
         * });
         *
         * @name        dataset
         * @memberof    mixitup.Config.load
         * @instance
         * @type        {Array.<object>}
         * @default     null
         */ this.dataset = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigLoad);
    mixitup.ConfigLoad.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigLoad.prototype.constructor = mixitup.ConfigLoad;
    /**
     * A group of properties defining the selectors used to query elements within a mixitup container.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        selectors
     * @namespace
     * @public
     * @since       3.0.0
     */ mixitup.ConfigSelectors = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A selector string used to query and index target elements within the container.
         *
         * By default, the class selector `'.mix'` is used, but this can be changed to an
         * attribute or element selector to match the style of your project.
         *
         * @example <caption>Example 1: Changing the target selector</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     selectors: {
         *         target: '.portfolio-item'
         *     }
         * });
         *
         * @example <caption>Example 2: Using an attribute selector as a target selector</caption>
         *
         * // The mixer will search for any children with the attribute `data-ref="mix"`
         *
         * var mixer = mixitup(containerEl, {
         *     selectors: {
         *         target: '[data-ref="mix"]'
         *     }
         * });
         *
         * @name        target
         * @memberof    mixitup.Config.selectors
         * @instance
         * @type        {string}
         * @default     '.mix'
         */ this.target = ".mix";
        /**
         * A optional selector string used to add further specificity to the querying of control elements,
         * in addition to their mandatory data attribute (e.g. `data-filter`, `data-toggle`, `data-sort`).
         *
         * This can be used if other elements in your document must contain the above attributes
         * (e.g. for use in third-party scripts), and would otherwise interfere with MixItUp. Adding
         * an additional `control` selector of your choice allows MixItUp to restrict event handling
         * to only those elements matching the defined selector.
         *
         * @name        control
         * @memberof    mixitup.Config.selectors
         * @instance
         * @type        {string}
         * @default     ''
         *
         * @example <caption>Example 1: Adding a `selectors.control` selector</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     selectors: {
         *         control: '.mixitup-control'
         *     }
         * });
         *
         * // Will not be handled:
         * // <button data-filter=".category-a"></button>
         *
         * // Will be handled:
         * // <button class="mixitup-control" data-filter=".category-a"></button>
         */ this.control = "";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigSelectors);
    mixitup.ConfigSelectors.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigSelectors.prototype.constructor = mixitup.ConfigSelectors;
    /**
     * A group of optional render functions for creating and updating elements.
     *
     * All render functions receive a data object, and should return a valid HTML string.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        render
     * @namespace
     * @public
     * @since       3.0.0
     */ mixitup.ConfigRender = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A function returning an HTML string representing a target element, or a reference to a
         * single DOM element.
         *
         * The function is invoked as part of the `.dataset()` API, whenever a new item is added
         * to the dataset, or an item in the dataset changes (if `dataset.dirtyCheck` is enabled).
         *
         * The function receives the relevant dataset item as its first parameter.
         *
         * @example <caption>Example 1: Using string concatenation</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     render: {
         *         target: function(item) {
         *             return (
         *                 '&lt;div class="mix"&gt;' +
         *                     '&lt;h2&gt;' + item.title + '&lt;/h2&gt;' +
         *                 '&lt;/div&gt;'
         *             );
         *         }
         *     }
         * });
         *
         * @example <caption>Example 2: Using an ES2015 template literal</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     render: {
         *         target: function(item) {
         *             return (
         *                 `&lt;div class="mix"&gt;
         *                     &lt;h2&gt;${item.title}&lt;/h2&gt;
         *                  &lt;/div&gt;`
         *             );
         *         }
         *     }
         * });
         *
         * @example <caption>Example 3: Using a Handlebars template</caption>
         *
         * var targetTemplate = Handlebars.compile('&lt;div class="mix"&gt;&lt;h2&gt;{{title}}&lt;/h2&gt;&lt;/div&gt;');
         *
         * var mixer = mixitup(containerEl, {
         *     render: {
         *         target: targetTemplate
         *     }
         * });
         *
         * @example <caption>Example 4: Returning a DOM element</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     render: {
         *         target: function(item) {
         *              // Create a single element using your framework's built-in renderer
         *
         *              var el = ...
         *
         *              return el;
         *         }
         *     }
         * });
         *
         * @name        target
         * @memberof    mixitup.Config.render
         * @instance
         * @type        {function}
         * @default     'null'
         */ this.target = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigRender);
    mixitup.ConfigRender.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigRender.prototype.constructor = mixitup.ConfigRender;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.ConfigTemplates = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigTemplates);
    mixitup.ConfigTemplates.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigTemplates.prototype.constructor = mixitup.ConfigTemplates;
    /**
     * `mixitup.Config` is an interface used for customising the functionality of a
     * mixer instance. It is organised into several semantically distinct sub-objects,
     * each one pertaining to a particular aspect of MixItUp functionality.
     *
     * An object literal containing any or all of the available properies,
     * known as the "configuration object", can be passed as the second parameter to
     * the `mixitup` factory function when creating a mixer instance to customise its
     * functionality as needed.
     *
     * If no configuration object is passed, the mixer instance will take on the default
     * configuration values detailed below.
     *
     * @example <caption>Example 1: Creating and passing the configuration object</caption>
     * // Create a configuration object with desired values
     *
     * var config = {
     *     animation: {
     *         enable: false
     *     },
     *     selectors: {
     *         target: '.item'
     *     }
     * };
     *
     * // Pass the configuration object to the mixitup factory function
     *
     * var mixer = mixitup(containerEl, config);
     *
     * @example <caption>Example 2: Passing the configuration object inline</caption>
     * // Typically, the configuration object is passed inline for brevity.
     *
     * var mixer = mixitup(containerEl, {
     *     controls: {
     *         live: true,
     *         toggleLogic: 'and'
     *     }
     * });
     *
     *
     * @constructor
     * @memberof    mixitup
     * @namespace
     * @public
     * @since       2.0.0
     */ mixitup.Config = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.animation = new mixitup.ConfigAnimation();
        this.behavior = new mixitup.ConfigBehavior();
        this.callbacks = new mixitup.ConfigCallbacks();
        this.controls = new mixitup.ConfigControls();
        this.classNames = new mixitup.ConfigClassNames();
        this.data = new mixitup.ConfigData();
        this.debug = new mixitup.ConfigDebug();
        this.layout = new mixitup.ConfigLayout();
        this.load = new mixitup.ConfigLoad();
        this.selectors = new mixitup.ConfigSelectors();
        this.render = new mixitup.ConfigRender();
        this.templates = new mixitup.ConfigTemplates();
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Config);
    mixitup.Config.prototype = Object.create(mixitup.Base.prototype);
    mixitup.Config.prototype.constructor = mixitup.Config;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.MixerDom = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.document = null;
        this.body = null;
        this.container = null;
        this.parent = null;
        this.targets = [];
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.MixerDom);
    mixitup.MixerDom.prototype = Object.create(mixitup.Base.prototype);
    mixitup.MixerDom.prototype.constructor = mixitup.MixerDom;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.UiClassNames = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.base = "";
        this.active = "";
        this.disabled = "";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.UiClassNames);
    mixitup.UiClassNames.prototype = Object.create(mixitup.Base.prototype);
    mixitup.UiClassNames.prototype.constructor = mixitup.UiClassNames;
    /**
     * An object into which all arbitrary arguments sent to '.dataset()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandDataset = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.dataset = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandDataset);
    mixitup.CommandDataset.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandDataset.prototype.constructor = mixitup.CommandDataset;
    /**
     * An object into which all arbitrary arguments sent to '.multimix()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandMultimix = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.filter = null;
        this.sort = null;
        this.insert = null;
        this.remove = null;
        this.changeLayout = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandMultimix);
    mixitup.CommandMultimix.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandMultimix.prototype.constructor = mixitup.CommandMultimix;
    /**
     * An object into which all arbitrary arguments sent to '.filter()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandFilter = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.selector = "";
        this.collection = null;
        this.action = "show"; // enum: ['show', 'hide']
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandFilter);
    mixitup.CommandFilter.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandFilter.prototype.constructor = mixitup.CommandFilter;
    /**
     * An object into which all arbitrary arguments sent to '.sort()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandSort = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.sortString = "";
        this.attribute = "";
        this.order = "asc";
        this.collection = null;
        this.next = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandSort);
    mixitup.CommandSort.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandSort.prototype.constructor = mixitup.CommandSort;
    /**
     * An object into which all arbitrary arguments sent to '.insert()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandInsert = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.index = 0;
        this.collection = [];
        this.position = "before"; // enum: ['before', 'after']
        this.sibling = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandInsert);
    mixitup.CommandInsert.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandInsert.prototype.constructor = mixitup.CommandInsert;
    /**
     * An object into which all arbitrary arguments sent to '.remove()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandRemove = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.targets = [];
        this.collection = [];
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandRemove);
    mixitup.CommandRemove.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandRemove.prototype.constructor = mixitup.CommandRemove;
    /**
     * An object into which all arbitrary arguments sent to '.changeLayout()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandChangeLayout = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.containerClassName = "";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandChangeLayout);
    mixitup.CommandChangeLayout.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandChangeLayout.prototype.constructor = mixitup.CommandChangeLayout;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     * @param       {string}        type
     * @param       {string}        selector
     * @param       {boolean}       [live]
     * @param       {string}        [parent]
     *     An optional string representing the name of the mixer.dom property containing a reference to a parent element.
     */ mixitup.ControlDefinition = function(type, selector, live, parent) {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.type = type;
        this.selector = selector;
        this.live = live || false;
        this.parent = parent || "";
        this.callActions("afterConstruct");
        h.freeze(this);
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ControlDefinition);
    mixitup.ControlDefinition.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ControlDefinition.prototype.constructor = mixitup.ControlDefinition;
    mixitup.controlDefinitions = [];
    mixitup.controlDefinitions.push(new mixitup.ControlDefinition("multimix", "[data-filter][data-sort]"));
    mixitup.controlDefinitions.push(new mixitup.ControlDefinition("filter", "[data-filter]"));
    mixitup.controlDefinitions.push(new mixitup.ControlDefinition("sort", "[data-sort]"));
    mixitup.controlDefinitions.push(new mixitup.ControlDefinition("toggle", "[data-toggle]"));
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Control = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.el = null;
        this.selector = "";
        this.bound = [];
        this.pending = -1;
        this.type = "";
        this.status = "inactive"; // enum: ['inactive', 'active', 'disabled', 'live']
        this.filter = "";
        this.sort = "";
        this.canDisable = false;
        this.handler = null;
        this.classNames = new mixitup.UiClassNames();
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Control);
    mixitup.Control.prototype = Object.create(mixitup.Base.prototype);
    h.extend(mixitup.Control.prototype, /** @lends mixitup.Control */ {
        constructor: mixitup.Control,
        /**
         * @private
         * @param {HTMLElement} el
         * @param {string}      type
         * @param {string}      selector
         */ init: function(el, type, selector) {
            var self = this;
            this.callActions("beforeInit", arguments);
            self.el = el;
            self.type = type;
            self.selector = selector;
            if (self.selector) self.status = "live";
            else {
                self.canDisable = typeof self.el.disable === "boolean";
                switch(self.type){
                    case "filter":
                        self.filter = self.el.getAttribute("data-filter");
                        break;
                    case "toggle":
                        self.filter = self.el.getAttribute("data-toggle");
                        break;
                    case "sort":
                        self.sort = self.el.getAttribute("data-sort");
                        break;
                    case "multimix":
                        self.filter = self.el.getAttribute("data-filter");
                        self.sort = self.el.getAttribute("data-sort");
                        break;
                }
            }
            self.bindClick();
            mixitup.controls.push(self);
            this.callActions("afterInit", arguments);
        },
        /**
         * @private
         * @param  {mixitup.Mixer} mixer
         * @return {boolean}
         */ isBound: function(mixer) {
            var self = this, isBound = false;
            this.callActions("beforeIsBound", arguments);
            isBound = self.bound.indexOf(mixer) > -1;
            return self.callFilters("afterIsBound", isBound, arguments);
        },
        /**
         * @private
         * @param  {mixitup.Mixer} mixer
         * @return {void}
         */ addBinding: function(mixer) {
            var self = this;
            this.callActions("beforeAddBinding", arguments);
            if (!self.isBound()) self.bound.push(mixer);
            this.callActions("afterAddBinding", arguments);
        },
        /**
         * @private
         * @param  {mixitup.Mixer} mixer
         * @return {void}
         */ removeBinding: function(mixer) {
            var self = this, removeIndex = -1;
            this.callActions("beforeRemoveBinding", arguments);
            if ((removeIndex = self.bound.indexOf(mixer)) > -1) self.bound.splice(removeIndex, 1);
            if (self.bound.length < 1) {
                // No bindings exist, unbind event click handlers
                self.unbindClick();
                // Remove from `mixitup.controls` list
                removeIndex = mixitup.controls.indexOf(self);
                mixitup.controls.splice(removeIndex, 1);
                if (self.status === "active") self.renderStatus(self.el, "inactive");
            }
            this.callActions("afterRemoveBinding", arguments);
        },
        /**
         * @private
         * @return {void}
         */ bindClick: function() {
            var self = this;
            this.callActions("beforeBindClick", arguments);
            self.handler = function(e) {
                self.handleClick(e);
            };
            h.on(self.el, "click", self.handler);
            this.callActions("afterBindClick", arguments);
        },
        /**
         * @private
         * @return {void}
         */ unbindClick: function() {
            var self = this;
            this.callActions("beforeUnbindClick", arguments);
            h.off(self.el, "click", self.handler);
            self.handler = null;
            this.callActions("afterUnbindClick", arguments);
        },
        /**
         * @private
         * @param   {MouseEvent} e
         * @return  {void}
         */ handleClick: function(e) {
            var self = this, button = null, mixer = null, isActive = false, returnValue = void 0, command = {}, clone = null, commands = [], i = -1;
            this.callActions("beforeHandleClick", arguments);
            this.pending = 0;
            mixer = self.bound[0];
            if (!self.selector) button = self.el;
            else button = h.closestParent(e.target, mixer.config.selectors.control + self.selector, true, mixer.dom.document);
            if (!button) {
                self.callActions("afterHandleClick", arguments);
                return;
            }
            switch(self.type){
                case "filter":
                    command.filter = self.filter || button.getAttribute("data-filter");
                    break;
                case "sort":
                    command.sort = self.sort || button.getAttribute("data-sort");
                    break;
                case "multimix":
                    command.filter = self.filter || button.getAttribute("data-filter");
                    command.sort = self.sort || button.getAttribute("data-sort");
                    break;
                case "toggle":
                    command.filter = self.filter || button.getAttribute("data-toggle");
                    if (self.status === "live") isActive = h.hasClass(button, self.classNames.active);
                    else isActive = self.status === "active";
                    break;
            }
            for(i = 0; i < self.bound.length; i++){
                // Create a clone of the command for each bound mixer instance
                clone = new mixitup.CommandMultimix();
                h.extend(clone, command);
                commands.push(clone);
            }
            commands = self.callFilters("commandsHandleClick", commands, arguments);
            self.pending = self.bound.length;
            for(i = 0; mixer = self.bound[i]; i++){
                command = commands[i];
                if (!command) continue;
                if (!mixer.lastClicked) mixer.lastClicked = button;
                mixitup.events.fire("mixClick", mixer.dom.container, {
                    state: mixer.state,
                    instance: mixer,
                    originalEvent: e,
                    control: mixer.lastClicked
                }, mixer.dom.document);
                if (typeof mixer.config.callbacks.onMixClick === "function") {
                    returnValue = mixer.config.callbacks.onMixClick.call(mixer.lastClicked, mixer.state, e, mixer);
                    if (returnValue === false) continue;
                }
                if (self.type === "toggle") isActive ? mixer.toggleOff(command.filter) : mixer.toggleOn(command.filter);
                else mixer.multimix(command);
            }
            this.callActions("afterHandleClick", arguments);
        },
        /**
         * @param   {object}          command
         * @param   {Array<string>}   toggleArray
         * @return  {void}
         */ update: function(command, toggleArray) {
            var self = this, actions = new mixitup.CommandMultimix();
            self.callActions("beforeUpdate", arguments);
            self.pending--;
            self.pending = Math.max(0, self.pending);
            if (self.pending > 0) return;
            if (self.status === "live") // Live control (status unknown)
            self.updateLive(command, toggleArray);
            else {
                // Static control
                actions.sort = self.sort;
                actions.filter = self.filter;
                self.callFilters("actionsUpdate", actions, arguments);
                self.parseStatusChange(self.el, command, actions, toggleArray);
            }
            self.callActions("afterUpdate", arguments);
        },
        /**
         * @param   {mixitup.CommandMultimix} command
         * @param   {Array<string>}           toggleArray
         * @return  {void}
         */ updateLive: function(command, toggleArray) {
            var self = this, controlButtons = null, actions = null, button = null, i = -1;
            self.callActions("beforeUpdateLive", arguments);
            if (!self.el) return;
            controlButtons = self.el.querySelectorAll(self.selector);
            for(i = 0; button = controlButtons[i]; i++){
                actions = new mixitup.CommandMultimix();
                switch(self.type){
                    case "filter":
                        actions.filter = button.getAttribute("data-filter");
                        break;
                    case "sort":
                        actions.sort = button.getAttribute("data-sort");
                        break;
                    case "multimix":
                        actions.filter = button.getAttribute("data-filter");
                        actions.sort = button.getAttribute("data-sort");
                        break;
                    case "toggle":
                        actions.filter = button.getAttribute("data-toggle");
                        break;
                }
                actions = self.callFilters("actionsUpdateLive", actions, arguments);
                self.parseStatusChange(button, command, actions, toggleArray);
            }
            self.callActions("afterUpdateLive", arguments);
        },
        /**
         * @param   {HTMLElement}             button
         * @param   {mixitup.CommandMultimix} command
         * @param   {mixitup.CommandMultimix} actions
         * @param   {Array<string>}           toggleArray
         * @return  {void}
         */ parseStatusChange: function(button, command, actions, toggleArray) {
            var self = this, alias = "", toggle = "", i = -1;
            self.callActions("beforeParseStatusChange", arguments);
            switch(self.type){
                case "filter":
                    if (command.filter === actions.filter) self.renderStatus(button, "active");
                    else self.renderStatus(button, "inactive");
                    break;
                case "multimix":
                    if (command.sort === actions.sort && command.filter === actions.filter) self.renderStatus(button, "active");
                    else self.renderStatus(button, "inactive");
                    break;
                case "sort":
                    if (command.sort.match(/:asc/g)) alias = command.sort.replace(/:asc/g, "");
                    if (command.sort === actions.sort || alias === actions.sort) self.renderStatus(button, "active");
                    else self.renderStatus(button, "inactive");
                    break;
                case "toggle":
                    if (toggleArray.length < 1) self.renderStatus(button, "inactive");
                    if (command.filter === actions.filter) self.renderStatus(button, "active");
                    for(i = 0; i < toggleArray.length; i++){
                        toggle = toggleArray[i];
                        if (toggle === actions.filter) {
                            // Button matches one active toggle
                            self.renderStatus(button, "active");
                            break;
                        }
                        self.renderStatus(button, "inactive");
                    }
                    break;
            }
            self.callActions("afterParseStatusChange", arguments);
        },
        /**
         * @param   {HTMLElement}   button
         * @param   {string}        status
         * @return  {void}
         */ renderStatus: function(button, status) {
            var self = this;
            self.callActions("beforeRenderStatus", arguments);
            switch(status){
                case "active":
                    h.addClass(button, self.classNames.active);
                    h.removeClass(button, self.classNames.disabled);
                    if (self.canDisable) self.el.disabled = false;
                    break;
                case "inactive":
                    h.removeClass(button, self.classNames.active);
                    h.removeClass(button, self.classNames.disabled);
                    if (self.canDisable) self.el.disabled = false;
                    break;
                case "disabled":
                    if (self.canDisable) self.el.disabled = true;
                    h.addClass(button, self.classNames.disabled);
                    h.removeClass(button, self.classNames.active);
                    break;
            }
            if (self.status !== "live") // Update the control's status propery if not live
            self.status = status;
            self.callActions("afterRenderStatus", arguments);
        }
    });
    mixitup.controls = [];
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.StyleData = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.x = 0;
        this.y = 0;
        this.top = 0;
        this.right = 0;
        this.bottom = 0;
        this.left = 0;
        this.width = 0;
        this.height = 0;
        this.marginRight = 0;
        this.marginBottom = 0;
        this.opacity = 0;
        this.scale = new mixitup.TransformData();
        this.translateX = new mixitup.TransformData();
        this.translateY = new mixitup.TransformData();
        this.translateZ = new mixitup.TransformData();
        this.rotateX = new mixitup.TransformData();
        this.rotateY = new mixitup.TransformData();
        this.rotateZ = new mixitup.TransformData();
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.StyleData);
    mixitup.StyleData.prototype = Object.create(mixitup.Base.prototype);
    mixitup.StyleData.prototype.constructor = mixitup.StyleData;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.TransformData = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.value = 0;
        this.unit = "";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.TransformData);
    mixitup.TransformData.prototype = Object.create(mixitup.Base.prototype);
    mixitup.TransformData.prototype.constructor = mixitup.TransformData;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.TransformDefaults = function() {
        mixitup.StyleData.apply(this);
        this.callActions("beforeConstruct");
        this.scale.value = 0.01;
        this.scale.unit = "";
        this.translateX.value = 20;
        this.translateX.unit = "px";
        this.translateY.value = 20;
        this.translateY.unit = "px";
        this.translateZ.value = 20;
        this.translateZ.unit = "px";
        this.rotateX.value = 90;
        this.rotateX.unit = "deg";
        this.rotateY.value = 90;
        this.rotateY.unit = "deg";
        this.rotateX.value = 90;
        this.rotateX.unit = "deg";
        this.rotateZ.value = 180;
        this.rotateZ.unit = "deg";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.TransformDefaults);
    mixitup.TransformDefaults.prototype = Object.create(mixitup.StyleData.prototype);
    mixitup.TransformDefaults.prototype.constructor = mixitup.TransformDefaults;
    /**
     * @private
     * @static
     * @since   3.0.0
     * @type    {mixitup.TransformDefaults}
     */ mixitup.transformDefaults = new mixitup.TransformDefaults();
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.EventDetail = function() {
        this.state = null;
        this.futureState = null;
        this.instance = null;
        this.originalEvent = null;
    };
    /**
     * The `mixitup.Events` class contains all custom events dispatched by MixItUp at various
     * points within the lifecycle of a mixer operation.
     *
     * Each event is analogous to the callback function of the same name defined in
     * the `callbacks` configuration object, and is triggered immediately before it.
     *
     * Events are always triggered from the container element on which MixItUp is instantiated
     * upon.
     *
     * As with any event, registered event handlers receive the event object as a parameter
     * which includes a `detail` property containting references to the current `state`,
     * the `mixer` instance, and other event-specific properties described below.
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @public
     * @since       3.0.0
     */ mixitup.Events = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A custom event triggered immediately after any MixItUp operation is requested
         * and before animations have begun.
         *
         * The `mixStart` event also exposes a `futureState` property via the
         * `event.detail` object, which represents the final state of the mixer once
         * the requested operation has completed.
         *
         * @name        mixStart
         * @memberof    mixitup.Events
         * @static
         * @type        {CustomEvent}
         */ this.mixStart = null;
        /**
         * A custom event triggered when a MixItUp operation is requested while another
         * operation is in progress, and the animation queue is full, or queueing
         * is disabled.
         *
         * @name        mixBusy
         * @memberof    mixitup.Events
         * @static
         * @type        {CustomEvent}
         */ this.mixBusy = null;
        /**
         * A custom event triggered after any MixItUp operation has completed, and the
         * state has been updated.
         *
         * @name        mixEnd
         * @memberof    mixitup.Events
         * @static
         * @type        {CustomEvent}
         */ this.mixEnd = null;
        /**
         * A custom event triggered whenever a filter operation "fails", i.e. no targets
         * could be found matching the requested filter.
         *
         * @name        mixFail
         * @memberof    mixitup.Events
         * @static
         * @type        {CustomEvent}
         */ this.mixFail = null;
        /**
         * A custom event triggered whenever a MixItUp control is clicked, and before its
         * respective operation is requested.
         *
         * This event also exposes an `originalEvent` property via the `event.detail`
         * object, which holds a reference to the original click event.
         *
         * @name        mixClick
         * @memberof    mixitup.Events
         * @static
         * @type        {CustomEvent}
         */ this.mixClick = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Events);
    mixitup.Events.prototype = Object.create(mixitup.Base.prototype);
    mixitup.Events.prototype.constructor = mixitup.Events;
    /**
     * @private
     * @param   {string}      eventType
     * @param   {Element}     el
     * @param   {object}      detail
     * @param   {Document}    [doc]
     */ mixitup.Events.prototype.fire = function(eventType, el, detail, doc) {
        var self = this, event = null, eventDetail = new mixitup.EventDetail();
        self.callActions("beforeFire", arguments);
        if (typeof self[eventType] === "undefined") throw new Error('Event type "' + eventType + '" not found.');
        eventDetail.state = new mixitup.State();
        h.extend(eventDetail.state, detail.state);
        if (detail.futureState) {
            eventDetail.futureState = new mixitup.State();
            h.extend(eventDetail.futureState, detail.futureState);
        }
        eventDetail.instance = detail.instance;
        if (detail.originalEvent) eventDetail.originalEvent = detail.originalEvent;
        event = h.getCustomEvent(eventType, eventDetail, doc);
        self.callFilters("eventFire", event, arguments);
        el.dispatchEvent(event);
    };
    // Asign a singleton instance to `mixitup.events`:
    mixitup.events = new mixitup.Events();
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.QueueItem = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.args = [];
        this.instruction = null;
        this.triggerElement = null;
        this.deferred = null;
        this.isToggling = false;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.QueueItem);
    mixitup.QueueItem.prototype = Object.create(mixitup.Base.prototype);
    mixitup.QueueItem.prototype.constructor = mixitup.QueueItem;
    /**
     * The `mixitup.Mixer` class is used to hold discreet, user-configured
     * instances of MixItUp on a provided container element.
     *
     * Mixer instances are returned whenever the `mixitup()` factory function is called,
     * which expose a range of methods enabling API-based filtering, sorting,
     * insertion, removal and more.
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @public
     * @since       3.0.0
     */ mixitup.Mixer = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.config = new mixitup.Config();
        this.id = "";
        this.isBusy = false;
        this.isToggling = false;
        this.incPadding = true;
        this.controls = [];
        this.targets = [];
        this.origOrder = [];
        this.cache = {};
        this.toggleArray = [];
        this.targetsMoved = 0;
        this.targetsImmovable = 0;
        this.targetsBound = 0;
        this.targetsDone = 0;
        this.staggerDuration = 0;
        this.effectsIn = null;
        this.effectsOut = null;
        this.transformIn = [];
        this.transformOut = [];
        this.queue = [];
        this.state = null;
        this.lastOperation = null;
        this.lastClicked = null;
        this.userCallback = null;
        this.userDeferred = null;
        this.dom = new mixitup.MixerDom();
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Mixer);
    mixitup.Mixer.prototype = Object.create(mixitup.Base.prototype);
    h.extend(mixitup.Mixer.prototype, /** @lends mixitup.Mixer */ {
        constructor: mixitup.Mixer,
        /**
         * @private
         * @instance
         * @since 3.0.0
         * @param {HTMLElement} container
         * @param {HTMLElement} document
         * @param {string}      id
         * @param {object}      [config]
         */ attach: function(container, document1, id, config) {
            var self = this, target = null, i = -1;
            self.callActions("beforeAttach", arguments);
            self.id = id;
            if (config) h.extend(self.config, config, true, true);
            self.sanitizeConfig();
            self.cacheDom(container, document1);
            if (self.config.layout.containerClassName) h.addClass(self.dom.container, self.config.layout.containerClassName);
            if (!mixitup.features.has.transitions) self.config.animation.enable = false;
            if (typeof window1.console === "undefined") self.config.debug.showWarnings = false;
            if (self.config.data.uidKey) // If the dataset API is in use, force disable controls
            self.config.controls.enable = false;
            self.indexTargets();
            self.state = self.getInitialState();
            for(i = 0; target = self.lastOperation.toHide[i]; i++)target.hide();
            if (self.config.controls.enable) {
                self.initControls();
                self.buildToggleArray(null, self.state);
                self.updateControls({
                    filter: self.state.activeFilter,
                    sort: self.state.activeSort
                });
            }
            self.parseEffects();
            self.callActions("afterAttach", arguments);
        },
        /**
         * @private
         * @instance
         * @since 3.0.0
         * @return {void}
         */ sanitizeConfig: function() {
            var self = this;
            self.callActions("beforeSanitizeConfig", arguments);
            // Sanitize enum/string config options
            self.config.controls.scope = self.config.controls.scope.toLowerCase().trim();
            self.config.controls.toggleLogic = self.config.controls.toggleLogic.toLowerCase().trim();
            self.config.controls.toggleDefault = self.config.controls.toggleDefault.toLowerCase().trim();
            self.config.animation.effects = self.config.animation.effects.trim();
            self.callActions("afterSanitizeConfig", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @return  {mixitup.State}
         */ getInitialState: function() {
            var self = this, state = new mixitup.State(), operation = new mixitup.Operation();
            self.callActions("beforeGetInitialState", arguments);
            // Map initial values into a mock state object in order to construct an operation
            state.activeContainerClassName = self.config.layout.containerClassName;
            if (self.config.load.dataset) {
                // Dataset API
                if (!self.config.data.uidKey || typeof self.config.data.uidKey !== "string") throw new TypeError(mixitup.messages.errorConfigDataUidKeyNotSet());
                operation.startDataset = operation.newDataset = state.activeDataset = self.config.load.dataset.slice();
                operation.startContainerClassName = operation.newContainerClassName = state.activeContainerClassName;
                operation.show = self.targets.slice();
                state = self.callFilters("stateGetInitialState", state, arguments);
            } else {
                // DOM API
                state.activeFilter = self.parseFilterArgs([
                    self.config.load.filter
                ]).command;
                state.activeSort = self.parseSortArgs([
                    self.config.load.sort
                ]).command;
                state.totalTargets = self.targets.length;
                state = self.callFilters("stateGetInitialState", state, arguments);
                if (state.activeSort.collection || state.activeSort.attribute || state.activeSort.order === "random" || state.activeSort.order === "desc") {
                    // Sorting on load
                    operation.newSort = state.activeSort;
                    self.sortOperation(operation);
                    self.printSort(false, operation);
                    self.targets = operation.newOrder;
                } else operation.startOrder = operation.newOrder = self.targets;
                operation.startFilter = operation.newFilter = state.activeFilter;
                operation.startSort = operation.newSort = state.activeSort;
                operation.startContainerClassName = operation.newContainerClassName = state.activeContainerClassName;
                if (operation.newFilter.selector === "all") operation.newFilter.selector = self.config.selectors.target;
                else if (operation.newFilter.selector === "none") operation.newFilter.selector = "";
            }
            operation = self.callFilters("operationGetInitialState", operation, [
                state
            ]);
            self.lastOperation = operation;
            if (operation.newFilter) self.filterOperation(operation);
            state = self.buildState(operation);
            return state;
        },
        /**
         * Caches references of DOM elements neccessary for the mixer's functionality.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {HTMLElement}       el
         * @param   {HTMLHtmlElement}   document
         * @return  {void}
         */ cacheDom: function(el, document1) {
            var self = this;
            self.callActions("beforeCacheDom", arguments);
            self.dom.document = document1;
            self.dom.body = self.dom.document.querySelector("body");
            self.dom.container = el;
            self.dom.parent = el;
            self.callActions("afterCacheDom", arguments);
        },
        /**
         * Indexes all child elements of the mixer matching the `selectors.target`
         * selector, instantiating a mixitup.Target for each one.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @return  {void}
         */ indexTargets: function() {
            var self = this, target = null, el = null, dataset = null, i = -1;
            self.callActions("beforeIndexTargets", arguments);
            self.dom.targets = self.config.layout.allowNestedTargets ? self.dom.container.querySelectorAll(self.config.selectors.target) : h.children(self.dom.container, self.config.selectors.target, self.dom.document);
            self.dom.targets = h.arrayFromList(self.dom.targets);
            self.targets = [];
            if ((dataset = self.config.load.dataset) && dataset.length !== self.dom.targets.length) throw new Error(mixitup.messages.errorDatasetPrerenderedMismatch());
            if (self.dom.targets.length) {
                for(i = 0; el = self.dom.targets[i]; i++){
                    target = new mixitup.Target();
                    target.init(el, self, dataset ? dataset[i] : void 0);
                    target.isInDom = true;
                    self.targets.push(target);
                }
                self.dom.parent = self.dom.targets[0].parentElement === self.dom.container ? self.dom.container : self.dom.targets[0].parentElement;
            }
            self.origOrder = self.targets;
            self.callActions("afterIndexTargets", arguments);
        },
        initControls: function() {
            var self = this, definition = "", controlElements = null, el = null, parent = null, delagators = null, control = null, i = -1, j = -1;
            self.callActions("beforeInitControls", arguments);
            switch(self.config.controls.scope){
                case "local":
                    parent = self.dom.container;
                    break;
                case "global":
                    parent = self.dom.document;
                    break;
                default:
                    throw new Error(mixitup.messages.errorConfigInvalidControlsScope());
            }
            for(i = 0; definition = mixitup.controlDefinitions[i]; i++)if (self.config.controls.live || definition.live) {
                if (definition.parent) {
                    delagators = self.dom[definition.parent];
                    if (!delagators || delagators.length < 0) continue;
                    if (typeof delagators.length !== "number") delagators = [
                        delagators
                    ];
                } else delagators = [
                    parent
                ];
                for(j = 0; el = delagators[j]; j++){
                    control = self.getControl(el, definition.type, definition.selector);
                    self.controls.push(control);
                }
            } else {
                controlElements = parent.querySelectorAll(self.config.selectors.control + definition.selector);
                for(j = 0; el = controlElements[j]; j++){
                    control = self.getControl(el, definition.type, "");
                    if (!control) continue;
                    self.controls.push(control);
                }
            }
            self.callActions("afterInitControls", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {HTMLElement} el
         * @param   {string}      type
         * @param   {string}      selector
         * @return  {mixitup.Control|null}
         */ getControl: function(el, type, selector) {
            var self = this, control = null, i = -1;
            self.callActions("beforeGetControl", arguments);
            if (!selector) // Static controls only
            for(i = 0; control = mixitup.controls[i]; i++){
                if (control.el === el && control.isBound(self)) // Control already bound to this mixer (as another type).
                // NB: This prevents duplicate controls from being registered where a selector
                // might collide, eg: "[data-filter]" and "[data-filter][data-sort]"
                return self.callFilters("controlGetControl", null, arguments);
                else if (control.el === el && control.type === type && control.selector === selector) {
                    // Another mixer is already using this control, add this mixer as a binding
                    control.addBinding(self);
                    return self.callFilters("controlGetControl", control, arguments);
                }
            }
            // Create new control
            control = new mixitup.Control();
            control.init(el, type, selector);
            control.classNames.base = h.getClassname(self.config.classNames, type);
            control.classNames.active = h.getClassname(self.config.classNames, type, self.config.classNames.modifierActive);
            control.classNames.disabled = h.getClassname(self.config.classNames, type, self.config.classNames.modifierDisabled);
            // Add a reference to this mixer as a binding
            control.addBinding(self);
            return self.callFilters("controlGetControl", control, arguments);
        },
        /**
         * Creates a compound selector by joining the `toggleArray` value as per the
         * defined toggle logic.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @return  {string}
         */ getToggleSelector: function() {
            var self = this, delineator = self.config.controls.toggleLogic === "or" ? ", " : "", toggleSelector = "";
            self.callActions("beforeGetToggleSelector", arguments);
            self.toggleArray = h.clean(self.toggleArray);
            toggleSelector = self.toggleArray.join(delineator);
            if (toggleSelector === "") toggleSelector = self.config.controls.toggleDefault;
            return self.callFilters("selectorGetToggleSelector", toggleSelector, arguments);
        },
        /**
         * Breaks compound selector strings in an array of discreet selectors,
         * as per the active `controls.toggleLogic` configuration option. Accepts
         * either a dynamic command object, or a state object.
         *
         * @private
         * @instance
         * @since   2.0.0
         * @param   {object}        [command]
         * @param   {mixitup.State} [state]
         * @return  {void}
         */ buildToggleArray: function(command, state) {
            var self = this, activeFilterSelector = "";
            self.callActions("beforeBuildToggleArray", arguments);
            if (command && command.filter) activeFilterSelector = command.filter.selector.replace(/\s/g, "");
            else if (state) activeFilterSelector = state.activeFilter.selector.replace(/\s/g, "");
            else return;
            if (activeFilterSelector === self.config.selectors.target || activeFilterSelector === "all") activeFilterSelector = "";
            if (self.config.controls.toggleLogic === "or") self.toggleArray = activeFilterSelector.split(",");
            else self.toggleArray = self.splitCompoundSelector(activeFilterSelector);
            self.toggleArray = h.clean(self.toggleArray);
            self.callActions("afterBuildToggleArray", arguments);
        },
        /**
         * Takes a compound selector (e.g. `.cat-1.cat-2`, `[data-cat="1"][data-cat="2"]`)
         * and breaks into its individual selectors.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {string} compoundSelector
         * @return  {string[]}
         */ splitCompoundSelector: function(compoundSelector) {
            // Break at a `.` or `[`, capturing the delineator
            var partials = compoundSelector.split(/([\.\[])/g), toggleArray = [], selector = "", i = -1;
            if (partials[0] === "") partials.shift();
            for(i = 0; i < partials.length; i++){
                if (i % 2 === 0) selector = "";
                selector += partials[i];
                if (i % 2 !== 0) toggleArray.push(selector);
            }
            return toggleArray;
        },
        /**
         * Updates controls to their active/inactive state based on the command or
         * current state of the mixer.
         *
         * @private
         * @instance
         * @since   2.0.0
         * @param   {object} command
         * @return  {void}
         */ updateControls: function(command) {
            var self = this, control = null, output = new mixitup.CommandMultimix(), i = -1;
            self.callActions("beforeUpdateControls", arguments);
            // Sanitise to defaults
            if (command.filter) output.filter = command.filter.selector;
            else output.filter = self.state.activeFilter.selector;
            if (command.sort) output.sort = self.buildSortString(command.sort);
            else output.sort = self.buildSortString(self.state.activeSort);
            if (output.filter === self.config.selectors.target) output.filter = "all";
            if (output.filter === "") output.filter = "none";
            h.freeze(output);
            for(i = 0; control = self.controls[i]; i++)control.update(output, self.toggleArray);
            self.callActions("afterUpdateControls", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {mixitup.CommandSort}   command
         * @return  {string}
         */ buildSortString: function(command) {
            var self = this;
            var output = "";
            output += command.sortString;
            if (command.next) output += " " + self.buildSortString(command.next);
            return output;
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {object}        command
         * @param   {Operation}     operation
         * @return  {Promise.<mixitup.State>}
         */ insertTargets: function(command, operation) {
            var self = this, nextSibling = null, insertionIndex = -1, frag = null, target = null, el = null, i = -1;
            self.callActions("beforeInsertTargets", arguments);
            if (typeof command.index === "undefined") command.index = 0;
            nextSibling = self.getNextSibling(command.index, command.sibling, command.position);
            frag = self.dom.document.createDocumentFragment();
            if (nextSibling) insertionIndex = h.index(nextSibling, self.config.selectors.target);
            else insertionIndex = self.targets.length;
            if (command.collection) {
                for(i = 0; el = command.collection[i]; i++){
                    if (self.dom.targets.indexOf(el) > -1) throw new Error(mixitup.messages.errorInsertPreexistingElement());
                    // Ensure elements are hidden when they are added to the DOM, so they can
                    // be animated in gracefully
                    el.style.display = "none";
                    frag.appendChild(el);
                    frag.appendChild(self.dom.document.createTextNode(" "));
                    if (!h.isElement(el, self.dom.document) || !el.matches(self.config.selectors.target)) continue;
                    target = new mixitup.Target();
                    target.init(el, self);
                    target.isInDom = true;
                    self.targets.splice(insertionIndex, 0, target);
                    insertionIndex++;
                }
                self.dom.parent.insertBefore(frag, nextSibling);
            }
            // Since targets have been added, the original order must be updated
            operation.startOrder = self.origOrder = self.targets;
            self.callActions("afterInsertTargets", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Number}      [index]
         * @param   {Element}     [sibling]
         * @param   {string}      [position]
         * @return  {Element}
         */ getNextSibling: function(index, sibling, position) {
            var self = this, element = null;
            index = Math.max(index, 0);
            if (sibling && position === "before") // Explicit sibling
            element = sibling;
            else if (sibling && position === "after") // Explicit sibling
            element = sibling.nextElementSibling || null;
            else if (self.targets.length > 0 && typeof index !== "undefined") // Index and targets exist
            element = index < self.targets.length || !self.targets.length ? self.targets[index].dom.el : self.targets[self.targets.length - 1].dom.el.nextElementSibling;
            else if (self.targets.length === 0 && self.dom.parent.children.length > 0) {
                // No targets but other siblings
                if (self.config.layout.siblingAfter) element = self.config.layout.siblingAfter;
                else if (self.config.layout.siblingBefore) element = self.config.layout.siblingBefore.nextElementSibling;
                else self.dom.parent.children[0];
            } else element;
            return self.callFilters("elementGetNextSibling", element, arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ filterOperation: function(operation) {
            var self = this, testResult = false, index = -1, action = "", target = null, i = -1;
            self.callActions("beforeFilterOperation", arguments);
            action = operation.newFilter.action;
            for(i = 0; target = operation.newOrder[i]; i++){
                if (operation.newFilter.collection) // show via collection
                testResult = operation.newFilter.collection.indexOf(target.dom.el) > -1;
                else // show via selector
                if (operation.newFilter.selector === "") testResult = false;
                else testResult = target.dom.el.matches(operation.newFilter.selector);
                self.evaluateHideShow(testResult, target, action, operation);
            }
            if (operation.toRemove.length) {
                for(i = 0; target = operation.show[i]; i++)if (operation.toRemove.indexOf(target) > -1) {
                    // If any shown targets should be removed, move them into the toHide array
                    operation.show.splice(i, 1);
                    if ((index = operation.toShow.indexOf(target)) > -1) operation.toShow.splice(index, 1);
                    operation.toHide.push(target);
                    operation.hide.push(target);
                    i--;
                }
            }
            operation.matching = operation.show.slice();
            if (operation.show.length === 0 && operation.newFilter.selector !== "" && self.targets.length !== 0) operation.hasFailed = true;
            self.callActions("afterFilterOperation", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {boolean}   testResult
         * @param   {Element}   target
         * @param   {string}    action
         * @param   {Operation} operation
         * @return  {void}
         */ evaluateHideShow: function(testResult, target, action, operation) {
            var self = this, filteredTestResult = false, args = Array.prototype.slice.call(arguments, 1);
            filteredTestResult = self.callFilters("testResultEvaluateHideShow", testResult, args);
            self.callActions("beforeEvaluateHideShow", arguments);
            if (filteredTestResult === true && action === "show" || filteredTestResult === false && action === "hide") {
                operation.show.push(target);
                !target.isShown && operation.toShow.push(target);
            } else {
                operation.hide.push(target);
                target.isShown && operation.toHide.push(target);
            }
            self.callActions("afterEvaluateHideShow", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ sortOperation: function(operation) {
            var self = this, newOrder = [], target = null, el = null, i = -1;
            self.callActions("beforeSortOperation", arguments);
            operation.startOrder = self.targets;
            if (operation.newSort.collection) {
                // Sort by collection
                newOrder = [];
                for(i = 0; el = operation.newSort.collection[i]; i++){
                    if (self.dom.targets.indexOf(el) < 0) throw new Error(mixitup.messages.errorSortNonExistentElement());
                    target = new mixitup.Target();
                    target.init(el, self);
                    target.isInDom = true;
                    newOrder.push(target);
                }
                operation.newOrder = newOrder;
            } else if (operation.newSort.order === "random") // Sort random
            operation.newOrder = h.arrayShuffle(operation.startOrder);
            else if (operation.newSort.attribute === "") {
                // Sort by default
                operation.newOrder = self.origOrder.slice();
                if (operation.newSort.order === "desc") operation.newOrder.reverse();
            } else {
                // Sort by attribute
                operation.newOrder = operation.startOrder.slice();
                operation.newOrder.sort(function(a, b) {
                    return self.compare(a, b, operation.newSort);
                });
            }
            if (h.isEqualArray(operation.newOrder, operation.startOrder)) operation.willSort = false;
            self.callActions("afterSortOperation", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {mixitup.Target}        a
         * @param   {mixitup.Target}        b
         * @param   {mixitup.CommandSort}   command
         * @return  {Number}
         */ compare: function(a, b, command) {
            var self = this, order = command.order, attrA = self.getAttributeValue(a, command.attribute), attrB = self.getAttributeValue(b, command.attribute);
            if (isNaN(attrA * 1) || isNaN(attrB * 1)) {
                attrA = attrA.toLowerCase();
                attrB = attrB.toLowerCase();
            } else {
                attrA = attrA * 1;
                attrB = attrB * 1;
            }
            if (attrA < attrB) return order === "asc" ? -1 : 1;
            if (attrA > attrB) return order === "asc" ? 1 : -1;
            if (attrA === attrB && command.next) return self.compare(a, b, command.next);
            return 0;
        },
        /**
         * Reads the values of any data attributes present the provided target element
         * which match the current sort command.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {mixitup.Target}    target
         * @param   {string}            [attribute]
         * @return  {(String|Number)}
         */ getAttributeValue: function(target, attribute) {
            var self = this, value = "";
            value = target.dom.el.getAttribute("data-" + attribute);
            if (value === null) {
                if (self.config.debug.showWarnings) // Encourage users to assign values to all targets to avoid erroneous sorting
                // when types are mixed
                console.warn(mixitup.messages.warningInconsistentSortingAttributes({
                    attribute: "data-" + attribute
                }));
            }
            // If an attribute is not present, return 0 as a safety value
            return self.callFilters("valueGetAttributeValue", value || 0, arguments);
        },
        /**
         * Inserts elements into the DOM in the appropriate
         * order using a document fragment for minimal
         * DOM thrashing
         *
         * @private
         * @instance
         * @since   2.0.0
         * @param   {boolean}   isResetting
         * @param   {Operation} operation
         * @return  {void}
         */ printSort: function(isResetting, operation) {
            var self = this, startOrder = isResetting ? operation.newOrder : operation.startOrder, newOrder = isResetting ? operation.startOrder : operation.newOrder, nextSibling = startOrder.length ? startOrder[startOrder.length - 1].dom.el.nextElementSibling : null, frag = window1.document.createDocumentFragment(), whitespace = null, target = null, el = null, i = -1;
            self.callActions("beforePrintSort", arguments);
            // Empty the container
            for(i = 0; target = startOrder[i]; i++){
                el = target.dom.el;
                if (el.style.position === "absolute") continue;
                h.removeWhitespace(el.previousSibling);
                el.parentElement.removeChild(el);
            }
            whitespace = nextSibling ? nextSibling.previousSibling : self.dom.parent.lastChild;
            if (whitespace && whitespace.nodeName === "#text") h.removeWhitespace(whitespace);
            for(i = 0; target = newOrder[i]; i++){
                // Add targets into a document fragment
                el = target.dom.el;
                if (h.isElement(frag.lastChild)) frag.appendChild(window1.document.createTextNode(" "));
                frag.appendChild(el);
            }
            // Insert the document fragment into the container
            // before any other non-target elements
            if (self.dom.parent.firstChild && self.dom.parent.firstChild !== nextSibling) frag.insertBefore(window1.document.createTextNode(" "), frag.childNodes[0]);
            if (nextSibling) {
                frag.appendChild(window1.document.createTextNode(" "));
                self.dom.parent.insertBefore(frag, nextSibling);
            } else self.dom.parent.appendChild(frag);
            self.callActions("afterPrintSort", arguments);
        },
        /**
         * Parses user-defined sort strings (i.e. `default:asc`) into sort commands objects.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {string}                sortString
         * @param   {mixitup.CommandSort}   command
         * @return  {mixitup.CommandSort}
         */ parseSortString: function(sortString, command) {
            var self = this, rules = sortString.split(" "), current = command, rule = [], i = -1;
            // command.sortString = sortString;
            for(i = 0; i < rules.length; i++){
                rule = rules[i].split(":");
                current.sortString = rules[i];
                current.attribute = h.dashCase(rule[0]);
                current.order = rule[1] || "asc";
                switch(current.attribute){
                    case "default":
                        // treat "default" as sorting by no attribute
                        current.attribute = "";
                        break;
                    case "random":
                        // treat "random" as an order not an attribute
                        current.attribute = "";
                        current.order = "random";
                        break;
                }
                if (!current.attribute || current.order === "random") break;
                if (i < rules.length - 1) {
                    // Embed reference to the next command
                    current.next = new mixitup.CommandSort();
                    h.freeze(current);
                    current = current.next;
                }
            }
            return self.callFilters("commandsParseSort", command, arguments);
        },
        /**
         * Parses all effects out of the user-defined `animation.effects` string into
         * their respective properties and units.
         *
         * @private
         * @instance
         * @since   2.0.0
         * @return  {void}
         */ parseEffects: function() {
            var self = this, transformName = "", effectsIn = self.config.animation.effectsIn || self.config.animation.effects, effectsOut = self.config.animation.effectsOut || self.config.animation.effects;
            self.callActions("beforeParseEffects", arguments);
            self.effectsIn = new mixitup.StyleData();
            self.effectsOut = new mixitup.StyleData();
            self.transformIn = [];
            self.transformOut = [];
            self.effectsIn.opacity = self.effectsOut.opacity = 1;
            self.parseEffect("fade", effectsIn, self.effectsIn, self.transformIn);
            self.parseEffect("fade", effectsOut, self.effectsOut, self.transformOut, true);
            for(transformName in mixitup.transformDefaults){
                if (!(mixitup.transformDefaults[transformName] instanceof mixitup.TransformData)) continue;
                self.parseEffect(transformName, effectsIn, self.effectsIn, self.transformIn);
                self.parseEffect(transformName, effectsOut, self.effectsOut, self.transformOut, true);
            }
            self.parseEffect("stagger", effectsIn, self.effectsIn, self.transformIn);
            self.parseEffect("stagger", effectsOut, self.effectsOut, self.transformOut, true);
            self.callActions("afterParseEffects", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {string}    effectName
         * @param   {string}    effectString
         * @param   {StyleData} effects
         * @param   {String[]}  transform
         * @param   {boolean}   [isOut]
         */ parseEffect: function(effectName, effectString, effects, transform, isOut) {
            var self = this, re = /\(([^)]+)\)/, propIndex = -1, str = "", match = [], val = "", units = [
                "%",
                "px",
                "em",
                "rem",
                "vh",
                "vw",
                "deg"
            ], unit = "", i = -1;
            self.callActions("beforeParseEffect", arguments);
            if (typeof effectString !== "string") throw new TypeError(mixitup.messages.errorConfigInvalidAnimationEffects());
            if (effectString.indexOf(effectName) < 0) {
                // The effect is not present in the effects string
                if (effectName === "stagger") // Reset stagger to 0
                self.staggerDuration = 0;
                return;
            }
            // The effect is present
            propIndex = effectString.indexOf(effectName + "(");
            if (propIndex > -1) {
                // The effect has a user defined value in parentheses
                // Extract from the first parenthesis to the end of string
                str = effectString.substring(propIndex);
                // Match any number of characters between "(" and ")"
                match = re.exec(str);
                val = match[1];
            }
            switch(effectName){
                case "fade":
                    effects.opacity = val ? parseFloat(val) : 0;
                    break;
                case "stagger":
                    self.staggerDuration = val ? parseFloat(val) : 100;
                    break;
                default:
                    // All other effects are transforms following the same structure
                    if (isOut && self.config.animation.reverseOut && effectName !== "scale") effects[effectName].value = (val ? parseFloat(val) : mixitup.transformDefaults[effectName].value) * -1;
                    else effects[effectName].value = val ? parseFloat(val) : mixitup.transformDefaults[effectName].value;
                    if (val) {
                        for(i = 0; unit = units[i]; i++)if (val.indexOf(unit) > -1) {
                            effects[effectName].unit = unit;
                            break;
                        }
                    } else effects[effectName].unit = mixitup.transformDefaults[effectName].unit;
                    transform.push(effectName + "(" + effects[effectName].value + effects[effectName].unit + ")");
            }
            self.callActions("afterParseEffect", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {State}
         */ buildState: function(operation) {
            var self = this, state = new mixitup.State(), target = null, i = -1;
            self.callActions("beforeBuildState", arguments);
            // Map target elements into state arrays.
            // the real target objects should never be exposed
            for(i = 0; target = self.targets[i]; i++)if (!operation.toRemove.length || operation.toRemove.indexOf(target) < 0) state.targets.push(target.dom.el);
            for(i = 0; target = operation.matching[i]; i++)state.matching.push(target.dom.el);
            for(i = 0; target = operation.show[i]; i++)state.show.push(target.dom.el);
            for(i = 0; target = operation.hide[i]; i++)if (!operation.toRemove.length || operation.toRemove.indexOf(target) < 0) state.hide.push(target.dom.el);
            state.id = self.id;
            state.container = self.dom.container;
            state.activeFilter = operation.newFilter;
            state.activeSort = operation.newSort;
            state.activeDataset = operation.newDataset;
            state.activeContainerClassName = operation.newContainerClassName;
            state.hasFailed = operation.hasFailed;
            state.totalTargets = self.targets.length;
            state.totalShow = operation.show.length;
            state.totalHide = operation.hide.length;
            state.totalMatching = operation.matching.length;
            state.triggerElement = operation.triggerElement;
            return self.callFilters("stateBuildState", state, arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {boolean}   shouldAnimate
         * @param   {Operation} operation
         * @return  {void}
         */ goMix: function(shouldAnimate, operation) {
            var self = this, deferred = null;
            self.callActions("beforeGoMix", arguments);
            // If the animation duration is set to 0ms,
            // or no effects specified,
            // or the container is hidden
            // then abort animation
            if (!self.config.animation.duration || !self.config.animation.effects || !h.isVisible(self.dom.container)) shouldAnimate = false;
            if (!operation.toShow.length && !operation.toHide.length && !operation.willSort && !operation.willChangeLayout) // If nothing to show or hide, and not sorting or
            // changing layout
            shouldAnimate = false;
            if (!operation.startState.show.length && !operation.show.length) // If nothing currently shown, nothing to show
            shouldAnimate = false;
            mixitup.events.fire("mixStart", self.dom.container, {
                state: operation.startState,
                futureState: operation.newState,
                instance: self
            }, self.dom.document);
            if (typeof self.config.callbacks.onMixStart === "function") self.config.callbacks.onMixStart.call(self.dom.container, operation.startState, operation.newState, self);
            h.removeClass(self.dom.container, h.getClassname(self.config.classNames, "container", self.config.classNames.modifierFailed));
            if (!self.userDeferred) // Queue empty, no pending operations
            deferred = self.userDeferred = h.defer(mixitup.libraries);
            else // Use existing deferred
            deferred = self.userDeferred;
            self.isBusy = true;
            if (!shouldAnimate || !mixitup.features.has.transitions) {
                // Abort
                if (self.config.debug.fauxAsync) setTimeout(function() {
                    self.cleanUp(operation);
                }, self.config.animation.duration);
                else self.cleanUp(operation);
                return self.callFilters("promiseGoMix", deferred.promise, arguments);
            }
            // If we should animate and the platform supports transitions, go for it
            if (window1.pageYOffset !== operation.docState.scrollTop) window1.scrollTo(operation.docState.scrollLeft, operation.docState.scrollTop);
            if (self.config.animation.applyPerspective) {
                self.dom.parent.style[mixitup.features.perspectiveProp] = self.config.animation.perspectiveDistance;
                self.dom.parent.style[mixitup.features.perspectiveOriginProp] = self.config.animation.perspectiveOrigin;
            }
            if (self.config.animation.animateResizeContainer && operation.startHeight !== operation.newHeight && operation.viewportDeltaY !== operation.startHeight - operation.newHeight) self.dom.parent.style.height = operation.startHeight + "px";
            if (self.config.animation.animateResizeContainer && operation.startWidth !== operation.newWidth && operation.viewportDeltaX !== operation.startWidth - operation.newWidth) self.dom.parent.style.width = operation.startWidth + "px";
            if (operation.startHeight === operation.newHeight) self.dom.parent.style.height = operation.startHeight + "px";
            if (operation.startWidth === operation.newWidth) self.dom.parent.style.width = operation.startWidth + "px";
            if (operation.startHeight === operation.newHeight && operation.startWidth === operation.newWidth) self.dom.parent.style.overflow = "hidden";
            requestAnimationFrame(function() {
                self.moveTargets(operation);
            });
            return self.callFilters("promiseGoMix", deferred.promise, arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ getStartMixData: function(operation) {
            var self = this, parentStyle = window1.getComputedStyle(self.dom.parent), parentRect = self.dom.parent.getBoundingClientRect(), target = null, data = {}, i = -1, boxSizing = parentStyle[mixitup.features.boxSizingProp];
            self.incPadding = boxSizing === "border-box";
            self.callActions("beforeGetStartMixData", arguments);
            for(i = 0; target = operation.show[i]; i++){
                data = target.getPosData();
                operation.showPosData[i] = {
                    startPosData: data
                };
            }
            for(i = 0; target = operation.toHide[i]; i++){
                data = target.getPosData();
                operation.toHidePosData[i] = {
                    startPosData: data
                };
            }
            operation.startX = parentRect.left;
            operation.startY = parentRect.top;
            operation.startHeight = self.incPadding ? parentRect.height : parentRect.height - parseFloat(parentStyle.paddingTop) - parseFloat(parentStyle.paddingBottom) - parseFloat(parentStyle.borderTop) - parseFloat(parentStyle.borderBottom);
            operation.startWidth = self.incPadding ? parentRect.width : parentRect.width - parseFloat(parentStyle.paddingLeft) - parseFloat(parentStyle.paddingRight) - parseFloat(parentStyle.borderLeft) - parseFloat(parentStyle.borderRight);
            self.callActions("afterGetStartMixData", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ setInter: function(operation) {
            var self = this, target = null, i = -1;
            self.callActions("beforeSetInter", arguments);
            // Prevent scrollbar flicker on non-inertial scroll platforms by clamping height/width
            if (self.config.animation.clampHeight) {
                self.dom.parent.style.height = operation.startHeight + "px";
                self.dom.parent.style.overflow = "hidden";
            }
            if (self.config.animation.clampWidth) {
                self.dom.parent.style.width = operation.startWidth + "px";
                self.dom.parent.style.overflow = "hidden";
            }
            for(i = 0; target = operation.toShow[i]; i++)target.show();
            if (operation.willChangeLayout) {
                h.removeClass(self.dom.container, operation.startContainerClassName);
                h.addClass(self.dom.container, operation.newContainerClassName);
            }
            self.callActions("afterSetInter", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ getInterMixData: function(operation) {
            var self = this, target = null, i = -1;
            self.callActions("beforeGetInterMixData", arguments);
            for(i = 0; target = operation.show[i]; i++)operation.showPosData[i].interPosData = target.getPosData();
            for(i = 0; target = operation.toHide[i]; i++)operation.toHidePosData[i].interPosData = target.getPosData();
            self.callActions("afterGetInterMixData", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ setFinal: function(operation) {
            var self = this, target = null, i = -1;
            self.callActions("beforeSetFinal", arguments);
            operation.willSort && self.printSort(false, operation);
            for(i = 0; target = operation.toHide[i]; i++)target.hide();
            self.callActions("afterSetFinal", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ getFinalMixData: function(operation) {
            var self = this, parentStyle = null, parentRect = null, target = null, i = -1;
            self.callActions("beforeGetFinalMixData", arguments);
            for(i = 0; target = operation.show[i]; i++)operation.showPosData[i].finalPosData = target.getPosData();
            for(i = 0; target = operation.toHide[i]; i++)operation.toHidePosData[i].finalPosData = target.getPosData();
            // Remove clamping
            if (self.config.animation.clampHeight || self.config.animation.clampWidth) self.dom.parent.style.height = self.dom.parent.style.width = self.dom.parent.style.overflow = "";
            if (!self.incPadding) parentStyle = window1.getComputedStyle(self.dom.parent);
            parentRect = self.dom.parent.getBoundingClientRect();
            operation.newX = parentRect.left;
            operation.newY = parentRect.top;
            operation.newHeight = self.incPadding ? parentRect.height : parentRect.height - parseFloat(parentStyle.paddingTop) - parseFloat(parentStyle.paddingBottom) - parseFloat(parentStyle.borderTop) - parseFloat(parentStyle.borderBottom);
            operation.newWidth = self.incPadding ? parentRect.width : parentRect.width - parseFloat(parentStyle.paddingLeft) - parseFloat(parentStyle.paddingRight) - parseFloat(parentStyle.borderLeft) - parseFloat(parentStyle.borderRight);
            operation.viewportDeltaX = operation.docState.viewportWidth - this.dom.document.documentElement.clientWidth;
            operation.viewportDeltaY = operation.docState.viewportHeight - this.dom.document.documentElement.clientHeight;
            if (operation.willSort) self.printSort(true, operation);
            for(i = 0; target = operation.toShow[i]; i++)target.hide();
            for(i = 0; target = operation.toHide[i]; i++)target.show();
            if (operation.willChangeLayout) {
                h.removeClass(self.dom.container, operation.newContainerClassName);
                h.addClass(self.dom.container, self.config.layout.containerClassName);
            }
            self.callActions("afterGetFinalMixData", arguments);
        },
        /**
         * @private
         * @instance
         * @since    3.0.0
         * @param    {Operation}     operation
         */ getTweenData: function(operation) {
            var self = this, target = null, posData = null, effectNames = Object.getOwnPropertyNames(self.effectsIn), effectName = "", effect = null, widthChange = -1, heightChange = -1, i = -1, j = -1;
            self.callActions("beforeGetTweenData", arguments);
            for(i = 0; target = operation.show[i]; i++){
                posData = operation.showPosData[i];
                posData.posIn = new mixitup.StyleData();
                posData.posOut = new mixitup.StyleData();
                posData.tweenData = new mixitup.StyleData();
                // Process x and y
                if (target.isShown) {
                    posData.posIn.x = posData.startPosData.x - posData.interPosData.x;
                    posData.posIn.y = posData.startPosData.y - posData.interPosData.y;
                } else posData.posIn.x = posData.posIn.y = 0;
                posData.posOut.x = posData.finalPosData.x - posData.interPosData.x;
                posData.posOut.y = posData.finalPosData.y - posData.interPosData.y;
                // Process opacity
                posData.posIn.opacity = target.isShown ? 1 : self.effectsIn.opacity;
                posData.posOut.opacity = 1;
                posData.tweenData.opacity = posData.posOut.opacity - posData.posIn.opacity;
                // Adjust x and y if not nudging
                if (!target.isShown && !self.config.animation.nudge) {
                    posData.posIn.x = posData.posOut.x;
                    posData.posIn.y = posData.posOut.y;
                }
                posData.tweenData.x = posData.posOut.x - posData.posIn.x;
                posData.tweenData.y = posData.posOut.y - posData.posIn.y;
                // Process width, height, and margins
                if (self.config.animation.animateResizeTargets) {
                    posData.posIn.width = posData.startPosData.width;
                    posData.posIn.height = posData.startPosData.height;
                    // "||" Prevents width/height change from including 0 width/height if hiding or showing
                    widthChange = (posData.startPosData.width || posData.finalPosData.width) - posData.interPosData.width;
                    posData.posIn.marginRight = posData.startPosData.marginRight - widthChange;
                    heightChange = (posData.startPosData.height || posData.finalPosData.height) - posData.interPosData.height;
                    posData.posIn.marginBottom = posData.startPosData.marginBottom - heightChange;
                    posData.posOut.width = posData.finalPosData.width;
                    posData.posOut.height = posData.finalPosData.height;
                    widthChange = (posData.finalPosData.width || posData.startPosData.width) - posData.interPosData.width;
                    posData.posOut.marginRight = posData.finalPosData.marginRight - widthChange;
                    heightChange = (posData.finalPosData.height || posData.startPosData.height) - posData.interPosData.height;
                    posData.posOut.marginBottom = posData.finalPosData.marginBottom - heightChange;
                    posData.tweenData.width = posData.posOut.width - posData.posIn.width;
                    posData.tweenData.height = posData.posOut.height - posData.posIn.height;
                    posData.tweenData.marginRight = posData.posOut.marginRight - posData.posIn.marginRight;
                    posData.tweenData.marginBottom = posData.posOut.marginBottom - posData.posIn.marginBottom;
                }
                // Process transforms
                for(j = 0; effectName = effectNames[j]; j++){
                    effect = self.effectsIn[effectName];
                    if (!(effect instanceof mixitup.TransformData) || !effect.value) continue;
                    posData.posIn[effectName].value = effect.value;
                    posData.posOut[effectName].value = 0;
                    posData.tweenData[effectName].value = posData.posOut[effectName].value - posData.posIn[effectName].value;
                    posData.posIn[effectName].unit = posData.posOut[effectName].unit = posData.tweenData[effectName].unit = effect.unit;
                }
            }
            for(i = 0; target = operation.toHide[i]; i++){
                posData = operation.toHidePosData[i];
                posData.posIn = new mixitup.StyleData();
                posData.posOut = new mixitup.StyleData();
                posData.tweenData = new mixitup.StyleData();
                // Process x and y
                posData.posIn.x = target.isShown ? posData.startPosData.x - posData.interPosData.x : 0;
                posData.posIn.y = target.isShown ? posData.startPosData.y - posData.interPosData.y : 0;
                posData.posOut.x = self.config.animation.nudge ? 0 : posData.posIn.x;
                posData.posOut.y = self.config.animation.nudge ? 0 : posData.posIn.y;
                posData.tweenData.x = posData.posOut.x - posData.posIn.x;
                posData.tweenData.y = posData.posOut.y - posData.posIn.y;
                // Process width, height, and margins
                if (self.config.animation.animateResizeTargets) {
                    posData.posIn.width = posData.startPosData.width;
                    posData.posIn.height = posData.startPosData.height;
                    widthChange = posData.startPosData.width - posData.interPosData.width;
                    posData.posIn.marginRight = posData.startPosData.marginRight - widthChange;
                    heightChange = posData.startPosData.height - posData.interPosData.height;
                    posData.posIn.marginBottom = posData.startPosData.marginBottom - heightChange;
                }
                // Process opacity
                posData.posIn.opacity = 1;
                posData.posOut.opacity = self.effectsOut.opacity;
                posData.tweenData.opacity = posData.posOut.opacity - posData.posIn.opacity;
                // Process transforms
                for(j = 0; effectName = effectNames[j]; j++){
                    effect = self.effectsOut[effectName];
                    if (!(effect instanceof mixitup.TransformData) || !effect.value) continue;
                    posData.posIn[effectName].value = 0;
                    posData.posOut[effectName].value = effect.value;
                    posData.tweenData[effectName].value = posData.posOut[effectName].value - posData.posIn[effectName].value;
                    posData.posIn[effectName].unit = posData.posOut[effectName].unit = posData.tweenData[effectName].unit = effect.unit;
                }
            }
            self.callActions("afterGetTweenData", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ moveTargets: function(operation) {
            var self = this, target = null, moveData = null, posData = null, statusChange = "", willTransition = false, staggerIndex = -1, i = -1, checkProgress = self.checkProgress.bind(self);
            self.callActions("beforeMoveTargets", arguments);
            // TODO: this is an extra loop in addition to the calcs
            // done in getOperation, could some of this be done there?
            for(i = 0; target = operation.show[i]; i++){
                moveData = new mixitup.IMoveData();
                posData = operation.showPosData[i];
                statusChange = target.isShown ? "none" : "show";
                willTransition = self.willTransition(statusChange, operation.hasEffect, posData.posIn, posData.posOut);
                if (willTransition) // Prevent non-transitioning targets from incrementing the staggerIndex
                staggerIndex++;
                target.show();
                moveData.posIn = posData.posIn;
                moveData.posOut = posData.posOut;
                moveData.statusChange = statusChange;
                moveData.staggerIndex = staggerIndex;
                moveData.operation = operation;
                moveData.callback = willTransition ? checkProgress : null;
                target.move(moveData);
            }
            for(i = 0; target = operation.toHide[i]; i++){
                posData = operation.toHidePosData[i];
                moveData = new mixitup.IMoveData();
                statusChange = "hide";
                willTransition = self.willTransition(statusChange, posData.posIn, posData.posOut);
                moveData.posIn = posData.posIn;
                moveData.posOut = posData.posOut;
                moveData.statusChange = statusChange;
                moveData.staggerIndex = i;
                moveData.operation = operation;
                moveData.callback = willTransition ? checkProgress : null;
                target.move(moveData);
            }
            if (self.config.animation.animateResizeContainer) {
                self.dom.parent.style[mixitup.features.transitionProp] = "height " + self.config.animation.duration + "ms ease, " + "width " + self.config.animation.duration + "ms ease ";
                requestAnimationFrame(function() {
                    if (operation.startHeight !== operation.newHeight && operation.viewportDeltaY !== operation.startHeight - operation.newHeight) self.dom.parent.style.height = operation.newHeight + "px";
                    if (operation.startWidth !== operation.newWidth && operation.viewportDeltaX !== operation.startWidth - operation.newWidth) self.dom.parent.style.width = operation.newWidth + "px";
                });
            }
            if (operation.willChangeLayout) {
                h.removeClass(self.dom.container, self.config.layout.ContainerClassName);
                h.addClass(self.dom.container, operation.newContainerClassName);
            }
            self.callActions("afterMoveTargets", arguments);
        },
        /**
         * @private
         * @instance
         * @return  {boolean}
         */ hasEffect: function() {
            var self = this, EFFECTABLES = [
                "scale",
                "translateX",
                "translateY",
                "translateZ",
                "rotateX",
                "rotateY",
                "rotateZ"
            ], effectName = "", effect = null, result = false, value = -1, i = -1;
            if (self.effectsIn.opacity !== 1) return self.callFilters("resultHasEffect", true, arguments);
            for(i = 0; effectName = EFFECTABLES[i]; i++){
                effect = self.effectsIn[effectName];
                value = typeof effect && effect.value !== "undefined" ? effect.value : effect;
                if (value !== 0) {
                    result = true;
                    break;
                }
            }
            return self.callFilters("resultHasEffect", result, arguments);
        },
        /**
         * Determines if a target element will transition in
         * some fasion and therefore requires binding of
         * transitionEnd
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {string}        statusChange
         * @param   {boolean}       hasEffect
         * @param   {StyleData}     posIn
         * @param   {StyleData}     posOut
         * @return  {boolean}
         */ willTransition: function(statusChange, hasEffect, posIn, posOut) {
            var self = this, result = false;
            if (!h.isVisible(self.dom.container)) // If the container is not visible, the transitionEnd
            // event will not occur and MixItUp will hang
            result = false;
            else if (statusChange !== "none" && hasEffect || posIn.x !== posOut.x || posIn.y !== posOut.y) // If opacity and/or translate will change
            result = true;
            else if (self.config.animation.animateResizeTargets) // Check if width, height or margins will change
            result = posIn.width !== posOut.width || posIn.height !== posOut.height || posIn.marginRight !== posOut.marginRight || posIn.marginTop !== posOut.marginTop;
            else result = false;
            return self.callFilters("resultWillTransition", result, arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ checkProgress: function(operation) {
            var self = this;
            self.targetsDone++;
            if (self.targetsBound === self.targetsDone) self.cleanUp(operation);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ cleanUp: function(operation) {
            var self = this, target = null, whitespaceBefore = null, whitespaceAfter = null, nextInQueue = null, i = -1;
            self.callActions("beforeCleanUp", arguments);
            self.targetsMoved = self.targetsImmovable = self.targetsBound = self.targetsDone = 0;
            for(i = 0; target = operation.show[i]; i++){
                target.cleanUp();
                target.show();
            }
            for(i = 0; target = operation.toHide[i]; i++){
                target.cleanUp();
                target.hide();
            }
            if (operation.willSort) self.printSort(false, operation);
            // Remove any styles applied to the parent container
            self.dom.parent.style[mixitup.features.transitionProp] = self.dom.parent.style.height = self.dom.parent.style.width = self.dom.parent.style.overflow = self.dom.parent.style[mixitup.features.perspectiveProp] = self.dom.parent.style[mixitup.features.perspectiveOriginProp] = "";
            if (operation.willChangeLayout) {
                h.removeClass(self.dom.container, operation.startContainerClassName);
                h.addClass(self.dom.container, operation.newContainerClassName);
            }
            if (operation.toRemove.length) {
                for(i = 0; target = self.targets[i]; i++)if (operation.toRemove.indexOf(target) > -1) {
                    if ((whitespaceBefore = target.dom.el.previousSibling) && whitespaceBefore.nodeName === "#text" && (whitespaceAfter = target.dom.el.nextSibling) && whitespaceAfter.nodeName === "#text") h.removeWhitespace(whitespaceBefore);
                    if (!operation.willSort) // NB: Sorting will remove targets as a bi-product of `printSort()`
                    self.dom.parent.removeChild(target.dom.el);
                    self.targets.splice(i, 1);
                    target.isInDom = false;
                    i--;
                }
                // Since targets have been removed, the original order must be updated
                self.origOrder = self.targets;
            }
            if (operation.willSort) self.targets = operation.newOrder;
            self.state = operation.newState;
            self.lastOperation = operation;
            self.dom.targets = self.state.targets;
            // mixEnd
            mixitup.events.fire("mixEnd", self.dom.container, {
                state: self.state,
                instance: self
            }, self.dom.document);
            if (typeof self.config.callbacks.onMixEnd === "function") self.config.callbacks.onMixEnd.call(self.dom.container, self.state, self);
            if (operation.hasFailed) {
                // mixFail
                mixitup.events.fire("mixFail", self.dom.container, {
                    state: self.state,
                    instance: self
                }, self.dom.document);
                if (typeof self.config.callbacks.onMixFail === "function") self.config.callbacks.onMixFail.call(self.dom.container, self.state, self);
                h.addClass(self.dom.container, h.getClassname(self.config.classNames, "container", self.config.classNames.modifierFailed));
            }
            // User-defined callback function
            if (typeof self.userCallback === "function") self.userCallback.call(self.dom.container, self.state, self);
            if (typeof self.userDeferred.resolve === "function") self.userDeferred.resolve(self.state);
            self.userCallback = null;
            self.userDeferred = null;
            self.lastClicked = null;
            self.isToggling = false;
            self.isBusy = false;
            if (self.queue.length) {
                self.callActions("beforeReadQueueCleanUp", arguments);
                nextInQueue = self.queue.shift();
                // Update non-public API properties stored in queue
                self.userDeferred = nextInQueue.deferred;
                self.isToggling = nextInQueue.isToggling;
                self.lastClicked = nextInQueue.triggerElement;
                if (nextInQueue.instruction.command instanceof mixitup.CommandMultimix) self.multimix.apply(self, nextInQueue.args);
                else self.dataset.apply(self, nextInQueue.args);
            }
            self.callActions("afterCleanUp", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Array<*>}  args
         * @return  {mixitup.UserInstruction}
         */ parseMultimixArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), arg = null, i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandMultimix();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (arg === null) continue;
                if (typeof arg === "object") h.extend(instruction.command, arg);
                else if (typeof arg === "boolean") instruction.animate = arg;
                else if (typeof arg === "function") instruction.callback = arg;
            }
            // Coerce arbitrary command arguments into typed command objects
            if (instruction.command.insert && !(instruction.command.insert instanceof mixitup.CommandInsert)) instruction.command.insert = self.parseInsertArgs([
                instruction.command.insert
            ]).command;
            if (instruction.command.remove && !(instruction.command.remove instanceof mixitup.CommandRemove)) instruction.command.remove = self.parseRemoveArgs([
                instruction.command.remove
            ]).command;
            if (instruction.command.filter && !(instruction.command.filter instanceof mixitup.CommandFilter)) instruction.command.filter = self.parseFilterArgs([
                instruction.command.filter
            ]).command;
            if (instruction.command.sort && !(instruction.command.sort instanceof mixitup.CommandSort)) instruction.command.sort = self.parseSortArgs([
                instruction.command.sort
            ]).command;
            if (instruction.command.changeLayout && !(instruction.command.changeLayout instanceof mixitup.CommandChangeLayout)) instruction.command.changeLayout = self.parseChangeLayoutArgs([
                instruction.command.changeLayout
            ]).command;
            instruction = self.callFilters("instructionParseMultimixArgs", instruction, arguments);
            h.freeze(instruction);
            return instruction;
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Array<*>}  args
         * @return  {mixitup.UserInstruction}
         */ parseFilterArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), arg = null, i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandFilter();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (typeof arg === "string") // Selector
                instruction.command.selector = arg;
                else if (arg === null) instruction.command.collection = [];
                else if (typeof arg === "object" && h.isElement(arg, self.dom.document)) // Single element
                instruction.command.collection = [
                    arg
                ];
                else if (typeof arg === "object" && typeof arg.length !== "undefined") // Multiple elements in array, NodeList or jQuery collection
                instruction.command.collection = h.arrayFromList(arg);
                else if (typeof arg === "object") // Filter command
                h.extend(instruction.command, arg);
                else if (typeof arg === "boolean") instruction.animate = arg;
                else if (typeof arg === "function") instruction.callback = arg;
            }
            if (instruction.command.selector && instruction.command.collection) throw new Error(mixitup.messages.errorFilterInvalidArguments());
            instruction = self.callFilters("instructionParseFilterArgs", instruction, arguments);
            h.freeze(instruction);
            return instruction;
        },
        parseSortArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), arg = null, sortString = "", i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandSort();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (arg === null) continue;
                switch(typeof arg){
                    case "string":
                        // Sort string
                        sortString = arg;
                        break;
                    case "object":
                        // Array of element references
                        if (arg.length) instruction.command.collection = h.arrayFromList(arg);
                        break;
                    case "boolean":
                        instruction.animate = arg;
                        break;
                    case "function":
                        instruction.callback = arg;
                        break;
                }
            }
            if (sortString) instruction.command = self.parseSortString(sortString, instruction.command);
            instruction = self.callFilters("instructionParseSortArgs", instruction, arguments);
            h.freeze(instruction);
            return instruction;
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Array<*>}  args
         * @return  {mixitup.UserInstruction}
         */ parseInsertArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), arg = null, i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandInsert();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (arg === null) continue;
                if (typeof arg === "number") // Insert index
                instruction.command.index = arg;
                else if (typeof arg === "string" && [
                    "before",
                    "after"
                ].indexOf(arg) > -1) // 'before'/'after'
                instruction.command.position = arg;
                else if (typeof arg === "string") // Markup
                instruction.command.collection = h.arrayFromList(h.createElement(arg).childNodes);
                else if (typeof arg === "object" && h.isElement(arg, self.dom.document)) // Single element
                !instruction.command.collection.length ? instruction.command.collection = [
                    arg
                ] : instruction.command.sibling = arg;
                else if (typeof arg === "object" && arg.length) // Multiple elements in array or jQuery collection
                !instruction.command.collection.length ? instruction.command.collection = arg : instruction.command.sibling = arg[0];
                else if (typeof arg === "object" && arg.childNodes && arg.childNodes.length) // Document fragment
                !instruction.command.collection.length ? instruction.command.collection = h.arrayFromList(arg.childNodes) : instruction.command.sibling = arg.childNodes[0];
                else if (typeof arg === "object") // Insert command
                h.extend(instruction.command, arg);
                else if (typeof arg === "boolean") instruction.animate = arg;
                else if (typeof arg === "function") instruction.callback = arg;
            }
            if (instruction.command.index && instruction.command.sibling) throw new Error(mixitup.messages.errorInsertInvalidArguments());
            if (!instruction.command.collection.length && self.config.debug.showWarnings) console.warn(mixitup.messages.warningInsertNoElements());
            instruction = self.callFilters("instructionParseInsertArgs", instruction, arguments);
            h.freeze(instruction);
            return instruction;
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Array<*>}  args
         * @return  {mixitup.UserInstruction}
         */ parseRemoveArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), target = null, arg = null, i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandRemove();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (arg === null) continue;
                switch(typeof arg){
                    case "number":
                        if (self.targets[arg]) instruction.command.targets[0] = self.targets[arg];
                        break;
                    case "string":
                        instruction.command.collection = h.arrayFromList(self.dom.parent.querySelectorAll(arg));
                        break;
                    case "object":
                        if (arg && arg.length) instruction.command.collection = arg;
                        else if (h.isElement(arg, self.dom.document)) instruction.command.collection = [
                            arg
                        ];
                        else // Remove command
                        h.extend(instruction.command, arg);
                        break;
                    case "boolean":
                        instruction.animate = arg;
                        break;
                    case "function":
                        instruction.callback = arg;
                        break;
                }
            }
            if (instruction.command.collection.length) {
                for(i = 0; target = self.targets[i]; i++)if (instruction.command.collection.indexOf(target.dom.el) > -1) instruction.command.targets.push(target);
            }
            if (!instruction.command.targets.length && self.config.debug.showWarnings) console.warn(mixitup.messages.warningRemoveNoElements());
            h.freeze(instruction);
            return instruction;
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Array<*>}  args
         * @return  {mixitup.UserInstruction}
         */ parseDatasetArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), arg = null, i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandDataset();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (arg === null) continue;
                switch(typeof arg){
                    case "object":
                        if (Array.isArray(arg) || typeof arg.length === "number") instruction.command.dataset = arg;
                        else // Change layout command
                        h.extend(instruction.command, arg);
                        break;
                    case "boolean":
                        instruction.animate = arg;
                        break;
                    case "function":
                        instruction.callback = arg;
                        break;
                }
            }
            h.freeze(instruction);
            return instruction;
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Array<*>}  args
         * @return  {mixitup.UserInstruction}
         */ parseChangeLayoutArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), arg = null, i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandChangeLayout();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (arg === null) continue;
                switch(typeof arg){
                    case "string":
                        instruction.command.containerClassName = arg;
                        break;
                    case "object":
                        // Change layout command
                        h.extend(instruction.command, arg);
                        break;
                    case "boolean":
                        instruction.animate = arg;
                        break;
                    case "function":
                        instruction.callback = arg;
                        break;
                }
            }
            h.freeze(instruction);
            return instruction;
        },
        /**
         * @private
         * @instance
         * @since       3.0.0
         * @param       {mixitup.QueueItem}         queueItem
         * @return      {Promise.<mixitup.State>}
         */ queueMix: function(queueItem) {
            var self = this, deferred = null, toggleSelector = "";
            self.callActions("beforeQueueMix", arguments);
            deferred = h.defer(mixitup.libraries);
            if (self.config.animation.queue && self.queue.length < self.config.animation.queueLimit) {
                queueItem.deferred = deferred;
                self.queue.push(queueItem);
                // Keep controls in sync with user interactions. Mixer will catch up as it drains the queue.
                if (self.config.controls.enable) {
                    if (self.isToggling) {
                        self.buildToggleArray(queueItem.instruction.command);
                        toggleSelector = self.getToggleSelector();
                        self.updateControls({
                            filter: {
                                selector: toggleSelector
                            }
                        });
                    } else self.updateControls(queueItem.instruction.command);
                }
            } else {
                if (self.config.debug.showWarnings) console.warn(mixitup.messages.warningMultimixInstanceQueueFull());
                deferred.resolve(self.state);
                mixitup.events.fire("mixBusy", self.dom.container, {
                    state: self.state,
                    instance: self
                }, self.dom.document);
                if (typeof self.config.callbacks.onMixBusy === "function") self.config.callbacks.onMixBusy.call(self.dom.container, self.state, self);
            }
            return self.callFilters("promiseQueueMix", deferred.promise, arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Array.<object>}    newDataset
         * @return  {Operation}
         */ getDataOperation: function(newDataset) {
            var self = this, operation = new mixitup.Operation(), startDataset = [];
            operation = self.callFilters("operationUnmappedGetDataOperation", operation, arguments);
            if (self.dom.targets.length && !(startDataset = self.state.activeDataset || []).length) throw new Error(mixitup.messages.errorDatasetNotSet());
            operation.id = h.randomHex();
            operation.startState = self.state;
            operation.startDataset = startDataset;
            operation.newDataset = newDataset.slice();
            self.diffDatasets(operation);
            operation.startOrder = self.targets;
            operation.newOrder = operation.show;
            if (self.config.animation.enable) {
                self.getStartMixData(operation);
                self.setInter(operation);
                operation.docState = h.getDocumentState(self.dom.document);
                self.getInterMixData(operation);
                self.setFinal(operation);
                self.getFinalMixData(operation);
                self.parseEffects();
                operation.hasEffect = self.hasEffect();
                self.getTweenData(operation);
            }
            self.targets = operation.show.slice();
            operation.newState = self.buildState(operation);
            // NB: Targets to be removed must be included in `self.targets` for removal during clean up,
            // but are added after state is built so that state is accurate
            Array.prototype.push.apply(self.targets, operation.toRemove);
            operation = self.callFilters("operationMappedGetDataOperation", operation, arguments);
            return operation;
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {mixitup.Operation} operation
         * @return  {void}
         */ diffDatasets: function(operation) {
            var self = this, persistantStartIds = [], persistantNewIds = [], insertedTargets = [], data = null, target = null, el = null, frag = null, nextEl = null, uids = {}, id = "", i = -1;
            self.callActions("beforeDiffDatasets", arguments);
            for(i = 0; data = operation.newDataset[i]; i++){
                if (typeof (id = data[self.config.data.uidKey]) === "undefined" || id.toString().length < 1) throw new TypeError(mixitup.messages.errorDatasetInvalidUidKey({
                    uidKey: self.config.data.uidKey
                }));
                if (!uids[id]) uids[id] = true;
                else throw new Error(mixitup.messages.errorDatasetDuplicateUid({
                    uid: id
                }));
                if ((target = self.cache[id]) instanceof mixitup.Target) {
                    // Already in cache
                    if (self.config.data.dirtyCheck && !h.deepEquals(data, target.data)) {
                        // change detected
                        el = target.render(data);
                        target.data = data;
                        if (el !== target.dom.el) {
                            // Update target element reference
                            if (target.isInDom) {
                                target.unbindEvents();
                                self.dom.parent.replaceChild(el, target.dom.el);
                            }
                            if (!target.isShown) el.style.display = "none";
                            target.dom.el = el;
                            if (target.isInDom) target.bindEvents();
                        }
                    }
                    el = target.dom.el;
                } else {
                    // New target
                    target = new mixitup.Target();
                    target.init(null, self, data);
                    target.hide();
                }
                if (!target.isInDom) {
                    // Adding to DOM
                    if (!frag) // Open frag
                    frag = self.dom.document.createDocumentFragment();
                    if (frag.lastElementChild) frag.appendChild(self.dom.document.createTextNode(" "));
                    frag.appendChild(target.dom.el);
                    target.isInDom = true;
                    target.unbindEvents();
                    target.bindEvents();
                    target.hide();
                    operation.toShow.push(target);
                    insertedTargets.push(target);
                } else {
                    // Already in DOM
                    nextEl = target.dom.el.nextElementSibling;
                    persistantNewIds.push(id);
                    if (frag) {
                        // Close and insert previously opened frag
                        if (frag.lastElementChild) frag.appendChild(self.dom.document.createTextNode(" "));
                        self.insertDatasetFrag(frag, target.dom.el, insertedTargets);
                        frag = null;
                    }
                }
                operation.show.push(target);
            }
            if (frag) {
                // Unclosed frag remaining
                nextEl = nextEl || self.config.layout.siblingAfter;
                if (nextEl) frag.appendChild(self.dom.document.createTextNode(" "));
                self.insertDatasetFrag(frag, nextEl, insertedTargets);
            }
            for(i = 0; data = operation.startDataset[i]; i++){
                id = data[self.config.data.uidKey];
                target = self.cache[id];
                if (operation.show.indexOf(target) < 0) {
                    // Previously shown but now absent
                    operation.hide.push(target);
                    operation.toHide.push(target);
                    operation.toRemove.push(target);
                } else persistantStartIds.push(id);
            }
            if (!h.isEqualArray(persistantStartIds, persistantNewIds)) operation.willSort = true;
            self.callActions("afterDiffDatasets", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.1.5
         * @param   {DocumentFragment}          frag
         * @param   {(HTMLElement|null)}        nextEl
         * @param   {Array.<mixitup.Target>}    targets
         * @return  {void}
         */ insertDatasetFrag: function(frag, nextEl, targets) {
            var self = this;
            var insertAt = nextEl ? h.arrayFromList(self.dom.parent.children).indexOf(nextEl) : self.targets.length;
            self.dom.parent.insertBefore(frag, nextEl);
            while(targets.length){
                self.targets.splice(insertAt, 0, targets.shift());
                insertAt++;
            }
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {mixitup.CommandSort} sortCommandA
         * @param   {mixitup.CommandSort} sortCommandB
         * @return  {boolean}
         */ willSort: function(sortCommandA, sortCommandB) {
            var self = this, result = false;
            if (self.config.behavior.liveSort || sortCommandA.order === "random" || sortCommandA.attribute !== sortCommandB.attribute || sortCommandA.order !== sortCommandB.order || sortCommandA.collection !== sortCommandB.collection || sortCommandA.next === null && sortCommandB.next || sortCommandA.next && sortCommandB.next === null) result = true;
            else if (sortCommandA.next && sortCommandB.next) result = self.willSort(sortCommandA.next, sortCommandB.next);
            else result = false;
            return self.callFilters("resultWillSort", result, arguments);
        },
        /**
         * A shorthand method for `.filter('all')`. Shows all targets in the container.
         *
         * @example
         *
         * .show()
         *
         * @example <caption>Example: Showing all targets</caption>
         *
         * mixer.show()
         *     .then(function(state) {
         *         console.log(state.totalShow === state.totalTargets); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @return      {Promise.<mixitup.State>}
         */ show: function() {
            var self = this;
            return self.filter("all");
        },
        /**
         * A shorthand method for `.filter('none')`. Hides all targets in the container.
         *
         * @example
         *
         * .hide()
         *
         * @example <caption>Example: Hiding all targets</caption>
         *
         * mixer.hide()
         *     .then(function(state) {
         *         console.log(state.totalShow === 0); // true
         *         console.log(state.totalHide === state.totalTargets); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @return      {Promise.<mixitup.State>}
         */ hide: function() {
            var self = this;
            return self.filter("none");
        },
        /**
         * Returns a boolean indicating whether or not a MixItUp operation is
         * currently in progress.
         *
         * @example
         *
         * .isMixing()
         *
         * @example <caption>Example: Checking the status of a mixer</caption>
         *
         * mixer.sort('random', function() {
         *     console.log(mixer.isMixing()) // false
         * });
         *
         * console.log(mixer.isMixing()) // true
         *
         * @public
         * @instance
         * @since   2.0.0
         * @return  {boolean}
         */ isMixing: function() {
            var self = this;
            return self.isBusy;
        },
        /**
         * Filters all targets in the container by a provided selector string, or the values `'all'`
         * or `'none'`. Only targets matching the selector will be shown.
         *
         * @example
         *
         * .filter(selector [, animate] [, callback])
         *
         * @example <caption>Example 1: Filtering targets by a class selector</caption>
         *
         * mixer.filter('.category-a')
         *     .then(function(state) {
         *         console.log(state.totalShow === containerEl.querySelectorAll('.category-a').length); // true
         *     });
         *
         * @example <caption>Example 2: Filtering targets by an attribute selector</caption>
         *
         * mixer.filter('[data-category~="a"]')
         *     .then(function(state) {
         *         console.log(state.totalShow === containerEl.querySelectorAll('[data-category~="a"]').length); // true
         *     });
         *
         * @example <caption>Example 3: Filtering targets by a compound selector</caption>
         *
         * // Show only those targets with the classes 'category-a' AND 'category-b'
         *
         * mixer.filter('.category-a.category-c')
         *     .then(function(state) {
         *         console.log(state.totalShow === containerEl.querySelectorAll('.category-a.category-c').length); // true
         *     });
         *
         * @example <caption>Example 4: Filtering via an element collection</caption>
         *
         * var collection = Array.from(container.querySelectorAll('.mix'));
         *
         * console.log(collection.length); // 34
         *
         * // Filter the collection manually using Array.prototype.filter
         *
         * var filtered = collection.filter(function(target) {
         *    return parseInt(target.getAttribute('data-price')) > 10;
         * });
         *
         * console.log(filtered.length); // 22
         *
         * // Pass the filtered collection to MixItUp
         *
         * mixer.filter(filtered)
         *    .then(function(state) {
         *        console.log(state.activeFilter.collection.length === 22); // true
         *    });
         *
         * @public
         * @instance
         * @since       2.0.0
         * @param       {(string|HTMLElement|Array.<HTMLElement>)} selector
         *      Any valid CSS selector (i.e. `'.category-a'`), or the values `'all'` or `'none'`. The filter method also accepts a reference to single target element or a collection of target elements to show.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ filter: function() {
            var self = this, instruction = self.parseFilterArgs(arguments);
            return self.multimix({
                filter: instruction.command
            }, instruction.animate, instruction.callback);
        },
        /**
         * Adds an additional selector to the currently active filter selector, concatenating
         * as per the logic defined in `controls.toggleLogic`.
         *
         * @example
         *
         * .toggleOn(selector [, animate] [, callback])
         *
         * @example <caption>Example: Toggling on a filter selector</caption>
         *
         * console.log(mixer.getState().activeFilter.selector); // '.category-a'
         *
         * mixer.toggleOn('.category-b')
         *     .then(function(state) {
         *         console.log(state.activeFilter.selector); // '.category-a, .category-b'
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {string}    selector
         *      Any valid CSS selector (i.e. `'.category-a'`)
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ toggleOn: function() {
            var self = this, instruction = self.parseFilterArgs(arguments), selector = instruction.command.selector, toggleSelector = "";
            self.isToggling = true;
            if (self.toggleArray.indexOf(selector) < 0) self.toggleArray.push(selector);
            toggleSelector = self.getToggleSelector();
            return self.multimix({
                filter: toggleSelector
            }, instruction.animate, instruction.callback);
        },
        /**
         * Removes a selector from the active filter selector.
         *
         * @example
         *
         * .toggleOff(selector [, animate] [, callback])
         *
         * @example <caption>Example: Toggling off a filter selector</caption>
         *
         * console.log(mixer.getState().activeFilter.selector); // '.category-a, .category-b'
         *
         * mixer.toggleOff('.category-b')
         *     .then(function(state) {
         *         console.log(state.activeFilter.selector); // '.category-a'
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {string}    selector
         *      Any valid CSS selector (i.e. `'.category-a'`)
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ toggleOff: function() {
            var self = this, instruction = self.parseFilterArgs(arguments), selector = instruction.command.selector, selectorIndex = self.toggleArray.indexOf(selector), toggleSelector = "";
            self.isToggling = true;
            if (selectorIndex > -1) self.toggleArray.splice(selectorIndex, 1);
            toggleSelector = self.getToggleSelector();
            return self.multimix({
                filter: toggleSelector
            }, instruction.animate, instruction.callback);
        },
        /**
         * Sorts all targets in the container according to a provided sort string.
         *
         * @example
         *
         * .sort(sortString [, animate] [, callback])
         *
         * @example <caption>Example 1: Sorting by the default DOM order</caption>
         *
         * // Reverse the default order of the targets
         *
         * mixer.sort('default:desc')
         *     .then(function(state) {
         *         console.log(state.activeSort.attribute === 'default'); // true
         *         console.log(state.activeSort.order === 'desc'); // true
         *     });
         *
         * @example <caption>Example 2: Sorting by a custom data-attribute</caption>
         *
         * // Sort the targets by the value of a `data-published-date` attribute
         *
         * mixer.sort('published-date:asc')
         *     .then(function(state) {
         *         console.log(state.activeSort.attribute === 'published-date'); // true
         *         console.log(state.activeSort.order === 'asc'); // true
         *     });
         *
         * @example <caption>Example 3: Sorting by multiple attributes</caption>
         *
         * // Sort the targets by the value of a `data-published-date` attribute, then by `data-title`
         *
         * mixer.sort('published-date:desc data-title:asc')
         *     .then(function(state) {
         *         console.log(state.activeSort.attribute === 'published-date'); // true
         *         console.log(state.activeSort.order === 'desc'); // true
         *
         *         console.log(state.activeSort.next.attribute === 'title'); // true
         *         console.log(state.activeSort.next.order === 'asc'); // true
         *     });
         *
         * @example <caption>Example 4: Sorting by random</caption>
         *
         * mixer.sort('random')
         *     .then(function(state) {
         *         console.log(state.activeSort.order === 'random') // true
         *     });
         *
         * @example <caption>Example 5: Sorting via an element collection</caption>
         *
         * var collection = Array.from(container.querySelectorAll('.mix'));
         *
         * // Swap the position of two elements in the collection:
         *
         * var temp = collection[1];
         *
         * collection[1] = collection[0];
         * collection[0] = temp;
         *
         * // Pass the sorted collection to MixItUp
         *
         * mixer.sort(collection)
         *     .then(function(state) {
         *         console.log(state.targets[0] === collection[0]); // true
         *     });
         *
         * @public
         * @instance
         * @since       2.0.0
         * @param       {(string|Array.<HTMLElement>)}    sortString
         *      A valid sort string (e.g. `'default'`, `'published-date:asc'`, or `'random'`). The sort method also accepts an array of all target elements in a user-defined order.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ sort: function() {
            var self = this, instruction = self.parseSortArgs(arguments);
            return self.multimix({
                sort: instruction.command
            }, instruction.animate, instruction.callback);
        },
        /**
         * Changes the layout of the container by adding, removing or updating a
         * layout-specific class name. If `animation.animateResizetargets` is
         * enabled, MixItUp will attempt to gracefully animate the width, height,
         * and position of targets between layout states.
         *
         * @example
         *
         * .changeLayout(containerClassName [, animate] [, callback])
         *
         * @example <caption>Example 1: Adding a new class name to the container</caption>
         *
         * mixer.changeLayout('container-list')
         *      .then(function(state) {
         *          console.log(state.activeContainerClass === 'container-list'); // true
         *      });
         *
         * @example <caption>Example 2: Removing a previously added class name from the container</caption>
         *
         * mixer.changeLayout('')
         *      .then(function(state) {
         *          console.log(state.activeContainerClass === ''); // true
         *      });
         *
         * @public
         * @instance
         * @since       2.0.0
         * @param       {string}    containerClassName
         *      A layout-specific class name to add to the container.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ changeLayout: function() {
            var self = this, instruction = self.parseChangeLayoutArgs(arguments);
            return self.multimix({
                changeLayout: instruction.command
            }, instruction.animate, instruction.callback);
        },
        /**
         * Updates the contents and order of the container to reflect the provided dataset,
         * if the dataset API is in use.
         *
         * The dataset API is designed for use in API-driven JavaScript applications, and
         * can be used instead of DOM-based methods such as `.filter()`, `.sort()`,
         * `.insert()`, etc. When used, insertion, removal, sorting and pagination can be
         * achieved purely via changes to your data model, without the uglyness of having
         * to interact with or query the DOM directly.
         *
         * @example
         *
         * .dataset(dataset [, animate] [, callback])
         *
         * @example <caption>Example 1: Rendering a dataset</caption>
         *
         * var myDataset = [
         *     {id: 1, ...},
         *     {id: 2, ...},
         *     {id: 3, ...}
         * ];
         *
         * mixer.dataset(myDataset)
         *     .then(function(state) {
         *         console.log(state.totalShow === 3); // true
         *     });
         *
         * @example <caption>Example 2: Sorting a dataset</caption>
         *
         * // Create a new dataset in reverse order
         *
         * var newDataset = myDataset.slice().reverse();
         *
         * mixer.dataset(newDataset)
         *     .then(function(state) {
         *         console.log(state.activeDataset[0] === myDataset[2]); // true
         *     });
         *
         * @example <caption>Example 3: Removing an item from the dataset</caption>
         *
         * console.log(myDataset.length); // 3
         *
         * // Create a new dataset with the last item removed.
         *
         * var newDataset = myDataset.slice().pop();
         *
         * mixer.dataset(newDataset)
         *     .then(function(state) {
         *         console.log(state.totalShow === 2); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {Array.<object>}    dataset
         *      An array of objects, each one representing the underlying data model of a target to be rendered.
         * @param       {boolean}           [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}          [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ dataset: function() {
            var self = this, instruction = self.parseDatasetArgs(arguments), operation = null, queueItem = null, animate = false;
            self.callActions("beforeDataset", arguments);
            if (!self.isBusy) {
                if (instruction.callback) self.userCallback = instruction.callback;
                animate = instruction.animate ^ self.config.animation.enable ? instruction.animate : self.config.animation.enable;
                operation = self.getDataOperation(instruction.command.dataset);
                return self.goMix(animate, operation);
            } else {
                queueItem = new mixitup.QueueItem();
                queueItem.args = arguments;
                queueItem.instruction = instruction;
                return self.queueMix(queueItem);
            }
        },
        /**
         * Performs simultaneous `filter`, `sort`, `insert`, `remove` and `changeLayout`
         * operations as requested.
         *
         * @example
         *
         * .multimix(multimixCommand [, animate] [, callback])
         *
         * @example <caption>Example 1: Performing simultaneous filtering and sorting</caption>
         *
         * mixer.multimix({
         *     filter: '.category-b',
         *     sort: 'published-date:desc'
         * })
         *     .then(function(state) {
         *         console.log(state.activeFilter.selector === '.category-b'); // true
         *         console.log(state.activeSort.attribute === 'published-date'); // true
         *     });
         *
         * @example <caption>Example 2: Performing simultaneous sorting, insertion, and removal</caption>
         *
         * console.log(mixer.getState().totalShow); // 6
         *
         * // NB: When inserting via `multimix()`, an object should be provided as the value
         * // for the `insert` portion of the command, allowing for a collection of elements
         * // and an insertion index to be specified.
         *
         * mixer.multimix({
         *     sort: 'published-date:desc', // Sort the container, including any new elements
         *     insert: {
         *         collection: [newElementReferenceA, newElementReferenceB], // Add 2 new elements at index 5
         *         index: 5
         *     },
         *     remove: existingElementReference // Remove 1 existing element
         * })
         *     .then(function(state) {
         *         console.log(state.activeSort.attribute === 'published-date'); // true
         *         console.log(state.totalShow === 7); // true
         *     });
         *
         * @public
         * @instance
         * @since       2.0.0
         * @param       {object}    multimixCommand
         *      An object containing one or more things to do
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ multimix: function() {
            var self = this, operation = null, animate = false, queueItem = null, instruction = self.parseMultimixArgs(arguments);
            self.callActions("beforeMultimix", arguments);
            if (!self.isBusy) {
                operation = self.getOperation(instruction.command);
                if (self.config.controls.enable) {
                    // Update controls for API calls
                    if (instruction.command.filter && !self.isToggling) {
                        // As we are not toggling, reset the toggle array
                        // so new filter overrides existing toggles
                        self.toggleArray.length = 0;
                        self.buildToggleArray(operation.command);
                    }
                    if (self.queue.length < 1) self.updateControls(operation.command);
                }
                if (instruction.callback) self.userCallback = instruction.callback;
                // Always allow the instruction to override the instance setting
                animate = instruction.animate ^ self.config.animation.enable ? instruction.animate : self.config.animation.enable;
                self.callFilters("operationMultimix", operation, arguments);
                return self.goMix(animate, operation);
            } else {
                queueItem = new mixitup.QueueItem();
                queueItem.args = arguments;
                queueItem.instruction = instruction;
                queueItem.triggerElement = self.lastClicked;
                queueItem.isToggling = self.isToggling;
                return self.queueMix(queueItem);
            }
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {object}            multimixCommand
         * @param   {boolean}           [isPreFetch]
         *      An optional boolean indicating that the operation is being pre-fetched for execution at a later time.
         * @return  {Operation|null}
         */ getOperation: function(multimixCommand) {
            var self = this, sortCommand = multimixCommand.sort, filterCommand = multimixCommand.filter, changeLayoutCommand = multimixCommand.changeLayout, removeCommand = multimixCommand.remove, insertCommand = multimixCommand.insert, operation = new mixitup.Operation();
            operation = self.callFilters("operationUnmappedGetOperation", operation, arguments);
            operation.id = h.randomHex();
            operation.command = multimixCommand;
            operation.startState = self.state;
            operation.triggerElement = self.lastClicked;
            if (self.isBusy) {
                if (self.config.debug.showWarnings) console.warn(mixitup.messages.warningGetOperationInstanceBusy());
                return null;
            }
            if (insertCommand) self.insertTargets(insertCommand, operation);
            if (removeCommand) operation.toRemove = removeCommand.targets;
            operation.startSort = operation.newSort = operation.startState.activeSort;
            operation.startOrder = operation.newOrder = self.targets;
            if (sortCommand) {
                operation.startSort = operation.startState.activeSort;
                operation.newSort = sortCommand;
                operation.willSort = self.willSort(sortCommand, operation.startState.activeSort);
                if (operation.willSort) self.sortOperation(operation);
            }
            operation.startFilter = operation.startState.activeFilter;
            if (filterCommand) operation.newFilter = filterCommand;
            else operation.newFilter = h.extend(new mixitup.CommandFilter(), operation.startFilter);
            if (operation.newFilter.selector === "all") operation.newFilter.selector = self.config.selectors.target;
            else if (operation.newFilter.selector === "none") operation.newFilter.selector = "";
            self.filterOperation(operation);
            operation.startContainerClassName = operation.startState.activeContainerClassName;
            if (changeLayoutCommand) {
                operation.newContainerClassName = changeLayoutCommand.containerClassName;
                if (operation.newContainerClassName !== operation.startContainerClassName) operation.willChangeLayout = true;
            } else operation.newContainerClassName = operation.startContainerClassName;
            if (self.config.animation.enable) {
                // Populate the operation's position data
                self.getStartMixData(operation);
                self.setInter(operation);
                operation.docState = h.getDocumentState(self.dom.document);
                self.getInterMixData(operation);
                self.setFinal(operation);
                self.getFinalMixData(operation);
                self.parseEffects();
                operation.hasEffect = self.hasEffect();
                self.getTweenData(operation);
            }
            if (operation.willSort) self.targets = operation.newOrder;
            operation.newState = self.buildState(operation);
            return self.callFilters("operationMappedGetOperation", operation, arguments);
        },
        /**
         * Renders a previously created operation at a specific point in its path, as
         * determined by a multiplier between 0 and 1.
         *
         * @example
         * .tween(operation, multiplier)
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {mixitup.Operation}     operation
         *      An operation object created via the `getOperation` method
         *
         * @param   {Float}                 multiplier
         *      Any number between 0 and 1 representing the percentage complete of the operation
         * @return  {void}
         */ tween: function(operation, multiplier) {
            var target = null, posData = null, toHideIndex = -1, i = -1;
            multiplier = Math.min(multiplier, 1);
            multiplier = Math.max(multiplier, 0);
            for(i = 0; target = operation.show[i]; i++){
                posData = operation.showPosData[i];
                target.applyTween(posData, multiplier);
            }
            for(i = 0; target = operation.hide[i]; i++){
                if (target.isShown) target.hide();
                if ((toHideIndex = operation.toHide.indexOf(target)) > -1) {
                    posData = operation.toHidePosData[toHideIndex];
                    if (!target.isShown) target.show();
                    target.applyTween(posData, multiplier);
                }
            }
        },
        /**
         * Inserts one or more new target elements into the container at a specified
         * index.
         *
         * To be indexed as targets, new elements must match the `selectors.target`
         * selector (`'.mix'` by default).
         *
         * @example
         *
         * .insert(newElements [, index] [, animate], [, callback])
         *
         * @example <caption>Example 1: Inserting a single element via reference</caption>
         *
         * console.log(mixer.getState().totalShow); // 0
         *
         * // Create a new element
         *
         * var newElement = document.createElement('div');
         * newElement.classList.add('mix');
         *
         * mixer.insert(newElement)
         *     .then(function(state) {
         *         console.log(state.totalShow === 1); // true
         *     });
         *
         * @example <caption>Example 2: Inserting a single element via HTML string</caption>
         *
         * console.log(mixer.getState().totalShow); // 1
         *
         * // Create a new element via reference
         *
         * var newElementHtml = '&lt;div class="mix"&gt;&lt;/div&gt;';
         *
         * // Create and insert the new element at index 1
         *
         * mixer.insert(newElementHtml, 1)
         *     .then(function(state) {
         *         console.log(state.totalShow === 2); // true
         *         console.log(state.show[1].outerHTML === newElementHtml); // true
         *     });
         *
         * @example <caption>Example 3: Inserting multiple elements via reference</caption>
         *
         * console.log(mixer.getState().totalShow); // 2
         *
         * // Create an array of new elements to insert.
         *
         * var newElement1 = document.createElement('div');
         * var newElement2 = document.createElement('div');
         *
         * newElement1.classList.add('mix');
         * newElement2.classList.add('mix');
         *
         * var newElementsCollection = [newElement1, newElement2];
         *
         * // Insert the new elements starting at index 1
         *
         * mixer.insert(newElementsCollection, 1)
         *     .then(function(state) {
         *         console.log(state.totalShow === 4); // true
         *         console.log(state.show[1] === newElement1); // true
         *         console.log(state.show[2] === newElement2); // true
         *     });
         *
         * @example <caption>Example 4: Inserting a jQuery collection object containing one or more elements</caption>
         *
         * console.log(mixer.getState().totalShow); // 4
         *
         * var $newElement = $('&lt;div class="mix"&gt;&lt;/div&gt;');
         *
         * // Insert the new elements starting at index 3
         *
         * mixer.insert($newElement, 3)
         *     .then(function(state) {
         *         console.log(state.totalShow === 5); // true
         *         console.log(state.show[3] === $newElement[0]); // true
         *     });
         *
         * @public
         * @instance
         * @since       2.0.0
         * @param       {(HTMLElement|Array.<HTMLElement>|string)}    newElements
         *      A reference to a single element to insert, an array-like collection of elements, or an HTML string representing a single element.
         * @param       {number}    index=0
         *      The index at which to insert the new element(s). `0` by default.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ insert: function() {
            var self = this, args = self.parseInsertArgs(arguments);
            return self.multimix({
                insert: args.command
            }, args.animate, args.callback);
        },
        /**
         * Inserts one or more new elements before a provided reference element.
         *
         * @example
         *
         * .insertBefore(newElements, referenceElement [, animate] [, callback])
         *
         * @example <caption>Example: Inserting a new element before a reference element</caption>
         *
         * // An existing reference element is chosen at index 2
         *
         * var referenceElement = mixer.getState().show[2];
         *
         * // Create a new element
         *
         * var newElement = document.createElement('div');
         * newElement.classList.add('mix');
         *
         * mixer.insertBefore(newElement, referenceElement)
         *     .then(function(state) {
         *         // The new element is inserted into the container at index 2, before the reference element
         *
         *         console.log(state.show[2] === newElement); // true
         *
         *         // The reference element is now at index 3
         *
         *         console.log(state.show[3] === referenceElement); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {(HTMLElement|Array.<HTMLElement>|string)}    newElements
         *      A reference to a single element to insert, an array-like collection of elements, or an HTML string representing a single element.
         * @param       {HTMLElement}    referenceElement
         *      A reference to an existing element in the container to insert new elements before.
         *@param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ insertBefore: function() {
            var self = this, args = self.parseInsertArgs(arguments);
            return self.insert(args.command.collection, "before", args.command.sibling, args.animate, args.callback);
        },
        /**
         * Inserts one or more new elements after a provided reference element.
         *
         * @example
         *
         * .insertAfter(newElements, referenceElement [, animate] [, callback])
         *
         * @example <caption>Example: Inserting a new element after a reference element</caption>
         *
         * // An existing reference element is chosen at index 2
         *
         * var referenceElement = mixer.getState().show[2];
         *
         * // Create a new element
         *
         * var newElement = document.createElement('div');
         * newElement.classList.add('mix');
         *
         * mixer.insertAfter(newElement, referenceElement)
         *     .then(function(state) {
         *         // The new element is inserted into the container at index 3, after the reference element
         *
         *         console.log(state.show[3] === newElement); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {(HTMLElement|Array.<HTMLElement>|string)}    newElements
         *      A reference to a single element to insert, an array-like collection of elements, or an HTML string representing a single element.
         * @param       {HTMLElement}    referenceElement
         *      A reference to an existing element in the container to insert new elements after.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ insertAfter: function() {
            var self = this, args = self.parseInsertArgs(arguments);
            return self.insert(args.command.collection, "after", args.command.sibling, args.animate, args.callback);
        },
        /**
         * Inserts one or more new elements into the container before all existing targets.
         *
         * @example
         *
         * .prepend(newElements [,animate] [,callback])
         *
         * @example <caption>Example: Prepending a new element</caption>
         *
         * // Create a new element
         *
         * var newElement = document.createElement('div');
         * newElement.classList.add('mix');
         *
         * // Insert the element into the container
         *
         * mixer.prepend(newElement)
         *     .then(function(state) {
         *         console.log(state.show[0] === newElement); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {(HTMLElement|Array.<HTMLElement>|string)}    newElements
         *      A reference to a single element to insert, an array-like collection of elements, or an HTML string representing a single element.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ prepend: function() {
            var self = this, args = self.parseInsertArgs(arguments);
            return self.insert(0, args.command.collection, args.animate, args.callback);
        },
        /**
         * Inserts one or more new elements into the container after all existing targets.
         *
         * @example
         *
         * .append(newElements [,animate] [,callback])
         *
         * @example <caption>Example: Appending a new element</caption>
         *
         * // Create a new element
         *
         * var newElement = document.createElement('div');
         * newElement.classList.add('mix');
         *
         * // Insert the element into the container
         *
         * mixer.append(newElement)
         *     .then(function(state) {
         *         console.log(state.show[state.show.length - 1] === newElement); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {(HTMLElement|Array.<HTMLElement>|string)}    newElements
         *      A reference to a single element to insert, an array-like collection of elements, or an HTML string representing a single element.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ append: function() {
            var self = this, args = self.parseInsertArgs(arguments);
            return self.insert(self.state.totalTargets, args.command.collection, args.animate, args.callback);
        },
        /**
         * Removes one or more existing target elements from the container.
         *
         * @example
         *
         * .remove(elements [, animate] [, callback])
         *
         * @example <caption>Example 1: Removing an element by reference</caption>
         *
         * var elementToRemove = containerEl.firstElementChild;
         *
         * mixer.remove(elementToRemove)
         *      .then(function(state) {
         *          console.log(state.targets.indexOf(elementToRemove) === -1); // true
         *      });
         *
         * @example <caption>Example 2: Removing a collection of elements by reference</caption>
         *
         * var elementsToRemove = containerEl.querySelectorAll('.category-a');
         *
         * console.log(elementsToRemove.length) // 3
         *
         * mixer.remove(elementsToRemove)
         *      .then(function() {
         *          console.log(containerEl.querySelectorAll('.category-a').length); // 0
         *      });
         *
         * @example <caption>Example 3: Removing one or more elements by selector</caption>
         *
         * mixer.remove('.category-a')
         *      .then(function() {
         *          console.log(containerEl.querySelectorAll('.category-a').length); // 0
         *      });
         *
         * @example <caption>Example 4: Removing an element by index</caption>
         *
         * console.log(mixer.getState.totalShow); // 4
         *
         * // Remove the element at index 3
         *
         * mixer.remove(3)
         *      .then(function(state) {
         *          console.log(state.totalShow); // 3
         *          console.log(state.show[3]); // undefined
         *      });
         *
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {(HTMLElement|Array.<HTMLElement>|string|number)}    elements
         *      A reference to a single element to remove, an array-like collection of elements, a selector string, or the index of an element to remove.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ remove: function() {
            var self = this, args = self.parseRemoveArgs(arguments);
            return self.multimix({
                remove: args.command
            }, args.animate, args.callback);
        },
        /**
         * Retrieves the the value of any property or sub-object within the current
         * mixitup configuration, or the whole configuration object.
         *
         * @example
         *
         * .getConfig([stringKey])
         *
         * @example <caption>Example 1: retrieve the entire configuration object</caption>
         *
         * var config = mixer.getConfig(); // Config { ... }
         *
         * @example <caption>Example 2: retrieve a named sub-object of configuration object</caption>
         *
         * var animation = mixer.getConfig('animation'); // ConfigAnimation { ... }
         *
         * @example <caption>Example 3: retrieve a value of configuration object via a dot-notation string key</caption>
         *
         * var effects = mixer.getConfig('animation.effects'); // 'fade scale'
         *
         * @public
         * @instance
         * @since       2.0.0
         * @param       {string}    [stringKey]    A "dot-notation" string key
         * @return      {*}
         */ getConfig: function(stringKey) {
            var self = this, value = null;
            if (!stringKey) value = self.config;
            else value = h.getProperty(self.config, stringKey);
            return self.callFilters("valueGetConfig", value, arguments);
        },
        /**
         * Updates the configuration of the mixer, after it has been instantiated.
         *
         * See the Configuration Object documentation for a full list of avilable
         * configuration options.
         *
         * @example
         *
         * .configure(config)
         *
         * @example <caption>Example 1: Updating animation options</caption>
         *
         * mixer.configure({
         *     animation: {
         *         effects: 'fade translateX(-100%)',
         *         duration: 300
         *     }
         * });
         *
         * @example <caption>Example 2: Removing a callback after it has been set</caption>
         *
         * var mixer;
         *
         * function handleMixEndOnce() {
         *     // Do something ..
         *
         *     // Then nullify the callback
         *
         *     mixer.configure({
         *         callbacks: {
         *             onMixEnd: null
         *         }
         *     });
         * };
         *
         * // Instantiate a mixer with a callback defined
         *
         * mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixEnd: handleMixEndOnce
         *     }
         * });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {object}    config
         *      An object containing one of more configuration options.
         * @return      {void}
         */ configure: function(config) {
            var self = this;
            self.callActions("beforeConfigure", arguments);
            h.extend(self.config, config, true, true);
            self.callActions("afterConfigure", arguments);
        },
        /**
         * Returns an object containing information about the current state of the
         * mixer. See the State Object documentation for more information.
         *
         * NB: State objects are immutable and should therefore be regenerated
         * after any operation.
         *
         * @example
         *
         * .getState();
         *
         * @example <caption>Example: Retrieving a state object</caption>
         *
         * var state = mixer.getState();
         *
         * console.log(state.totalShow + 'targets are currently shown');
         *
         * @public
         * @instance
         * @since       2.0.0
         * @return      {mixitup.State} An object reflecting the current state of the mixer.
         */ getState: function() {
            var self = this, state = null;
            state = new mixitup.State();
            h.extend(state, self.state);
            h.freeze(state);
            return self.callFilters("stateGetState", state, arguments);
        },
        /**
         * Forces the re-indexing all targets within the container.
         *
         * This should only be used if some other piece of code in your application
         * has manipulated the contents of your container, which should be avoided.
         *
         * If you need to add or remove target elements from the container, use
         * the built-in `.insert()` or `.remove()` methods, and MixItUp will keep
         * itself up to date.
         *
         * @example
         *
         * .forceRefresh()
         *
         * @example <caption>Example: Force refreshing the mixer after external DOM manipulation</caption>
         *
         * console.log(mixer.getState().totalShow); // 3
         *
         * // An element is removed from the container via some external DOM manipulation code:
         *
         * containerEl.removeChild(containerEl.firstElementChild);
         *
         * // The mixer does not know that the number of targets has changed:
         *
         * console.log(mixer.getState().totalShow); // 3
         *
         * mixer.forceRefresh();
         *
         * // After forceRefresh, the mixer is in sync again:
         *
         * console.log(mixer.getState().totalShow); // 2
         *
         * @public
         * @instance
         * @since 2.1.2
         * @return {void}
         */ forceRefresh: function() {
            var self = this;
            self.indexTargets();
        },
        /**
         * Forces the re-rendering of all targets when using the Dataset API.
         *
         * By default, targets are only re-rendered when `data.dirtyCheck` is
         * enabled, and an item's data has changed when `dataset()` is called.
         *
         * The `forceRender()` method allows for the re-rendering of all targets
         * in response to some arbitrary event, such as the changing of the target
         * render function.
         *
         * Targets are rendered against their existing data.
         *
         * @example
         *
         * .forceRender()
         *
         * @example <caption>Example: Force render targets after changing the target render function</caption>
         *
         * console.log(container.innerHTML); // ... &lt;span class="mix"&gt;Foo&lt;/span&gt; ...
         *
         * mixer.configure({
         *     render: {
         *         target: (item) => `&lt;a href="/${item.slug}/" class="mix"&gt;${item.title}&lt;/a&gt;`
         *     }
         * });
         *
         * mixer.forceRender();
         *
         * console.log(container.innerHTML); // ... &lt;a href="/foo/" class="mix"&gt;Foo&lt;/a&gt; ...
         *
         * @public
         * @instance
         * @since 3.2.1
         * @return {void}
         */ forceRender: function() {
            var self = this, target = null, el = null, id = "";
            for(id in self.cache){
                target = self.cache[id];
                el = target.render(target.data);
                if (el !== target.dom.el) {
                    // Update target element reference
                    if (target.isInDom) {
                        target.unbindEvents();
                        self.dom.parent.replaceChild(el, target.dom.el);
                    }
                    if (!target.isShown) el.style.display = "none";
                    target.dom.el = el;
                    if (target.isInDom) target.bindEvents();
                }
            }
            self.state = self.buildState(self.lastOperation);
        },
        /**
         * Removes mixitup functionality from the container, unbinds all control
         * event handlers, and deletes the mixer instance from MixItUp's internal
         * cache.
         *
         * This should be performed whenever a mixer's container is removed from
         * the DOM, such as during a page change in a single page application,
         * or React's `componentWillUnmount()`.
         *
         * @example
         *
         * .destroy([cleanUp])
         *
         * @example <caption>Example: Destroying the mixer before removing its container element</caption>
         *
         * mixer.destroy();
         *
         * containerEl.parentElement.removeChild(containerEl);
         *
         * @public
         * @instance
         * @since   2.0.0
         * @param   {boolean}   [cleanUp=false]
         *     An optional boolean dictating whether or not to clean up any inline `display: none;` styling applied to hidden targets.
         * @return  {void}
         */ destroy: function(cleanUp) {
            var self = this, control = null, target = null, i = 0;
            self.callActions("beforeDestroy", arguments);
            for(i = 0; control = self.controls[i]; i++)control.removeBinding(self);
            for(i = 0; target = self.targets[i]; i++){
                if (cleanUp) target.show();
                target.unbindEvents();
            }
            if (self.dom.container.id.match(/^MixItUp/)) self.dom.container.removeAttribute("id");
            delete mixitup.instances[self.id];
            self.callActions("afterDestroy", arguments);
        }
    });
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.IMoveData = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.posIn = null;
        this.posOut = null;
        this.operation = null;
        this.callback = null;
        this.statusChange = "";
        this.duration = -1;
        this.staggerIndex = -1;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.IMoveData);
    mixitup.IMoveData.prototype = Object.create(mixitup.Base.prototype);
    mixitup.IMoveData.prototype.constructor = mixitup.IMoveData;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.TargetDom = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.el = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.TargetDom);
    mixitup.TargetDom.prototype = Object.create(mixitup.Base.prototype);
    mixitup.TargetDom.prototype.constructor = mixitup.TargetDom;
    /**
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Target = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.id = "";
        this.sortString = "";
        this.mixer = null;
        this.callback = null;
        this.isShown = false;
        this.isBound = false;
        this.isExcluded = false;
        this.isInDom = false;
        this.handler = null;
        this.operation = null;
        this.data = null;
        this.dom = new mixitup.TargetDom();
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Target);
    mixitup.Target.prototype = Object.create(mixitup.Base.prototype);
    h.extend(mixitup.Target.prototype, {
        constructor: mixitup.Target,
        /**
         * Initialises a newly instantiated Target.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {(Element|null)}    el
         * @param   {object}            mixer
         * @param   {object}            [data]
         * @return  {void}
         */ init: function(el, mixer, data) {
            var self = this, id = "";
            self.callActions("beforeInit", arguments);
            self.mixer = mixer;
            if (!el) // If no element is provided, render it
            el = self.render(data);
            self.cacheDom(el);
            self.bindEvents();
            if (self.dom.el.style.display !== "none") self.isShown = true;
            if (data && mixer.config.data.uidKey) {
                if (typeof (id = data[mixer.config.data.uidKey]) === "undefined" || id.toString().length < 1) throw new TypeError(mixitup.messages.errorDatasetInvalidUidKey({
                    uidKey: mixer.config.data.uidKey
                }));
                self.id = id;
                self.data = data;
                mixer.cache[id] = self;
            }
            self.callActions("afterInit", arguments);
        },
        /**
         * Renders the target element using a user-defined renderer function.
         *
         * @private
         * @instance
         * @since   3.1.4
         * @param   {object} data
         * @return  {void}
         */ render: function(data) {
            var self = this, render = null, el = null, temp = null, output = "";
            self.callActions("beforeRender", arguments);
            render = self.callFilters("renderRender", self.mixer.config.render.target, arguments);
            if (typeof render !== "function") throw new TypeError(mixitup.messages.errorDatasetRendererNotSet());
            output = render(data);
            if (output && typeof output === "object" && h.isElement(output)) el = output;
            else if (typeof output === "string") {
                temp = document.createElement("div");
                temp.innerHTML = output;
                el = temp.firstElementChild;
            }
            return self.callFilters("elRender", el, arguments);
        },
        /**
         * Caches references of DOM elements neccessary for the target's functionality.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Element} el
         * @return  {void}
         */ cacheDom: function(el) {
            var self = this;
            self.callActions("beforeCacheDom", arguments);
            self.dom.el = el;
            self.callActions("afterCacheDom", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {string}    attributeName
         * @return  {void}
         */ getSortString: function(attributeName) {
            var self = this, value = self.dom.el.getAttribute("data-" + attributeName) || "";
            self.callActions("beforeGetSortString", arguments);
            value = isNaN(value * 1) ? value.toLowerCase() : value * 1;
            self.sortString = value;
            self.callActions("afterGetSortString", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @return  {void}
         */ show: function() {
            var self = this;
            self.callActions("beforeShow", arguments);
            if (!self.isShown) {
                self.dom.el.style.display = "";
                self.isShown = true;
            }
            self.callActions("afterShow", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @return  {void}
         */ hide: function() {
            var self = this;
            self.callActions("beforeHide", arguments);
            if (self.isShown) {
                self.dom.el.style.display = "none";
                self.isShown = false;
            }
            self.callActions("afterHide", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {mixitup.IMoveData} moveData
         * @return  {void}
         */ move: function(moveData) {
            var self = this;
            self.callActions("beforeMove", arguments);
            if (!self.isExcluded) self.mixer.targetsMoved++;
            self.applyStylesIn(moveData);
            requestAnimationFrame(function() {
                self.applyStylesOut(moveData);
            });
            self.callActions("afterMove", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {object}    posData
         * @param   {number}    multiplier
         * @return  {void}
         */ applyTween: function(posData, multiplier) {
            var self = this, propertyName = "", tweenData = null, posIn = posData.posIn, currentTransformValues = [], currentValues = new mixitup.StyleData(), i = -1;
            self.callActions("beforeApplyTween", arguments);
            currentValues.x = posIn.x;
            currentValues.y = posIn.y;
            if (multiplier === 0) self.hide();
            else if (!self.isShown) self.show();
            for(i = 0; propertyName = mixitup.features.TWEENABLE[i]; i++){
                tweenData = posData.tweenData[propertyName];
                if (propertyName === "x") {
                    if (!tweenData) continue;
                    currentValues.x = posIn.x + tweenData * multiplier;
                } else if (propertyName === "y") {
                    if (!tweenData) continue;
                    currentValues.y = posIn.y + tweenData * multiplier;
                } else if (tweenData instanceof mixitup.TransformData) {
                    if (!tweenData.value) continue;
                    currentValues[propertyName].value = posIn[propertyName].value + tweenData.value * multiplier;
                    currentValues[propertyName].unit = tweenData.unit;
                    currentTransformValues.push(propertyName + "(" + currentValues[propertyName].value + tweenData.unit + ")");
                } else {
                    if (!tweenData) continue;
                    currentValues[propertyName] = posIn[propertyName] + tweenData * multiplier;
                    self.dom.el.style[propertyName] = currentValues[propertyName];
                }
            }
            if (currentValues.x || currentValues.y) currentTransformValues.unshift("translate(" + currentValues.x + "px, " + currentValues.y + "px)");
            if (currentTransformValues.length) self.dom.el.style[mixitup.features.transformProp] = currentTransformValues.join(" ");
            self.callActions("afterApplyTween", arguments);
        },
        /**
         * Applies the initial styling to a target element before any transition
         * is applied.
         *
         * @private
         * @instance
         * @param   {mixitup.IMoveData} moveData
         * @return  {void}
         */ applyStylesIn: function(moveData) {
            var self = this, posIn = moveData.posIn, isFading = self.mixer.effectsIn.opacity !== 1, transformValues = [];
            self.callActions("beforeApplyStylesIn", arguments);
            transformValues.push("translate(" + posIn.x + "px, " + posIn.y + "px)");
            if (self.mixer.config.animation.animateResizeTargets) {
                if (moveData.statusChange !== "show") {
                    // Don't apply posIn width or height or showing, as will be 0
                    self.dom.el.style.width = posIn.width + "px";
                    self.dom.el.style.height = posIn.height + "px";
                }
                self.dom.el.style.marginRight = posIn.marginRight + "px";
                self.dom.el.style.marginBottom = posIn.marginBottom + "px";
            }
            isFading && (self.dom.el.style.opacity = posIn.opacity);
            if (moveData.statusChange === "show") transformValues = transformValues.concat(self.mixer.transformIn);
            self.dom.el.style[mixitup.features.transformProp] = transformValues.join(" ");
            self.callActions("afterApplyStylesIn", arguments);
        },
        /**
         * Applies a transition followed by the final styles for the element to
         * transition towards.
         *
         * @private
         * @instance
         * @param   {mixitup.IMoveData} moveData
         * @return  {void}
         */ applyStylesOut: function(moveData) {
            var self = this, transitionRules = [], transformValues = [], isResizing = self.mixer.config.animation.animateResizeTargets, isFading = typeof self.mixer.effectsIn.opacity !== "undefined";
            self.callActions("beforeApplyStylesOut", arguments);
            // Build the transition rules
            transitionRules.push(self.writeTransitionRule(mixitup.features.transformRule, moveData.staggerIndex));
            if (moveData.statusChange !== "none") transitionRules.push(self.writeTransitionRule("opacity", moveData.staggerIndex, moveData.duration));
            if (isResizing) {
                transitionRules.push(self.writeTransitionRule("width", moveData.staggerIndex, moveData.duration));
                transitionRules.push(self.writeTransitionRule("height", moveData.staggerIndex, moveData.duration));
                transitionRules.push(self.writeTransitionRule("margin", moveData.staggerIndex, moveData.duration));
            }
            // If no callback was provided, the element will
            // not transition in any way so tag it as "immovable"
            if (!moveData.callback) {
                self.mixer.targetsImmovable++;
                if (self.mixer.targetsMoved === self.mixer.targetsImmovable) // If the total targets moved is equal to the
                // number of immovable targets, the operation
                // should be considered finished
                self.mixer.cleanUp(moveData.operation);
                return;
            }
            // If the target will transition in some fasion,
            // assign a callback function
            self.operation = moveData.operation;
            self.callback = moveData.callback;
            // As long as the target is not excluded, increment
            // the total number of targets bound
            !self.isExcluded && self.mixer.targetsBound++;
            // Tag the target as bound to differentiate from transitionEnd
            // events that may come from stylesheet driven effects
            self.isBound = true;
            // Apply the transition
            self.applyTransition(transitionRules);
            // Apply width, height and margin negation
            if (isResizing && moveData.posOut.width > 0 && moveData.posOut.height > 0) {
                self.dom.el.style.width = moveData.posOut.width + "px";
                self.dom.el.style.height = moveData.posOut.height + "px";
                self.dom.el.style.marginRight = moveData.posOut.marginRight + "px";
                self.dom.el.style.marginBottom = moveData.posOut.marginBottom + "px";
            }
            if (!self.mixer.config.animation.nudge && moveData.statusChange === "hide") // If we're not nudging, the translation should be
            // applied before any other transforms to prevent
            // lateral movement
            transformValues.push("translate(" + moveData.posOut.x + "px, " + moveData.posOut.y + "px)");
            // Apply fade
            switch(moveData.statusChange){
                case "hide":
                    isFading && (self.dom.el.style.opacity = self.mixer.effectsOut.opacity);
                    transformValues = transformValues.concat(self.mixer.transformOut);
                    break;
                case "show":
                    isFading && (self.dom.el.style.opacity = 1);
            }
            if (self.mixer.config.animation.nudge || !self.mixer.config.animation.nudge && moveData.statusChange !== "hide") // Opposite of above - apply translate after
            // other transform
            transformValues.push("translate(" + moveData.posOut.x + "px, " + moveData.posOut.y + "px)");
            // Apply transforms
            self.dom.el.style[mixitup.features.transformProp] = transformValues.join(" ");
            self.callActions("afterApplyStylesOut", arguments);
        },
        /**
         * Combines the name of a CSS property with the appropriate duration and delay
         * values to created a valid transition rule.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {string}    property
         * @param   {number}    staggerIndex
         * @param   {number}    duration
         * @return  {string}
         */ writeTransitionRule: function(property, staggerIndex, duration) {
            var self = this, delay = self.getDelay(staggerIndex), rule = "";
            rule = property + " " + (duration > 0 ? duration : self.mixer.config.animation.duration) + "ms " + delay + "ms " + (property === "opacity" ? "linear" : self.mixer.config.animation.easing);
            return self.callFilters("ruleWriteTransitionRule", rule, arguments);
        },
        /**
         * Calculates the transition delay for each target element based on its index, if
         * staggering is applied. If defined, A custom `animation.staggerSeqeuence`
         * function can be used to manipulate the order of indices to produce custom
         * stagger effects (e.g. for use in a grid with irregular row lengths).
         *
         * @private
         * @instance
         * @since   2.0.0
         * @param   {number}    index
         * @return  {number}
         */ getDelay: function(index) {
            var self = this, delay = -1;
            if (typeof self.mixer.config.animation.staggerSequence === "function") index = self.mixer.config.animation.staggerSequence.call(self, index, self.state);
            delay = !!self.mixer.staggerDuration ? index * self.mixer.staggerDuration : 0;
            return self.callFilters("delayGetDelay", delay, arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {string[]}  rules
         * @return  {void}
         */ applyTransition: function(rules) {
            var self = this, transitionString = rules.join(", ");
            self.callActions("beforeApplyTransition", arguments);
            self.dom.el.style[mixitup.features.transitionProp] = transitionString;
            self.callActions("afterApplyTransition", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Event} e
         * @return  {void}
         */ handleTransitionEnd: function(e) {
            var self = this, propName = e.propertyName, canResize = self.mixer.config.animation.animateResizeTargets;
            self.callActions("beforeHandleTransitionEnd", arguments);
            if (self.isBound && e.target.matches(self.mixer.config.selectors.target) && (propName.indexOf("transform") > -1 || propName.indexOf("opacity") > -1 || canResize && propName.indexOf("height") > -1 || canResize && propName.indexOf("width") > -1 || canResize && propName.indexOf("margin") > -1)) {
                self.callback.call(self, self.operation);
                self.isBound = false;
                self.callback = null;
                self.operation = null;
            }
            self.callActions("afterHandleTransitionEnd", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Event}     e
         * @return  {void}
         */ eventBus: function(e) {
            var self = this;
            self.callActions("beforeEventBus", arguments);
            switch(e.type){
                case "webkitTransitionEnd":
                case "transitionend":
                    self.handleTransitionEnd(e);
            }
            self.callActions("afterEventBus", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @return  {void}
         */ unbindEvents: function() {
            var self = this;
            self.callActions("beforeUnbindEvents", arguments);
            h.off(self.dom.el, "webkitTransitionEnd", self.handler);
            h.off(self.dom.el, "transitionend", self.handler);
            self.callActions("afterUnbindEvents", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @return  {void}
         */ bindEvents: function() {
            var self = this, transitionEndEvent = "";
            self.callActions("beforeBindEvents", arguments);
            transitionEndEvent = mixitup.features.transitionPrefix === "webkit" ? "webkitTransitionEnd" : "transitionend";
            self.handler = function(e) {
                return self.eventBus(e);
            };
            h.on(self.dom.el, transitionEndEvent, self.handler);
            self.callActions("afterBindEvents", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {boolean}   [getBox]
         * @return  {PosData}
         */ getPosData: function(getBox) {
            var self = this, styles = {}, rect = null, posData = new mixitup.StyleData();
            self.callActions("beforeGetPosData", arguments);
            posData.x = self.dom.el.offsetLeft;
            posData.y = self.dom.el.offsetTop;
            if (self.mixer.config.animation.animateResizeTargets || getBox) {
                rect = self.dom.el.getBoundingClientRect();
                posData.top = rect.top;
                posData.right = rect.right;
                posData.bottom = rect.bottom;
                posData.left = rect.left;
                posData.width = rect.width;
                posData.height = rect.height;
            }
            if (self.mixer.config.animation.animateResizeTargets) {
                styles = window1.getComputedStyle(self.dom.el);
                posData.marginBottom = parseFloat(styles.marginBottom);
                posData.marginRight = parseFloat(styles.marginRight);
            }
            return self.callFilters("posDataGetPosData", posData, arguments);
        },
        /**
         * @private
         * @instance
         * @since       3.0.0
         * @return      {void}
         */ cleanUp: function() {
            var self = this;
            self.callActions("beforeCleanUp", arguments);
            self.dom.el.style[mixitup.features.transformProp] = "";
            self.dom.el.style[mixitup.features.transitionProp] = "";
            self.dom.el.style.opacity = "";
            if (self.mixer.config.animation.animateResizeTargets) {
                self.dom.el.style.width = "";
                self.dom.el.style.height = "";
                self.dom.el.style.marginRight = "";
                self.dom.el.style.marginBottom = "";
            }
            self.callActions("afterCleanUp", arguments);
        }
    });
    /**
     * A jQuery-collection-like wrapper around one or more `mixitup.Mixer` instances
     * allowing simultaneous control of said instances similar to the MixItUp 2 API.
     *
     * @example
     * new mixitup.Collection(instances)
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     * @param       {mixitup.Mixer[]}   instances
     */ mixitup.Collection = function(instances) {
        var instance = null, i = -1;
        this.callActions("beforeConstruct");
        for(i = 0; instance = instances[i]; i++)this[i] = instance;
        this.length = instances.length;
        this.callActions("afterConstruct");
        h.freeze(this);
    };
    mixitup.BaseStatic.call(mixitup.Collection);
    mixitup.Collection.prototype = Object.create(mixitup.Base.prototype);
    h.extend(mixitup.Collection.prototype, /** @lends mixitup.Collection */ {
        constructor: mixitup.Collection,
        /**
         * Calls a method on all instances in the collection by passing the method
         * name as a string followed by any applicable parameters to be curried into
         * to the method.
         *
         * @example
         * .mixitup(methodName[,arg1][,arg2..]);
         *
         * @example
         * var collection = new Collection([mixer1, mixer2]);
         *
         * return collection.mixitup('filter', '.category-a')
         *     .then(function(states) {
         *         state.forEach(function(state) {
         *             console.log(state.activeFilter.selector); // .category-a
         *         });
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {string}  methodName
         * @return      {Promise<Array<mixitup.State>>}
         */ mixitup: function(methodName) {
            var self = this, instance = null, args = Array.prototype.slice.call(arguments), tasks = [], i = -1;
            this.callActions("beforeMixitup");
            args.shift();
            for(i = 0; instance = self[i]; i++)tasks.push(instance[methodName].apply(instance, args));
            return self.callFilters("promiseMixitup", h.all(tasks, mixitup.libraries), arguments);
        }
    });
    /**
     * `mixitup.Operation` objects contain all data neccessary to describe the full
     * lifecycle of any MixItUp operation. They can be used to compute and store an
     * operation for use at a later time (e.g. programmatic tweening).
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Operation = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.id = "";
        this.args = [];
        this.command = null;
        this.showPosData = [];
        this.toHidePosData = [];
        this.startState = null;
        this.newState = null;
        this.docState = null;
        this.willSort = false;
        this.willChangeLayout = false;
        this.hasEffect = false;
        this.hasFailed = false;
        this.triggerElement = null;
        this.show = [];
        this.hide = [];
        this.matching = [];
        this.toShow = [];
        this.toHide = [];
        this.toMove = [];
        this.toRemove = [];
        this.startOrder = [];
        this.newOrder = [];
        this.startSort = null;
        this.newSort = null;
        this.startFilter = null;
        this.newFilter = null;
        this.startDataset = null;
        this.newDataset = null;
        this.viewportDeltaX = 0;
        this.viewportDeltaY = 0;
        this.startX = 0;
        this.startY = 0;
        this.startHeight = 0;
        this.startWidth = 0;
        this.newX = 0;
        this.newY = 0;
        this.newHeight = 0;
        this.newWidth = 0;
        this.startContainerClassName = "";
        this.startDisplay = "";
        this.newContainerClassName = "";
        this.newDisplay = "";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Operation);
    mixitup.Operation.prototype = Object.create(mixitup.Base.prototype);
    mixitup.Operation.prototype.constructor = mixitup.Operation;
    /**
     * `mixitup.State` objects expose various pieces of data detailing the state of
     * a MixItUp instance. They are provided at the start and end of any operation via
     * callbacks and events, with the most recent state stored between operations
     * for retrieval at any time via the API.
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @public
     * @since       3.0.0
     */ mixitup.State = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * The ID of the mixer instance.
         *
         * @name        id
         * @memberof    mixitup.State
         * @instance
         * @type        {string}
         * @default     ''
         */ this.id = "";
        /**
         * The currently active filter command as set by a control click or API call.
         *
         * @name        activeFilter
         * @memberof    mixitup.State
         * @instance
         * @type        {mixitup.CommandFilter}
         * @default     null
         */ this.activeFilter = null;
        /**
         * The currently active sort command as set by a control click or API call.
         *
         * @name        activeSort
         * @memberof    mixitup.State
         * @instance
         * @type        {mixitup.CommandSort}
         * @default     null
         */ this.activeSort = null;
        /**
         * The current layout-specific container class name, if applied.
         *
         * @name        activeContainerClassName
         * @memberof    mixitup.State
         * @instance
         * @type        {string}
         * @default     ''
         */ this.activeContainerClassName = "";
        /**
         * A reference to the container element that the mixer is instantiated on.
         *
         * @name        container
         * @memberof    mixitup.State
         * @instance
         * @type        {Element}
         * @default     null
         */ this.container = null;
        /**
         * An array of all target elements indexed by the mixer.
         *
         * @name        targets
         * @memberof    mixitup.State
         * @instance
         * @type        {Array.<Element>}
         * @default     []
         */ this.targets = [];
        /**
         * An array of all target elements not matching the current filter.
         *
         * @name        hide
         * @memberof    mixitup.State
         * @instance
         * @type        {Array.<Element>}
         * @default     []
         */ this.hide = [];
        /**
         * An array of all target elements matching the current filter and any additional
         * limits applied such as pagination.
         *
         * @name        show
         * @memberof    mixitup.State
         * @instance
         * @type        {Array.<Element>}
         * @default     []
         */ this.show = [];
        /**
         * An array of all target elements matching the current filter irrespective of
         * any additional limits applied such as pagination.
         *
         * @name        matching
         * @memberof    mixitup.State
         * @instance
         * @type        {Array.<Element>}
         * @default     []
         */ this.matching = [];
        /**
         * An integer representing the total number of target elements indexed by the
         * mixer. Equivalent to `state.targets.length`.
         *
         * @name        totalTargets
         * @memberof    mixitup.State
         * @instance
         * @type        {number}
         * @default     -1
         */ this.totalTargets = -1;
        /**
         * An integer representing the total number of target elements matching the
         * current filter and any additional limits applied such as pagination.
         * Equivalent to `state.show.length`.
         *
         * @name        totalShow
         * @memberof    mixitup.State
         * @instance
         * @type        {number}
         * @default     -1
         */ this.totalShow = -1;
        /**
         * An integer representing the total number of target elements not matching
         * the current filter. Equivalent to `state.hide.length`.
         *
         * @name        totalHide
         * @memberof    mixitup.State
         * @instance
         * @type        {number}
         * @default     -1
         */ this.totalHide = -1;
        /**
         * An integer representing the total number of target elements matching the
         * current filter irrespective of any other limits applied such as pagination.
         * Equivalent to `state.matching.length`.
         *
         * @name        totalMatching
         * @memberof    mixitup.State
         * @instance
         * @type        {number}
         * @default     -1
         */ this.totalMatching = -1;
        /**
         * A boolean indicating whether the last operation "failed", i.e. no targets
         * could be found matching the filter.
         *
         * @name        hasFailed
         * @memberof    mixitup.State
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.hasFailed = false;
        /**
         * The DOM element that was clicked if the last operation was triggered by the
         * clicking of a control and not an API call.
         *
         * @name        triggerElement
         * @memberof    mixitup.State
         * @instance
         * @type        {Element|null}
         * @default     null
         */ this.triggerElement = null;
        /**
         * The currently active dataset underlying the rendered targets, if the
         * dataset API is in use.
         *
         * @name        activeDataset
         * @memberof    mixitup.State
         * @instance
         * @type        {Array.<object>}
         * @default     null
         */ this.activeDataset = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.State);
    mixitup.State.prototype = Object.create(mixitup.Base.prototype);
    mixitup.State.prototype.constructor = mixitup.State;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.UserInstruction = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.command = {};
        this.animate = false;
        this.callback = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.UserInstruction);
    mixitup.UserInstruction.prototype = Object.create(mixitup.Base.prototype);
    mixitup.UserInstruction.prototype.constructor = mixitup.UserInstruction;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Messages = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /* Errors
        ----------------------------------------------------------------------------- */ this.ERROR_FACTORY_INVALID_CONTAINER = "[MixItUp] An invalid selector or element reference was passed to the mixitup factory function";
        this.ERROR_FACTORY_CONTAINER_NOT_FOUND = "[MixItUp] The provided selector yielded no container element";
        this.ERROR_CONFIG_INVALID_ANIMATION_EFFECTS = "[MixItUp] Invalid value for `animation.effects`";
        this.ERROR_CONFIG_INVALID_CONTROLS_SCOPE = "[MixItUp] Invalid value for `controls.scope`";
        this.ERROR_CONFIG_INVALID_PROPERTY = '[MixitUp] Invalid configuration object property "${erroneous}"${suggestion}';
        this.ERROR_CONFIG_INVALID_PROPERTY_SUGGESTION = '. Did you mean "${probableMatch}"?';
        this.ERROR_CONFIG_DATA_UID_KEY_NOT_SET = "[MixItUp] To use the dataset API, a UID key must be specified using `data.uidKey`";
        this.ERROR_DATASET_INVALID_UID_KEY = '[MixItUp] The specified UID key "${uidKey}" is not present on one or more dataset items';
        this.ERROR_DATASET_DUPLICATE_UID = '[MixItUp] The UID "${uid}" was found on two or more dataset items. UIDs must be unique.';
        this.ERROR_INSERT_INVALID_ARGUMENTS = "[MixItUp] Please provider either an index or a sibling and position to insert, not both";
        this.ERROR_INSERT_PREEXISTING_ELEMENT = "[MixItUp] An element to be inserted already exists in the container";
        this.ERROR_FILTER_INVALID_ARGUMENTS = "[MixItUp] Please provide either a selector or collection `.filter()`, not both";
        this.ERROR_DATASET_NOT_SET = "[MixItUp] To use the dataset API with pre-rendered targets, a starting dataset must be set using `load.dataset`";
        this.ERROR_DATASET_PRERENDERED_MISMATCH = "[MixItUp] `load.dataset` does not match pre-rendered targets";
        this.ERROR_DATASET_RENDERER_NOT_SET = "[MixItUp] To insert an element via the dataset API, a target renderer function must be provided to `render.target`";
        this.ERROR_SORT_NON_EXISTENT_ELEMENT = "[MixItUp] An element to be sorted does not already exist in the container";
        /* Warnings
        ----------------------------------------------------------------------------- */ this.WARNING_FACTORY_PREEXISTING_INSTANCE = "[MixItUp] WARNING: This element already has an active MixItUp instance. The provided configuration object will be ignored. If you wish to perform additional methods on this instance, please create a reference.";
        this.WARNING_INSERT_NO_ELEMENTS = "[MixItUp] WARNING: No valid elements were passed to `.insert()`";
        this.WARNING_REMOVE_NO_ELEMENTS = "[MixItUp] WARNING: No valid elements were passed to `.remove()`";
        this.WARNING_MULTIMIX_INSTANCE_QUEUE_FULL = "[MixItUp] WARNING: An operation was requested but the MixItUp instance was busy. The operation was rejected because the queue is full or queuing is disabled.";
        this.WARNING_GET_OPERATION_INSTANCE_BUSY = "[MixItUp] WARNING: Operations can be be created while the MixItUp instance is busy.";
        this.WARNING_NO_PROMISE_IMPLEMENTATION = "[MixItUp] WARNING: No Promise implementations could be found. If you wish to use promises with MixItUp please install an ES6 Promise polyfill.";
        this.WARNING_INCONSISTENT_SORTING_ATTRIBUTES = '[MixItUp] WARNING: The requested sorting data attribute "${attribute}" was not present on one or more target elements which may product unexpected sort output';
        this.callActions("afterConstruct");
        this.compileTemplates();
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Messages);
    mixitup.Messages.prototype = Object.create(mixitup.Base.prototype);
    mixitup.Messages.prototype.constructor = mixitup.Messages;
    /**
     * @return {void}
     */ mixitup.Messages.prototype.compileTemplates = function() {
        var errorKey = "";
        var errorMessage = "";
        for(errorKey in this){
            if (typeof (errorMessage = this[errorKey]) !== "string") continue;
            this[h.camelCase(errorKey)] = h.template(errorMessage);
        }
    };
    mixitup.messages = new mixitup.Messages();
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     * @param       {mixitup.Mixer} mixer
     */ mixitup.Facade = function Mixer(mixer) {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct", arguments);
        this.configure = mixer.configure.bind(mixer);
        this.show = mixer.show.bind(mixer);
        this.hide = mixer.hide.bind(mixer);
        this.filter = mixer.filter.bind(mixer);
        this.toggleOn = mixer.toggleOn.bind(mixer);
        this.toggleOff = mixer.toggleOff.bind(mixer);
        this.sort = mixer.sort.bind(mixer);
        this.changeLayout = mixer.changeLayout.bind(mixer);
        this.multimix = mixer.multimix.bind(mixer);
        this.dataset = mixer.dataset.bind(mixer);
        this.tween = mixer.tween.bind(mixer);
        this.insert = mixer.insert.bind(mixer);
        this.insertBefore = mixer.insertBefore.bind(mixer);
        this.insertAfter = mixer.insertAfter.bind(mixer);
        this.prepend = mixer.prepend.bind(mixer);
        this.append = mixer.append.bind(mixer);
        this.remove = mixer.remove.bind(mixer);
        this.destroy = mixer.destroy.bind(mixer);
        this.forceRefresh = mixer.forceRefresh.bind(mixer);
        this.forceRender = mixer.forceRender.bind(mixer);
        this.isMixing = mixer.isMixing.bind(mixer);
        this.getOperation = mixer.getOperation.bind(mixer);
        this.getConfig = mixer.getConfig.bind(mixer);
        this.getState = mixer.getState.bind(mixer);
        this.callActions("afterConstruct", arguments);
        h.freeze(this);
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Facade);
    mixitup.Facade.prototype = Object.create(mixitup.Base.prototype);
    mixitup.Facade.prototype.constructor = mixitup.Facade;
    $e319239f91b7ae73$exports = mixitup;
    mixitup.BaseStatic.call(mixitup.constructor);
    mixitup.NAME = "mixitup";
    mixitup.CORE_VERSION = "3.3.1";
})(window);


document.addEventListener("DOMContentLoaded", function(event) {
    //Prevent scroll when menu is open
    document.querySelector("#menuToggle").addEventListener("click", function() {
        document.querySelector("body").classList.toggle("prevent-scroll");
        event.stopPropagation();
    });
    function removeClass(e) {
        const navContainer = document.querySelector(".nav-container");
        const path = e.path || e.composedPath && e.composedPath();
        if (path && !path.includes(navContainer)) document.querySelector("body").classList.remove("prevent-scroll");
    }
    document.addEventListener("click", removeClass);
    //decrease menu-size on scroll
    const menu = document.querySelector("#navbar");
    document.addEventListener("scroll", ()=>{
        // use document.documentElement for chrome, firefox, ie or opera
        // and document.body for safari since that's where overflow is set in those browsers
        if (document.documentElement.scrollTop > 0) menu.classList.add("menu--alt");
        else menu.classList.remove("menu--alt");
    });
    //MixItUp filtering on event page
    const mixContainer = document.getElementById("mixContainer");
    if (mixContainer) var mixer = $e319239f91b7ae73$exports(mixContainer, {
        controls: {
            toggleDefault: "all"
        }
    });
    //FormPreview AltText
    if (document.getElementById("SubmitEvent")) {
        //Save image in local storage to prevent content from dissapearing while moving to next step
        const sessionStorageEl = sessionStorage.getItem("imgData");
        if (sessionStorageEl) {
            const preview = document.getElementById("imagePreview");
            preview.setAttribute("src", sessionStorageEl);
        }
        const descSessionStorageEl = sessionStorage.getItem("descStorage");
        if (descSessionStorageEl) {
            const result = document.getElementById("description");
            result.textContent = descSessionStorageEl;
        }
        const titleSessionStorageEl = sessionStorage.getItem("titleStorage");
        if (titleSessionStorageEl) {
            const result = document.getElementById("eventTitle");
            result.textContent = titleSessionStorageEl;
        }
        const userAltTextEl = document.querySelector('input[data-alias="userAltText"]');
        if (userAltTextEl) {
            const result = document.getElementById("userAlt");
            result.textContent = userAltTextEl.value;
            userAltTextEl.addEventListener("change", (event)=>{
                let eventTarget = event.target;
                result.textContent = eventTarget.value;
            });
        }
        //render preview of event title
        const eventTitleEl = document.querySelector('input[data-alias="eventTitle"]');
        if (eventTitleEl) {
            const result = document.getElementById("eventTitle");
            result.textContent = eventTitleEl.value;
            eventTitleEl.addEventListener("keyup", (event)=>{
                let eventTarget = event.target;
                result.textContent = eventTarget.value;
            });
            eventTitleEl.addEventListener("change", (event)=>{
                sessionStorage.setItem("titleStorage", result.textContent);
                console.log("local", sessionStorage);
            });
        }
        //Render preview of event description
        const userDescriptionEl = document.querySelector('textarea[data-alias="userDescription"]');
        console.log("test1", userDescriptionEl);
        if (userDescriptionEl) {
            const result = document.getElementById("description");
            result.textContent = userDescriptionEl.value;
            userDescriptionEl.addEventListener("keyup", (event)=>{
                let eventTarget = event.target;
                result.textContent = eventTarget.value;
            });
            userDescriptionEl.addEventListener("change", (event)=>{
                sessionStorage.setItem("descStorage", result.textContent);
                console.log("local", sessionStorage);
            });
        }
        //Render preview image from fileupload
        const eventImageEl = document.querySelector('input[data-alias="formEventImage"]');
        const previewPhoto = ()=>{
            console.log("input", eventImageEl);
            console.log("input value", eventImageEl.value);
            console.log("input value2", eventImageEl.value.split("\\").pop().split("/").pop());
            document.getElementById("fileNameInput").textContent = eventImageEl.value.split("\\").pop().split("/").pop();
            var red = document.getElementById("inputImageDiv");
            red.style.display = "block";
            const file = eventImageEl.files;
            if (file) {
                const fileReader = new FileReader();
                const preview = document.getElementById("imagePreview");
                console.log("bild", preview);
                let eventTarget = event.target;
                fileReader.onload = function(event) {
                    var _event_target, _event_target1;
                    preview.setAttribute("src", (_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.result);
                    sessionStorage.setItem("imgData", (_event_target1 = event.target) === null || _event_target1 === void 0 ? void 0 : _event_target1.result);
                };
                fileReader.readAsDataURL(file[0]);
            }
        };
        if (eventImageEl) {
            eventImageEl.addEventListener("change", previewPhoto);
            eventImageEl.addEventListener("click", (event)=>{
                sessionStorage.removeItem(sessionStorageEl);
            });
        }
        const submitButton = document.getElementById("eventLastSubmit");
        if (submitButton) submitButton.addEventListener("click", ()=>{
            sessionStorage.clear();
        });
    }
    //Indicate which form-page the user is on
    const descEl = document.getElementById("3413a96f-8680-4048-81d8-e329e025d5d2");
    const descClassEl = document.getElementById("liDescription");
    if (descEl != null) descClassEl.classList.add("active-li");
    const addressEl = document.getElementById("8fcd6540-a029-435b-94f1-a338a7af2862");
    const placeClassEl = document.getElementById("liPlace");
    if (addressEl != null) placeClassEl.classList.add("active-li");
    const contactEl = document.getElementById("44b437e0-bfcc-4327-f616-225976bc6bdf");
    const contactClassEl = document.getElementById("liContact");
    const contactPersonEl = document.getElementById("personalInfo");
    if (contactEl != null) {
        contactClassEl.classList.add("active-li");
        contactPersonEl.classList.add("display-info");
    }
});


//# sourceMappingURL=main.js.map
